webpackJsonp([4],{

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Dme":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);



var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+QeK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.currentUser.avatar_url}})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.toggleMenu}},[_c('span',[_vm._v("\n           "+_vm._s(_vm.firstName())+"\n           "),_c('b',{staticClass:"caret"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isClosed),expression:"!isClosed"}],staticClass:"nav"},[_c('li',[_c('router-link',{attrs:{"to":"/editar-perfil","tag":"li"}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-normal"},[_vm._v("Editar Perfil")])])])],1),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.logoutUser()}}},[_c('span',{staticClass:"sidebar-normal"},[_vm._v("Sair")])])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+RZ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+SEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        name: '',
        email: '',
        company: '',
        message: ''
      },
      response: {
        message: '',
        error: false
      },
      loading: false
    };
  },

  methods: {
    validForm: function validForm() {
      if (!!this.form.name && !!this.form.email && !!this.form.company) {
        this.sendForm();
      } else {
        this.setResponse('Todo os campos (*) são obrigatórios.', true);
      }
    },
    sendForm: function sendForm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = '/support/contact';

                _this.loading = true;
                _context.next = 4;
                return axios.post(url, _this.form).then(function (res) {
                  _this.setResponse(res.data.message);
                  _this.form = {
                    name: '',
                    email: '',
                    company: '',
                    message: ''
                  };
                }).catch(function (err) {
                  var message = 'Não foi possível enviar sua mensagem, tente novamente mais tarde.';
                  if (err.response.status !== 500) {
                    message = res.response.data.message;
                  }
                  _this.setResponse(message, true);
                });

              case 4:
                _this.loading = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setResponse: function setResponse(message) {
      var _this2 = this;

      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.response.message = message;
      this.response.error = error;

      if (this.response.message) {
        setTimeout(function () {
          _this2.setResponse(null);
        }, 5000);
      }
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "/JCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs__);
















__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse_item___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    collaboratorId: [Number]
  },
  data: function data() {
    return {
      evaluations: [],
      loading: false
    };
  },

  components: {
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */]
  },
  methods: {
    getEvaluations: function getEvaluations() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = '/collaborator/manager/collaborator/' + _this.collaboratorId + '/evaluations';

                _this.loading = true;
                _context.next = 4;
                return axios.get(url).then(function (response) {
                  _this.evaluations = response.data;
                }).catch(function (error) {
                  console.log(error);
                });

              case 4:
                _this.loading = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toEvaluate: function toEvaluate(evaluation) {
      var _this2 = this;

      var evaluationId = evaluation.id;
      __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
        title: 'Você tem certeza!',
        text: 'Você iniciará avaliação agora.',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'OK',
        buttonsStyling: false,
        preConfirm: function preConfirm(res) {
          return _this2.verifyAccess(evaluationId).catch(function (error) {
            var message = 'Não foi possível completar a requisição, tente novamente mais tarde.';
            if (error.response.status !== 500) {
              message = error.response.data.error;
            }

            __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.showValidationError(message);

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              reject(new Error(message));
            });
          });
        }
      }).then(function (res) {
        _this2.execEvaluation(evaluationId, res.data);
      });
    },
    verifyAccess: function verifyAccess(evaluationId) {
      return axios.post('/collaborator/manager/verify-access-evaluation', {
        evaluation_id: evaluationId
      });
    },
    execEvaluation: function execEvaluation(evaluationId, dataAccess) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
        title: 'Acesso Liberado!',
        html: 'Link de validação gerado. <br/> <small>Você tem 72 horas para realizar avaliação com o link gerado.</small>',
        type: 'success',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Acessar Avaliação',
        buttonsStyling: false,
        preConfirm: function preConfirm() {
          if (dataAccess.access_token) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve(dataAccess);
            });
          }

          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            reject(new Error('Token não pode ser encontrado.'));
          });
        }
      }).then(function (res) {
        _this3.$router.push('/avaliacao/formulario/' + _this3.collaboratorId + '/' + evaluationId + '/' + res.access_token);
      }).catch(__WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.noop);
    },
    openOverview: function openOverview(evaluationId) {
      this.$router.push('/avaliacao/equipe/perfil/' + this.collaboratorId + '/resultado-completo/' + evaluationId);
    },
    openSetPlan: function openSetPlan(evaluationId) {
      this.$router.push('/avaliacao/formulario-resultado/' + evaluationId + '/' + this.collaboratorId);
    },
    percentColor: function percentColor(percent) {
      var classColor = 'success';

      if (percent >= 0 && percent < 40) {
        classColor = 'danger';
      } else if (percent >= 40 && percent < 80) {
        classColor = 'warning';
      }
      return classColor;
    },
    percentTotalColor: function percentTotalColor(percent) {
      var color = 'green';

      if (percent >= 0 && percent < 40) {
        color = 'red';
      }

      if (percent >= 40 && percent < 80) {
        color = 'orange';
      }

      return color;
    },
    evaluationEdit: function evaluationEdit(evaluationId) {
      this.$router.push('/avaliacao/formulario-editar/' + evaluationId + '/' + this.collaboratorId);
    }
  },
  watch: {
    collaboratorId: function collaboratorId() {
      this.getEvaluations();
    }
  }
});

/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "1Kqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "2BWB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Pzx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13fde254_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("vIxs");
function injectStyle (ssrContext) {
  __webpack_require__("RAFT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13fde254_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2jgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{attrs:{"id":"contentImage"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2rGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "36l/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Dyy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3MeN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("2rGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__("nu7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);








__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.directive);
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "3Nt+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3ukO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "49yH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Support_vue__ = __webpack_require__("+SEL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6721b2bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Support_vue__ = __webpack_require__("7C6X");
function injectStyle (ssrContext) {
  __webpack_require__("EvZG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Support_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6721b2bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4qt1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__ = __webpack_require__("negu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de64e9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__ = __webpack_require__("azot");
function injectStyle (ssrContext) {
  __webpack_require__("A+TZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de64e9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fdc3d6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("FHYG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fdc3d6d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Hee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5"},[_c('collaborator-card',{attrs:{"collaborator":_vm.collaborator}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-7"},[_c('evaluation-card',{attrs:{"collaboratorId":_vm.collaboratorId}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-sm-12",staticStyle:{"text-align":"center","margin":"20px 0"}},[_c('router-link',{attrs:{"to":"/avaliacao/equipe"}},[_c('button',{staticClass:"btn btn-wd btn-default btn-move-left",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v("\n          Voltar\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Qkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5snn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.collaboratorId = this.$route.params.collaboratorId;
    this.evaluationId = this.$route.params.evaluationId;
    this.token = this.$route.params.token;
    this.getCollaborator();
  },
  data: function data() {
    return {
      token: null,
      evaluation: {},
      loading: true,
      evaluationAnswers: [],
      evaluationDeliveryAnswer: '',
      evaluationOpenAnswer: ''
    };
  },

  methods: {
    getCollaborator: function getCollaborator() {
      var _this = this;

      var url = '/collaborator/manager/collaborator-evaluation';
      axios.post(url, { token: this.token }).then(function (response) {
        _this.evaluation = response.data;
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
        if (error.response.status === 500) {
          _this.setError('Error inesperado, tente novamente mais tarde.');
        } else {
          _this.setError(error.response.data.error);
        }
      });
    },
    setError: function setError(message) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Avaliação!',
        text: message,
        type: 'warning',
        showCancelButton: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        confirmButtonText: 'Voltar',
        buttonsStyling: false,
        allowOutsideClick: false,
        preConfirm: function preConfirm() {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            resolve('OK');
          });
        }
      }).then(function () {
        _this2.$router.push('/avaliacao/equipe');
      });
    },
    setEvaluationAnswer: function setEvaluationAnswer(answer) {
      var answers = this.evaluationAnswers.filter(function (element) {
        if (element.skillId === answer.skillId) {
          return false;
        } else {
          return true;
        }
      });

      answers.push(answer);

      this.evaluationAnswers = answers;
    },
    setEvaluationDeliveryAnswer: function setEvaluationDeliveryAnswer(answer) {
      this.evaluationDeliveryAnswer = answer.answerValue;
    },
    validEvaluation: function validEvaluation() {
      var _this3 = this;

      var countSkills = this.evaluation.collaborator.skills.length;

      var selfAssignmentFlag = this.evaluation.evaluation_type_id === 3 ? !!this.evaluationOpenAnswer : true;

      if (this.evaluationAnswers.length === countSkills && !!this.evaluationDeliveryAnswer && selfAssignmentFlag) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          title: 'Você tem certeza!',
          html: 'Avaliação será Concluída.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Enviar Avaliação',
          buttonsStyling: false,
          preConfirm: function preConfirm() {
            return _this3.sendEvaluationAnswer().catch(function (error) {
              var message = 'Não foi possível completar a requisição, tente novamente mais tarde.';
              if (error.response.status !== 500) {
                message = error.response.data.error;
              }
              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.showValidationError(message);
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(message));
            });
          }
        }).then(function () {
          var redirectMessage = '';
          if (_this3.evaluation.evaluation_type_id === 1) {
            redirectMessage = 'você será redirecionado para o <b>Plano de Ação</b>';
          } else if (_this3.evaluation.evaluation_type_id === 3) {
            redirectMessage = 'você será redirecionado para a página de <b>Minhas Avaliações</b>';
          } else {
            redirectMessage = 'o processo será concluído';
          }

          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            title: 'Avaliação Concluída!',
            html: 'Avalia\xE7\xE3o do colaborador foi realizada com sucesso. <br> <small>' + redirectMessage + '</small>',
            type: 'success',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'OK',
            buttonsStyling: false,
            allowOutsideClick: false,
            preConfirm: function preConfirm() {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve('OK');
            }
          }).then(function () {
            if (_this3.evaluation.evaluation_type_id === 1) {
              _this3.$router.push('/avaliacao/formulario-resultado/' + _this3.evaluation.id + '/' + _this3.collaboratorId);
            } else if (_this3.evaluation.evaluation_type_id === 3) {
              _this3.$router.push('/avaliacao/listar');
            }
          });
        }).catch(__WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.noop);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          title: 'Atenção!',
          text: 'Você não finalizou a avaliação. Responda todas as competências!',
          type: 'warning',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this3.scrollWinTop();
        });
      }
    },
    sendEvaluationAnswer: function sendEvaluationAnswer() {
      var url = '/collaborator/manager/collaborator-evaluation-answer';
      return axios.post(url, { token: this.token, evaluationAnswers: this.evaluationAnswers, evaluationDeliveryAnswer: this.evaluationDeliveryAnswer, evaluationOpenAnswer: this.evaluationOpenAnswer });
    },
    scrollWinTop: function scrollWinTop() {
      $('.main-panel').scrollTop(250, 0);
    },
    handleClose: function handleClose(tag) {
      this.tags.dynamicTags.splice(this.tags.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this4 = this;

      this.tags.inputVisible = true;
      this.$nextTick(function () {
        _this4.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.tags.inputValue;
      if (inputValue) {
        this.tags.dynamicTags.push(inputValue);
      }
      this.tags.inputVisible = false;
      this.tags.inputValue = '';
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  }
});

/***/ }),

/***/ "6H4O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'evaluation-delivery-answer',
  props: {
    answerEdit: [Number],
    label: [String, Number],
    disabled: [Boolean, String],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      answer: this.answerEdit,
      cbId: '',
      rId1: '',
      rId2: '',
      rId3: '',
      rId4: '',
      rId5: ''
    };
  },

  computed: {
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
    this.rId1 = Math.random().toString(16).slice(2);
    this.rId2 = Math.random().toString(16).slice(2);
    this.rId3 = Math.random().toString(16).slice(2);
    this.rId4 = Math.random().toString(16).slice(2);
    this.rId5 = Math.random().toString(16).slice(2);
  },

  watch: {
    answer: function answer(val) {
      var data = {
        answerValue: val
      };
      this.$emit('setEvaluationDeliveryAnswer', data);
    }
  }
});

/***/ }),

/***/ "6KnM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollaboratorCard_vue__ = __webpack_require__("YU9/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a709198_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollaboratorCard_vue__ = __webpack_require__("smGu");
function injectStyle (ssrContext) {
  __webpack_require__("3Nt+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollaboratorCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a709198_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollaboratorCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6V8M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6qw8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7C6X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle navbar-toggle-black",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/login"}},[_vm._v("\n              Quero Entrar\n            ")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validForm()}}},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"p_form"},[_vm._v("Caso você ainda tenha alguma dúvida preencha o formulário abaixo e entraremos em contato o mais breve possível.")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"100","placeholder":"Digite seu Nome*"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-control",attrs:{"type":"email","maxlength":"65","placeholder":"Digite seu E-mail*","required":""},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.company),expression:"form.company"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"45","placeholder":"Digite sua Empresa*"},domProps:{"value":(_vm.form.company)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "company", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.message),expression:"form.message"}],staticClass:"form-control",attrs:{"placeholder":"Qual a sua dúvida?","rows":"3"},domProps:{"value":(_vm.form.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "message", $event.target.value)}}})]),_vm._v(" "),(!!_vm.response.message)?_c('div',{staticClass:"text-center",class:{'text-success': !_vm.response.error, 'text-danger': _vm.response.error },staticStyle:{"margin-bottom":"10px"}},[_vm._v("\n                      "+_vm._s(_vm.response.message)+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-wd ",attrs:{"type":"submit"}},[_c('loading-spin',{staticClass:"loading-spin-login",attrs:{"check":_vm.loading}}),_vm._v(" Enviar")],1)])])])])])])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Quero Entrar\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('h2',[_c('img',{staticClass:"logo_ad_r",attrs:{"src":"static/img/logo.png","alt":"Avaliação de Desempenho"}})]),_vm._v(" "),_c('h4',[_vm._v("Nunca foi tão fácil realizar e solicitar uma avaliação de desempenho na Brasal.")]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-danger"},[_c('i',{staticClass:"ti ti-user"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Colaborador e Gestor")]),_vm._v("\n                  A partir de agora as avaliações de desempenho só podem ser realizadas consensualmente com seu gestor imediato.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-warning"},[_c('i',{staticClass:"ti-reload"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Feedbacks Aleatórios")]),_vm._v("\n                  Você pode solicitar 2 avaliações de desempenho por ano, além da avaliação realizada normalmente em cada ciclo.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-info"},[_c('i',{staticClass:"ti-thumb-up"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Competências")]),_vm._v("\n                  O colaborador tem mais clareza sobre quais são as competências em que ele está sendo avaliado pelo gestor.\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_c('a',{attrs:{"href":"https://www.brasal.com.br","target":"_blank"}},[_c('img',{staticClass:"logo_brasal",attrs:{"src":"static/img/logo_brasal_c.png","alt":"Brasal"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7CgR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = login;
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocalUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general__ = __webpack_require__("Y3o5");




function login(credentials) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (res, rej) {
    axios.post('/auth/login', credentials).then(function (response) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__general__["b" /* setAuthorization */])(response.data.access_token);
      res(response.data);
    }).catch(function (err) {
      var message = 'Desculpe, algo deu errado. Tente novamente mais tarde.';
      if (err.response.status !== 500) {
        message = err.response.data.error;
      }
      rej(message);
    });
  });
}

function getLocalUser() {
  var userStr = localStorage.getItem("user");

  if (!userStr) {
    return null;
  }

  return JSON.parse(userStr);
}

/***/ }),

/***/ "7zM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Position_vue__ = __webpack_require__("ag0+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22607c74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Position_vue__ = __webpack_require__("rsHq");
function injectStyle (ssrContext) {
  __webpack_require__("+RZ7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Position_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22607c74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Position_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "87ks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extended-forms"},[(_vm.loading)?_c('div',{staticClass:"view-block"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.evaluation.evaluation_type_id == 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h5',{staticClass:"title_h5"},[_vm._v("Gestor Imediato")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center desc_member"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-2"},[_c('div',{staticClass:"avatar img_member"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":_vm.currentUser.avatar_url,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('div',{staticClass:"pull-left name_member"},[_c('span',[_vm._v("\n                  "+_vm._s(_vm.currentUser.name)+"\n                ")]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.currentUser.position.functional_classification.name))])])])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h5',{staticClass:"title_h5"},[_vm._v("Colaborador")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center desc_member"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-2"},[_c('div',{staticClass:"avatar img_member"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":_vm.evaluation.collaborator.avatar_url,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('div',{staticClass:"pull-left name_member"},[_c('span',[_vm._v("\n                  "+_vm._s(_vm.evaluation.collaborator.name)+"\n                ")]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.evaluation.collaborator.position.name))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card card-av-desempenho"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("COMPETÊNCIAS")]),_vm._v(" "),_vm._l((_vm.evaluation.collaborator.skills),function(skill,index){return _c('div',{key:("skill-" + index),staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',[_c('b',[_vm._v(_vm._s(skill.name))]),_c('br'),_c('br'),_c('small',[_vm._v(_vm._s(skill.description))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('evaluation-answer',{attrs:{"evaluationWeight":_vm.evaluation.evaluation_weight,"skillId":skill.id},on:{"setEvaluationAnswer":_vm.setEvaluationAnswer}})],1)])])])})],2)]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"card card-av-desempenho"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("Entrega")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('evaluation-delivery-answer',{on:{"setEvaluationDeliveryAnswer":_vm.setEvaluationDeliveryAnswer}})],1)])])])])]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),(_vm.evaluation.evaluation_type_id == 3)?_c('div',{staticClass:"card card-av-desempenho"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("Sua opinião")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.evaluationOpenAnswer),expression:"evaluationOpenAnswer"}],staticClass:"form-control",attrs:{"rows":"6","placeholder":"Escreva sua opinião aqui..."},domProps:{"value":(_vm.evaluationOpenAnswer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.evaluationOpenAnswer=$event.target.value}}})])])])])])]),_vm._v(" "),_c('br'),_c('br')])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('button',{staticClass:"btn btn-wd btn-success btn-fill btn-rotate bt-end",attrs:{"type":"button"},on:{"click":function($event){return _vm.validEvaluation()}}},[_vm._m(3),_vm._v("\n             Concluir Avaliação\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v("Avaliar segundo a realidade atual (o desempenho das entregas realizadas) e não pela situação esperada (o potencial demonstrado). A avaliação só terá valor se as respostas refletirem as verdadeiras práticas e a performance apresentada pelo colaborador ao longo do último ano. ​Trata-se de uma “fotografia” das entregas em geral, considerando o que normalmente acontece. Ou seja, deve refletir a maioria das entregas e trabalhos resultados e não o “destaque de um único trabalho).​"),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v("Deixe aqui sua mensagem sobre o seu desempenho durante este ciclo.​"),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-save"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8mNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ooc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormResult_vue__ = __webpack_require__("NKe7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ec8bca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormResult_vue__ = __webpack_require__("BcEL");
function injectStyle (ssrContext) {
  __webpack_require__("oAPB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36ec8bca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ec8bca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8pqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("elQm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08bef15e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("EWNQ");
function injectStyle (ssrContext) {
  __webpack_require__("wQ02")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08bef15e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9597":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__ = __webpack_require__("E0D1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc05f5b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__ = __webpack_require__("qFR4");
function injectStyle (ssrContext) {
  __webpack_require__("a9Ek")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc05f5b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9G8F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9HkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_auth__ = __webpack_require__("7CgR");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      form: {
        username: '',
        password: ''
      },
      loading: false,
      error: null
    };
  },

  methods: {
    authenticate: function authenticate() {
      var _this = this;

      this.$store.dispatch('login');
      this.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_auth__["b" /* login */])(this.$data.form).then(function (res) {
        _this.loading = false;
        _this.$store.commit('loginSuccess', res);
        _this.$router.push({ path: '/' });
        _this.resetForm();
      }).catch(function (error) {
        _this.loading = false;
        _this.resetForm();
        _this.$store.commit('loginFailed', { error: error });
      });
    },
    resetForm: function resetForm() {
      this.form.username = '';
      this.form.password = '';
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  computed: {
    authError: function authError() {
      return this.$store.getters.authError;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "9OU8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9WBg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId1,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"1"},domProps:{"checked":_vm._q(_vm.answer,"1")},on:{"change":function($event){_vm.answer="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId1}},[_c('div',{staticClass:"escala1"},[_vm._v("1")]),_vm._v(" Abaixo do esperado (0 a 50%): Normalmente suas entregas são "),_c('b',[_vm._v("fora")]),_vm._v(" do prazo estipulado, "),_c('b',[_vm._v("incompletas/inacabadas")]),_vm._v(" e "),_c('b',[_vm._v("abaixo")]),_vm._v(" dos padrões de qualidade.\n      ")])]),_vm._v(" "),_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId2,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"2"},domProps:{"checked":_vm._q(_vm.answer,"2")},on:{"change":function($event){_vm.answer="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId2}},[_c('div',{staticClass:"escala2"},[_vm._v("2")]),_vm._v(" Em desenvolvimento (51 a 79%): Normalmente suas entregas são "),_c('b',[_vm._v("pacialmente satisfatórias")]),_vm._v(" e "),_c('b',[_vm._v("oscilam")]),_vm._v(" entre estarem incompletas/inacabadas, fora do prazo, conforme os padroes de qualidade​.\n      ")])]),_vm._v(" "),_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId3,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"3"},domProps:{"checked":_vm._q(_vm.answer,"3")},on:{"change":function($event){_vm.answer="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId3}},[_c('div',{staticClass:"escala3"},[_vm._v("3")]),_vm._v(" Dentro do esperado (80 a 100%): Normalmente suas entregas são "),_c('b',[_vm._v("dentro")]),_vm._v(" do prazo, "),_c('b',[_vm._v("conforme")]),_vm._v(" os padrões de qualidade, "),_c('b',[_vm._v("completas")]),_vm._v(" e "),_c('b',[_vm._v("acabadas")]),_vm._v(".​\n      ")])]),_vm._v(" "),_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId4,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"4"},domProps:{"checked":_vm._q(_vm.answer,"4")},on:{"change":function($event){_vm.answer="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId4}},[_c('div',{staticClass:"escala4"},[_vm._v("4")]),_vm._v(" Acima do esperado (101 a 120%): Normalmente suas entregas "),_c('b',[_vm._v("superam")]),_vm._v(", sao antes do prazo estabelecido, com qualidade excepcional, completa e acabada, "),_c('b',[_vm._v("viabilizando novas alternativas e evolução")]),_vm._v(".\n      ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9gNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__("rP9/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49867f85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__("S4NR");
function injectStyle (ssrContext) {
  __webpack_require__("f+Jq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49867f85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A+TZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A3tr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ADJj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BKfn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BNE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("aCDv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8fe55de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("3ukO");
function injectStyle (ssrContext) {
  __webpack_require__("3Dyy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8fe55de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BcEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resultEvaluation)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h5',{staticClass:"title_h5"},[_vm._v("Gestor Imediato")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content desc_member"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-xs-4"},[_c('div',{staticClass:"avatar img_member"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":_vm.currentUser.avatar_url,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-xs-8"},[_c('div',{staticClass:"pull-left name_member"},[_c('span',[_vm._v("\n                  "+_vm._s(_vm.currentUser.name)+"\n                ")]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.currentUser.position.functional_classification.name))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h5',{staticClass:"title_h5"},[_vm._v("Colaborador")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content desc_member"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-xs-4"},[_c('div',{staticClass:"avatar img_member"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":_vm.resultEvaluation.collaborator.avatar_url,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-xs-8"},[_c('div',{staticClass:"pull-left name_member"},[_c('span',[_vm._v("\n                  "+_vm._s(_vm.resultEvaluation.collaborator.name)+"\n                ")]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.position.name))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.resultEvaluation.collaborator.phone)?_c('a',{staticClass:"whatsapp-collaborator",attrs:{"href":_vm.whatsappGenerateLink(_vm.resultEvaluation.collaborator.phone),"target":"_blank"}},[_c('i',{staticClass:"fa fa-whatsapp"}),_vm._v(" "),_c('span',[_vm._v("Vídeo chamada")])]):_vm._e()])])])])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"card card-competencias"},[_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('circle-chart-card',{attrs:{"percentage":_vm.resultEvaluation.final_result,"title":"RESULTADO FINAL","description":_vm.resultEvaluation.evaluation_type_name,"color":_vm.percentTotalColor(_vm.resultEvaluation.final_result)}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":_vm.resultEvaluation.total_skill_percent,"title":"COMPETÊNCIAS","color":_vm.percentTotalColor(_vm.resultEvaluation.total_skill_percent)}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":_vm.resultEvaluation.delivery_percent,"title":"ENTREGA","color":_vm.percentTotalColor(_vm.resultEvaluation.delivery_percent)}})],1)])])])])]),_vm._v(" "),_c('info-pdi-9box',{attrs:{"resultEvaluation":_vm.resultEvaluation}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-12"},[_c('el-select',{staticClass:"select-default",attrs:{"multiple":"","size":"large","placeholder":"Selecione..."},model:{value:(_vm.developmentPlan.skill_ids),callback:function ($$v) {_vm.$set(_vm.developmentPlan, "skill_ids", $$v)},expression:"developmentPlan.skill_ids"}},_vm._l((_vm.resultEvaluation.collaborator.skills),function(skill){return _c('el-option',{key:skill.id,attrs:{"value":skill.id,"label":skill.name}})}),1)],1)]),_vm._v(" "),_c('br')])])])]),_vm._v(" "),(_vm.skillView.id)?_c('div',{staticClass:"row"},[_vm._v("\n    "+_vm._s(_vm.skillView)+"\n    "),_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",class:("icon-" + (_vm.percentColor(_vm.skillView.percent))),attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-package"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"category"},[_vm._v("COMPETÊNCIA")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-10 comp"},[_vm._v("\n              "+_vm._s(_vm.skillView.name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 grade_comp"},[_vm._v("\n              "+_vm._s(_vm.skillView.percent)+"%\n            ")])]),_vm._v(" "),_c('p-progress',{attrs:{"value":_vm.skillView.percent,"type":_vm.percentColor(_vm.skillView.percent)}})],1)])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-content"},[(!!_vm.developmentPlanSelected.description)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"13px"}},[_c('blockquote',{staticStyle:{"font-style":"normal","font-size":"14px"}},[_vm._v("\n                "+_vm._s(_vm.developmentPlanSelected.description)+"\n              ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Data de Início*")]),_vm._v(" "),_c('div',[_c('el-date-picker',{attrs:{"format":"dd/MM/yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Selecione a data","picker-options":_vm.pickerOptionsStart},on:{"change":_vm.clearAllDates},model:{value:(_vm.developmentPlan.start_date),callback:function ($$v) {_vm.$set(_vm.developmentPlan, "start_date", $$v)},expression:"developmentPlan.start_date"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Data de Término*")]),_vm._v(" "),_c('div',[_c('el-date-picker',{attrs:{"format":"dd/MM/yyyy","value-format":"yyyy-MM-dd","disabled":!_vm.developmentPlan.start_date,"type":"date","placeholder":"Selecione a data","picker-options":_vm.pickerOptionsEnd},on:{"change":_vm.clearAllDates},model:{value:(_vm.developmentPlan.end_date),callback:function ($$v) {_vm.$set(_vm.developmentPlan, "end_date", $$v)},expression:"developmentPlan.end_date"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Objetivo do Plano de Ação*")]),_c('i',{staticClass:"fa fa-info-circle",attrs:{"rel":"tooltip","title":"Descreva brevemente o objetivo principal deste plano de ação. O objetivo deve ser claro e específico, focando em uma área de desenvolvimento que será trabalhada ao longo do período definido.","aria-hidden":"true"}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.developmentPlan.action_plan_objective),expression:"developmentPlan.action_plan_objective"}],staticClass:"form-control",attrs:{"placeholder":"Ex.: Aprimorar habilidades de análise de dados para otimizar os processos da área; Desenvolver competências de liderança para coordenar uma equipe no próximo ano.","rows":"3","maxlength":"2000"},domProps:{"value":(_vm.developmentPlan.action_plan_objective)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.developmentPlan, "action_plan_objective", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Áreas de Melhoria Identificadas*")]),_c('i',{staticClass:"fa fa-info-circle",attrs:{"rel":"tooltip","title":"Enumere as habilidades técnicas e competências comportamentais específicas que precisam ser aprimoradas para alcançar as metas estabelecidas no plano de ação. Identifique quais competências são essenciais para o sucesso no desenvolvimento do colaborador.","aria-hidden":"true"}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.developmentPlan.identified_improvement_areas),expression:"developmentPlan.identified_improvement_areas"}],staticClass:"form-control",attrs:{"placeholder":"Ex.: Técnicas: Uso avançado do Excel, Gestão de Processos, Análise de Dados; Comportamentais: Comunicação eficaz, Gestão de Tempo, Resolução de Problemas.","rows":"3","maxlength":"2000"},domProps:{"value":(_vm.developmentPlan.identified_improvement_areas)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.developmentPlan, "identified_improvement_areas", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_vm._l((_vm.developmentPlan.action_plan_goals),function(goalItem,index){return _c('div',{key:index,staticClass:"well",staticStyle:{"padding":"15px","margin-bottom":"10px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Meta "+_vm._s(index + 1)+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(goalItem.goal),expression:"goalItem.goal"}],staticClass:"form-control",attrs:{"type":"text","placeholder":'Digite a meta ' + (index + 1),"maxlength":"200"},domProps:{"value":(goalItem.goal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(goalItem, "goal", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Prazo*")]),_vm._v(" "),_c('div',[_c('el-date-picker',{attrs:{"format":"dd/MM/yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Selecione a data","picker-options":_vm.pickerOptionsGoals,"disabled":!_vm.developmentPlan.start_date || !_vm.developmentPlan.end_date},model:{value:(goalItem.due_date),callback:function ($$v) {_vm.$set(goalItem, "due_date", $$v)},expression:"goalItem.due_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estratégias para alcançar essa meta*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(goalItem.strategy),expression:"goalItem.strategy"}],staticClass:"form-control",attrs:{"placeholder":"Ex.: Participação em cursos, feedbacks periódicos, envolvimento em projetos...","rows":"3","maxlength":"2000"},domProps:{"value":(goalItem.strategy)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(goalItem, "strategy", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","disabled":_vm.developmentPlan.action_plan_goals.length === 1},on:{"click":function($event){return _vm.removeGoal(index)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Remover\n                  ")])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"type":"button"},on:{"click":_vm.addGoal}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Adicionar Meta\n                ")])],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Indicadores de Sucesso*")]),_c('i',{staticClass:"fa fa-info-circle",attrs:{"rel":"tooltip","title":"Defina como o progresso e o sucesso serão medidos ao longo do plano de ação","aria-hidden":"true"}}),_vm._v(" "),_vm._l((_vm.successIndicators),function(indicator,index){return _c('div',{key:index},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.developmentPlan.success_indicators),expression:"developmentPlan.success_indicators"}],attrs:{"type":"checkbox","id":'success-indicator-checkbox-' + index},domProps:{"value":indicator.id,"checked":Array.isArray(_vm.developmentPlan.success_indicators)?_vm._i(_vm.developmentPlan.success_indicators,indicator.id)>-1:(_vm.developmentPlan.success_indicators)},on:{"change":function($event){var $$a=_vm.developmentPlan.success_indicators,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=indicator.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.developmentPlan, "success_indicators", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.developmentPlan, "success_indicators", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.developmentPlan, "success_indicators", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"non-bold-label",attrs:{"for":'success-indicator-checkbox-' + index}},[_vm._v(_vm._s(indicator.description))])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_vm._l((_vm.developmentPlan.monitoring_meetings),function(meeting,index){return _c('div',{key:index,staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('el-date-picker',{attrs:{"format":"dd/MM/yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Selecione a data","disabled":!_vm.developmentPlan.start_date || !_vm.developmentPlan.end_date,"picker-options":_vm.getMeetingDatePickerOptions(index)},model:{value:(_vm.developmentPlan.monitoring_meetings[index]),callback:function ($$v) {_vm.$set(_vm.developmentPlan.monitoring_meetings, index, $$v)},expression:"developmentPlan.monitoring_meetings[index]"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","disabled":_vm.developmentPlan.monitoring_meetings.length === 1},on:{"click":function($event){return _vm.removeMeetingDate(index)}}},[_c('i',{staticClass:"fa fa-trash"})])])],1)}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"type":"button","disabled":!_vm.canAddNewMeetingDate,"title":!_vm.canAddNewMeetingDate ? 'Não é possível adicionar mais reuniões dentro do intervalo atual' : ''},on:{"click":_vm.addMeetingDate}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Adicionar Data\n                ")]),_vm._v(" "),(_vm.noMeetingDateAvailable)?_c('span',{staticStyle:{"font-size":"12px","color":"gray","margin-left":"10px"}},[_vm._v("Não é possível adicionar mais reuniões dentro do intervalo atual.")]):_vm._e()],2)])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12 text-center"},[_c('button',{staticClass:"btn btn-success btn-fill btn-rotate bt-end",attrs:{"type":"button"},on:{"click":function($event){return _vm.validDevelopmentPlan()}}},[_vm._m(9),_vm._v("\n                Inserir Plano de Ação\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-fill btn-rotate bt-end",attrs:{"type":"button"},on:{"click":function($event){return _vm.evaluationEdit()}}},[_vm._m(10),_vm._v("\n                Editar Avaliação\n              ")])])])])])])])],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card card-competencias"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("Plano de Desenvolvimento Individual (PDI)")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_vm._v("\n              O Plano de Desenvolvimento Individual (PDI) é um método para estabelecer, acompanhar e desenvolver as\n              competências do seu colaborador. É um fator decisivo na evolução individual, servindo de guia prático\n              para desenvolver competências e habilidades.\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n              Com base no resultado da avaliação de desempenho você, juntamente, com o colaborador deverá especificar\n              a ação a ser tomada considerando prática, treinamento e feedback contínuo.\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n              É importante estabelecer o prazo de início e conclusão para cada ação.\n            ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("RESULTADO DA AVALIAÇÃO")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12"},[_vm._v("\n              Escolha as competências que você deseja incluir no Plano de Ação do colaborador.*"),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Plano de Ação")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Por favor, preencha o formulário de Plano de Ação Individual detalhando o objetivo\n            principal de desenvolvimento, as áreas de melhoria identificadas, as metas específicas, as estratégias\n            para alcançar essas metas, os indicadores de sucesso, a frequência de monitoramento e o tempo de execução\n            previsto,. Este plano será essencial para o crescimento professional do colaborador e alinhamento com os\n            objetivos da empresa.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"13px"}},[_c('br'),_vm._v("\n              Estime o tempo necessário para participar das atividades de desenvolvimento, incluindo treinamentos,\n              workshops e outras iniciativas. Defina claramente as datas de início e término. Tempo mínimo: 20 dias.\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"control-label"},[_vm._v("\n                  Metas do Plano de Ação*\n                  "),_c('i',{staticClass:"fa fa-info-circle",attrs:{"rel":"tooltip","title":"Defina metas alcançáveis e objetivos de desenvolvimento que sejam específicos, mensuráveis, atingíveis, relevantes e com prazo definido.","aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"13px"}},[_c('br'),_vm._v("\n              Defina reuniões periódicas de acompanhamento para monitorar e avaliar o desenvolvimento do colaborador. Cada reunião deve ter um intervalo de no mínimo 15 dias da data de início ou da última reunião. Você poderá alterar/definir novas datas depois.\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"control-label"},[_vm._v("\n                  Reuniões de Acompanhamento* \n                  "),_c('i',{staticClass:"fa fa-info-circle",attrs:{"rel":"tooltip","title":"Adicione uma ou mais datas para as reuniões de acompanhamento.","aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Atenção")]),_vm._v("\n          Após inserir o Plano de Ação a avaliação não pode ser editada.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-pencil-alt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-left"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BxWU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CBCL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cfke":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "D6Xl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row list-av-equipe"},[_c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"title"},[_vm._v("Minha Equipe "),_c('loading-spin',{attrs:{"check":_vm.loading}})],1),_vm._v(" "),_c('small',[_vm._v("Clique no colaborador para visualizar suas avaliações")]),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.collaborators),function(collaborator){return _c('div',{key:("collaborator-ev-" + (collaborator.id)),staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content desc_member"},[_c('div',{staticClass:"row text-center collaborator_open",on:{"click":function($event){return _vm.openCollaborator(collaborator.id)}}},[_c('div',{staticClass:"col-md-2 col-xs-4"},[_c('div',{staticClass:"avatar img_member"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":collaborator.avatar_url,"alt":"IMG COLAB"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xs-8"},[_c('div',{staticClass:"pull-left name_member"},[_c('span',[_vm._v("\n                    "+_vm._s(collaborator.name)+"\n                  ")]),_c('br'),_c('small',[_vm._v(_vm._s(collaborator.position.name))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('div',{staticClass:"pull-right"},[_c('span',{staticClass:"label btn-status",class:_vm.getClassLabel(collaborator.evaluation_status.label)},[_vm._v(_vm._s(collaborator.evaluation_status.name))])])])]),_vm._v(" "),(!!collaborator.plan_evaluation)?_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-md-12"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":("PLANO DE AÇÃO - " + (collaborator.plan_evaluation.cycle_year) + " | " + (_vm.translateStatus(collaborator.plan_evaluation.status))),"name":"1"}},[_c('div',{staticStyle:{"font-size":"14px"}},[_c('p',[_c('b',[_vm._v(_vm._s(collaborator.plan_evaluation.development_plan_name))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('i',{staticClass:"ti-calendar"}),_vm._v("  "),_c('b',[_vm._v("Data de Início: ")]),_c('span',{staticClass:"category"},[_vm._v(_vm._s(_vm._f("formatDateBr")(collaborator.plan_evaluation.start_date)))]),_c('br'),_vm._v(" "),_c('i',{staticClass:"ti-calendar"}),_vm._v("  "),_c('b',[_vm._v("Data de Término: ")]),_c('span',{staticClass:"category"},[_vm._v(_vm._s(_vm._f("formatDateBr")(collaborator.plan_evaluation.end_date)))]),_c('br'),_c('br'),_vm._v(" "),_c('i',{staticClass:"ti-ticket"}),_vm._v("  "),_c('b',[_vm._v("Competência: ")]),_c('br'),_vm._v(" "),_vm._l((collaborator.plan_evaluation.newSkills),function(skill){return _c('span',[_c('u',[_vm._v(_vm._s(skill.skill && skill.skill.name ? skill.skill.name : skill.name))]),_c('br'),_vm._v("\n                           "+_vm._s(skill.skill && skill.skill.description ? skill.skill.description : skill.description)),_c('br'),_c('br')])}),_vm._v(" "),(collaborator.plan_evaluation.description)?_c('div',[_c('i',{staticClass:"ti-clipboard"}),_vm._v("  "),_c('b',[_vm._v("Descrição: ")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"category",staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(collaborator.plan_evaluation.description)+" ")]),_c('br')]):_vm._e(),_vm._v(" "),(collaborator.plan_evaluation.action_plan_objective)?_c('div',[_c('i',{staticClass:"ti-star"}),_vm._v("  "),_c('b',[_vm._v("Objetivo: ")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"category",staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(collaborator.plan_evaluation.action_plan_objective)+" ")]),_c('br')]):_vm._e(),_vm._v(" "),(collaborator.plan_evaluation.identified_improvement_areas)?_c('div',[_c('i',{staticClass:"ti-bookmark"}),_vm._v("  "),_c('b',[_vm._v("Áreas de Melhoria: ")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"category",staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(collaborator.plan_evaluation.identified_improvement_areas)+" ")]),_c('br')]):_vm._e(),_vm._v(" "),(collaborator.plan_evaluation.action_plan_goals_old)?_c('div',[_c('i',{staticClass:"ti-check-box"}),_vm._v("  "),_c('b',[_vm._v("Metas: ")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"category",staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(collaborator.plan_evaluation.action_plan_goals_old)+" ")]),_c('br')]):(collaborator.plan_evaluation.action_plan_goals && collaborator.plan_evaluation.action_plan_goals.length != 0)?_c('div',[_c('i',{staticClass:"ti-check-box"}),_vm._v("  "),_c('b',[_vm._v("Metas:")]),_c('br'),_vm._v(" "),_vm._l((collaborator.plan_evaluation.action_plan_goals),function(goal,index){return _c('div',{key:goal.id,staticClass:"goal",staticStyle:{"margin-top":"10px","margin-bottom":"15px"}},[_c('div',{staticClass:"goal-title"},[_c('span',{staticClass:"dot"},[_vm._v("•")]),_vm._v(" "),_c('b',[_vm._v("Meta "+_vm._s(index + 1))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.translateStatus(goal.status)))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goal.progress)+"%")])]),_vm._v(" "),_c('div',{staticClass:"goal-body"},[_c('div',{staticClass:"progress",staticStyle:{"margin-bottom":"10px","height":"5px"}},[_c('div',{staticClass:"progress-bar",style:('width: ' + goal.progress + '%;'),attrs:{"role":"progressbar","aria-valuenow":goal.progress,"aria-valuemin":"0","aria-valuemax":"100"}})]),_vm._v(" "),_c('b',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(goal.goal)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Estratégia:")]),_vm._v(" "+_vm._s(goal.strategy)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Prazo:")]),_vm._v(" "+_vm._s(_vm.formatDate(goal.due_date))+"\n                            ")])])})],2):_vm._e(),_vm._v(" "),(collaborator.plan_evaluation.strategies_to_reach_goals_old)?_c('div',[_c('i',{staticClass:"ti-list"}),_vm._v("  "),_c('b',[_vm._v("Estratégias para Alcançar as Metas: ")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"category",staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(collaborator.plan_evaluation.strategies_to_reach_goals_old)+" ")]),_c('br')]):_vm._e(),_vm._v(" "),(collaborator.plan_evaluation.success_indicators && collaborator.plan_evaluation.success_indicators.length > 0)?_c('div',[_c('i',{staticClass:"ti-stats-up"}),_vm._v("  "),_c('b',[_vm._v("Indicadores de Sucesso:")]),_c('br'),_vm._v(" "),_vm._l((collaborator.plan_evaluation.success_indicators),function(successIndicator){return _c('div',[_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" - "+_vm._s(successIndicator.success_indicator.description)+" ")])])}),_c('br')],2):_vm._e(),_vm._v(" "),(collaborator.plan_evaluation.monitoring_meetings && collaborator.plan_evaluation.monitoring_meetings.length > 0)?_c('div',[_c('i',{staticClass:"ti-timer"}),_vm._v("  "),_c('b',[_vm._v("Acompanhamento:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v("\n                          Próxima reunião: "+_vm._s(_vm.formatNextMonitoring(collaborator.plan_evaluation.next_monitoring))+"\n                        ")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('i',{staticClass:"ti-agenda"}),_vm._v("  "),_c('b',[_vm._v("Histórico de Reuniões:")]),_c('br'),_vm._v(" "),(_vm.getPastMeetings(collaborator) && _vm.getPastMeetings(collaborator).length > 0)?_c('div',{staticClass:"carousel-wrapper"},[_c('button',{staticClass:"nav-button left",attrs:{"disabled":_vm.currentMeetingIndex(collaborator.id) === 0},on:{"click":function($event){return _vm.prevMeeting(collaborator)}}},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.slideDirectionByCollaborator[collaborator.id],"mode":"out-in"}},[_c('div',{key:(_vm.currentPastMeeting(collaborator) && _vm.currentPastMeeting(collaborator).id) || 'no-id',staticClass:"carousel-card"},[_c('b',[_vm._v("Data:")]),_vm._v(" "+_vm._s(_vm.currentPastMeeting(collaborator) ? _vm.formatDate(_vm.currentPastMeeting(collaborator).date) : '')),_c('br'),_vm._v(" "),(_vm.currentPastMeeting(collaborator) && _vm.currentPastMeeting(collaborator).status === 2)?_c('div',[_c('span',[_vm._v("Reunião não realizada.")])]):_c('div',[_vm._l((_vm.currentPastMeeting(collaborator).goal_progresses),function(goalProgress,index){return _c('div',[(goalProgress.progress_change && goalProgress.progress_change > 0)?_c('div',[_c('i',{staticClass:"ti-arrow-up"}),_vm._v(" "),_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"green"}},[_vm._v(" + "+_vm._s(goalProgress.progress_change)+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])]):(goalProgress.progress_change == 0)?_c('div',[_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',[_vm._v(" + "+_vm._s(goalProgress.progress_change)+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])]):_c('div',[_c('i',{staticClass:"ti-arrow-down"}),_vm._v(" "),_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" - "+_vm._s(goalProgress.progress_change * (-1))+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])])])}),_vm._v(" "),_c('b',[_vm._v("Feedbacks:")]),_vm._v(" "+_vm._s(_vm.currentPastMeeting(collaborator) && _vm.currentPastMeeting(collaborator).feedbacks ? _vm.currentPastMeeting(collaborator).feedbacks : 'Sem feedbacks')),_c('br')],2)])]),_vm._v(" "),_c('button',{staticClass:"nav-button right",attrs:{"disabled":_vm.currentMeetingIndex(collaborator.id) >= _vm.getPastMeetings(collaborator).length - 1},on:{"click":function($event){return _vm.nextMeeting(collaborator)}}},[_c('i',{staticClass:"ti-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"carousel-indicators"},_vm._l((_vm.getPastMeetings(collaborator)),function(meeting,index){return _c('span',{key:meeting.id,class:['indicator-dot', { active: index === _vm.currentMeetingIndex(collaborator.id) }],on:{"click":function($event){return _vm.goToMeeting(collaborator, index)}}})}),0)],1):_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v("\n                            As reuniões de acompanhamento realizadas aparecerão aqui.\n                          ")]),_c('br')])]):(collaborator.plan_evaluation.monitoring_frequencies.length > 0)?_c('div',[_c('i',{staticClass:"ti-timer"}),_vm._v("  "),_c('b',[_vm._v("Frequência de Monitoramento:")]),_c('br'),_vm._v(" "),_vm._l((collaborator.plan_evaluation.monitoring_frequencies),function(monitoringFrequency){return _c('div',[_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" - "+_vm._s(monitoringFrequency.monitoring_frequency.description)+" ")])])}),_c('br')],2):_vm._e()],2)])],1)],1)]):_vm._e()])])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DQiw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_vm._l((_vm.statsCards),function(stats,index){return _c('div',{key:("stats-" + index),staticClass:"col-lg-3 col-sm-6"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",class:("icon-" + (stats.type)),attrs:{"slot":"header"},slot:"header"},[_c('i',{class:stats.icon})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(stats.title))]),_vm._v("\n          "+_vm._s(stats.value)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 comp"},[_c('h4',{staticClass:"title"},[_vm._v(" "+_vm._s(stats.compGrade1))]),_vm._v("\n              "+_vm._s(stats.compText1)+"\n            ")])])])])],1)}),_vm._v(" "),(_vm.statsCards.length === 0)?_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",class:"icon-info",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-ticket"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"category"},[_vm._v("Sem avaliação")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 comp text-center"},[_c('h4',{staticClass:"title"},[_vm._v("Você não possuí códigos de verificação.")])])])])])],1):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DRfi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DaUO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E0D1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImageCropper__ = __webpack_require__("oMdY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_general__ = __webpack_require__("Y3o5");










/* harmony default export */ __webpack_exports__["a"] = ({
  directives: { mask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["mask"] },
  mounted: function mounted() {
    this.user.email = this.currentUser.email;
    this.user.phone = this.currentUser.phone;
  },
  data: function data() {
    return {
      user: {
        email: '',
        phone: '',
        avatar: null
      },
      tempAvatar: null,
      steps: {
        profile: true,
        cropimage: false
      },
      loading: false
    };
  },

  components: {
    ImageCropper: __WEBPACK_IMPORTED_MODULE_5__ImageCropper__["a" /* default */]
  },
  methods: {
    validForm: function validForm() {
      if (!!this.user.email && !!this.user.phone) {
        this.saveData();
      } else {
        this.setAlert('warning', 'Atenção!', 'Preencha todos os campos.');
      }
    },
    saveData: function saveData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user, avatar;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return _this.saveUser();

              case 3:
                user = _context.sent;

                if (!_this.user.avatar) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.saveAvatar();

              case 7:
                avatar = _context.sent;

                user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(user, avatar);

              case 9:

                _this.loading = false;

                if (user.hasOwnProperty('email') || user.hasOwnProperty('phone') || user.hasOwnProperty('avatar_url')) {
                  _this.updateDataStorage(user);
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    saveUser: function saveUser() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, user, dataUser;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = '/collaborator';
                user = _this2.user;
                dataUser = {};

                if (!(_this2.currentUser.email === user.email && _this2.currentUser.phone === user.phone)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return', dataUser);

              case 5:
                _context2.next = 7;
                return axios.put(url, user).then(function (response) {
                  dataUser = { 'email': user.email, 'phone': user.phone };
                  _this2.setAlert('success', 'Alterado!', response.data.message);
                }).catch(function (error) {
                  dataUser = { 'email': null, 'phone': null };
                  console.log(error);
                });

              case 7:
                return _context2.abrupt('return', dataUser);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    saveAvatar: function saveAvatar() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url, data, config, dataAvatar;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = '/collaborator/upload-avatar';
                data = new FormData();

                data.append('avatar', _this3.user.avatar);

                config = {
                  'Content-Type': 'multipart/form-data'
                };
                dataAvatar = {};
                _context3.next = 7;
                return axios.post(url, data, config).then(function (response) {
                  dataAvatar = { 'avatar_url': response.data.avatar_url };
                  _this3.setAlert('success', 'Alterado!', 'Imagem de perfil alterado com sucesso.');
                }).catch(function (error) {
                  dataAvatar = { 'avatar_url': null };
                  _this3.setAlert('warning', 'Atenção!', 'Não foi possível enviar sua imagem.');
                  console.log(error);
                });

              case 7:
                return _context3.abrupt('return', dataAvatar);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    updateDataStorage: function updateDataStorage(user) {
      var userStorage = this.currentUser;

      if (user.email) {
        userStorage.email = user.email;
      }

      if (user.phone) {
        userStorage.phone = user.phone;
      }

      if (user.avatar_url) {
        userStorage.avatar_url = user.avatar_url;
        this.cleanInputFile();
        this.tempAvatar = null;
      }

      this.$store.commit('alterUserData', userStorage);
    },
    openFile: function openFile() {
      $(this.$refs.avatar).trigger('click');
    },
    cleanInputFile: function cleanInputFile() {
      this.user.avatar = null;
      $(this.$refs.avatar).val(null);
    },
    onFileChange: function onFileChange() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var files, file;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                files = _this4.$refs.avatar.files;


                if (files.length > 0) {
                  file = files[0];


                  if (_this4.verifExtension(file)) {
                    _this4.resizeImage(file);
                  } else {
                    _this4.cleanInputFile();
                  }
                } else {
                  _this4.tempAvatar = null;
                }

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    verifExtension: function verifExtension(file) {
      var check = false;
      var fileTypes = ['image/png', 'image/jpeg'];

      if (fileTypes.indexOf(fileTypes.find(function (fileType) {
        return fileType === file.type;
      })) > -1) {
        check = true;
      } else {
        this.setAlert('warning', 'Atenção!', 'Arquivo selecionado não é permitido.');
      }

      return check;
    },
    resizeImage: function resizeImage(file) {
      var _this5 = this;

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (readerEvent) {
        var img = new Image();
        img.src = readerEvent.target.result;
        img.onload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
          var canvas, imageUrl;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this5.convertImageToCanvas(img, file);

                case 2:
                  canvas = _context5.sent;

                  _this5.handleStep('cropimage');_context5.next = 6;
                  return canvas.toDataURL('image/jpeg', 1);

                case 6:
                  imageUrl = _context5.sent;

                  _this5.$refs.imageCropper.render(imageUrl);
                case 8:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, _this5);
        }));
      };
    },
    convertImageToCanvas: function convertImageToCanvas(image, file) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _proportionalResize, width, height, canvas, context, orientation;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _proportionalResize = _this6.proportionalResize(image.width, image.height), width = _proportionalResize.width, height = _proportionalResize.height;
                canvas = document.createElement('canvas');
                context = canvas.getContext('2d');
                orientation = void 0;
                _context6.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_general__["d" /* readOrientation */])(file).then(function (res) {
                  orientation = res;
                });

              case 6:

                if ([6].includes(orientation)) {
                  canvas.width = height;
                  canvas.height = width;
                } else {
                  canvas.width = width;
                  canvas.height = height;
                }

                context.imageSmoothingEnabled = true;

                _context6.t0 = orientation;
                _context6.next = _context6.t0 === 2 ? 11 : _context6.t0 === 3 ? 13 : _context6.t0 === 4 ? 15 : _context6.t0 === 5 ? 17 : _context6.t0 === 6 ? 19 : _context6.t0 === 7 ? 21 : _context6.t0 === 8 ? 23 : 25;
                break;

              case 11:
                context.transform(-1, 0, 0, 1, width, 0);
                return _context6.abrupt('break', 27);

              case 13:
                context.transform(-1, 0, 0, -1, width, height);
                return _context6.abrupt('break', 27);

              case 15:
                context.transform(1, 0, 0, -1, 0, height);
                return _context6.abrupt('break', 27);

              case 17:
                context.transform(0, 1, 1, 0, 0, 0);
                return _context6.abrupt('break', 27);

              case 19:
                context.transform(0, 1, -1, 0, height, 0);
                return _context6.abrupt('break', 27);

              case 21:
                context.transform(0, -1, -1, 0, height, width);
                return _context6.abrupt('break', 27);

              case 23:
                context.transform(0, -1, 1, 0, 0, width);
                return _context6.abrupt('break', 27);

              case 25:
                context.transform(1, 0, 0, 1, 0, 0);
                return _context6.abrupt('break', 27);

              case 27:

                context.drawImage(image, 0, 0, width, height);
                context.beginPath();
                context.fill();

                return _context6.abrupt('return', canvas);

              case 31:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    cropImage: function cropImage() {
      this.$refs.imageCropper.cropImage();
    },
    setImage: function setImage(data) {
      var file = data.file,
          url = data.url;

      this.user.avatar = file;
      this.tempAvatar = url;
      this.handleStep('profile');
    },
    proportionalResize: function proportionalResize(width, height) {
      return {
        width: Math.round(480 * width / height),
        height: 480
      };
    },
    setAlert: function setAlert(type, title, text) {
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: title,
        text: text,
        type: type,
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      });
    },
    handleStep: function handleStep(step) {
      switch (step) {
        case 'profile':
          this.steps.profile = true;
          this.steps.cropimage = false;
          break;
        case 'cropimage':
          this.steps.cropimage = true;
          this.steps.profile = false;
          break;
      }
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  }
});

/***/ }),

/***/ "EWNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row list-avaliacoes"},[_c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"title"},[_vm._v("AVALIAÇÕES")]),_vm._v(" "),_c('small',[_vm._v("Veja abaixo as avaliações realizadas no ciclo de "+_vm._s(!!_vm.myDefaultEvaluationCycleYear ? _vm.myDefaultEvaluationCycleYear : _vm.cycleYear)+".")]),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.myDefaultEvaluationCycleYear),expression:"myDefaultEvaluationCycleYear"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.myDefaultEvaluationCycleYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Ciclo")]),_vm._v(" "),_vm._l((_vm.evaluationCycles),function(evaluationCycle){return _c('option',{key:("cycle-" + (evaluationCycle.id)),domProps:{"value":evaluationCycle.year}},[_vm._v(_vm._s(evaluationCycle.name))])})],2)])])])]),_vm._v(" "),_vm._l((_vm.myEvaluations),function(evaluation){return _c('div',{key:evaluation.id,staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"numbers pull-left date_evaluation"},[_c('span',[_c('b',[_vm._v(_vm._s(evaluation.cycle_name))]),_c('br'),_vm._v(_vm._s(_vm.evaluationTypeTranslate(evaluation.type))+"\n                  ")]),_c('br'),_c('small',[_vm._v(_vm._s(_vm._f("formatDate")(evaluation.start_date))+" a "+_vm._s(_vm._f("formatDate")(evaluation.end_date)))])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[(evaluation.type == 1)?_c('div',{staticClass:"pull-right"},[(!evaluation.status)?_c('span',{staticClass:"label label-warning",on:{"click":function($event){return _vm.evaluationInfo()}}},[_vm._v("\n                    PENDENTE\n                  ")]):_c('router-link',{attrs:{"to":("resultado/" + (evaluation.id))}},[_c('span',{staticClass:"label label-success"},[_vm._v("\n                      CONCLUÍDA\n                    ")])])],1):_vm._e(),_vm._v(" "),(evaluation.type == 3)?_c('div',{staticClass:"pull-right"},[(!evaluation.status)?_c('span',{staticClass:"label label-info",on:{"click":function($event){return _vm.toEvaluate(evaluation)}}},[_c('i',{staticClass:"ti-check"}),_vm._v(" AUTOAVALIAR\n                  ")]):_c('router-link',{attrs:{"to":("resultado/" + (evaluation.id))}},[_c('span',{staticClass:"label label-success"},[_vm._v("\n                      CONCLUÍDA\n                    ")])])],1):_vm._e()])])])])])}),_vm._v(" "),(_vm.myEvaluations.length == 0)?_c('div',{staticClass:"col-lg-12 col-md-12"},[_vm._m(0)]):_vm._e()],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('p',{staticClass:"category text-center"},[_vm._v("Sem avaliações")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ev6x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EvZG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F4OC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);









/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.getCollaborators();
  },
  data: function data() {
    return {
      loading: false,
      currentMeetingIndexByCollaborator: {},
      slideDirectionByCollaborator: {}
    };
  },

  filters: {
    formatDateBr: function formatDateBr(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('DD/MM/YYYY');
    }
  },
  methods: {
    getCollaborators: function getCollaborators() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return _this.$store.dispatch('getCollaborators').catch(function (error) {
                  console.log(error);
                });

              case 3:
                _this.loading = false;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openCollaborator: function openCollaborator(collaboratorId) {
      this.$router.push('/avaliacao/equipe/perfil/' + collaboratorId);
    },
    toEvaluate: function toEvaluate(evaluationId, collaboratorId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Você tem certeza!',
        text: 'Você iniciará avaliação agora.',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'OK',
        buttonsStyling: false,
        preConfirm: function preConfirm(res) {
          return _this2.verifyAccess(evaluationId).catch(function (error) {
            var message = 'Não foi possível completa requisição, tente novamente mais tarde.';
            if (error.response.status !== 500) {
              message = error.response.data.error;
            }

            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.showValidationError(message);

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              reject(new Error(message));
            });
          });
        }
      }).then(function (res) {
        _this2.execEvaluation(res.data, collaboratorId);
      });
    },
    verifyAccess: function verifyAccess(evaluationId) {
      return axios.post('/collaborator/manager/verify-access-evaluation-me', {
        evaluation_id: evaluationId
      });
    },
    execEvaluation: function execEvaluation(dataAccess, collaboratorId) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Acesso Liberado!',
        html: 'Link de validação gerado. <br/> <small>Você tem 72 horas para realizar avaliação.</small>',
        type: 'success',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Acessar Avaliação',
        buttonsStyling: false,
        preConfirm: function preConfirm() {
          if (dataAccess.access_token) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve(dataAccess);
            });
          }

          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            reject(new Error('Token não pode ser encontrado.'));
          });
        }
      }).then(function (res) {
        _this3.$router.push('/avaliacao/formulario/' + collaboratorId + '/' + res.access_token);
      }).catch(__WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.noop);
    },
    getClassLabel: function getClassLabel(label) {
      var classLabel = '';

      switch (label) {
        case 'success':
          classLabel = 'label-success';
          break;
        case 'warning':
          classLabel = 'label-warning';
          break;
        case 'info':
          classLabel = 'label-info';
          break;
        case 'danger':
          classLabel = 'label-danger';
          break;
      }

      return classLabel;
    },
    translateStatus: function translateStatus(status) {
      var translations = {
        pending: 'Pendente',
        in_progress: 'Em Andamento',
        at_risk: 'Em Risco',
        completed: 'Concluído',
        overdue: 'Atrasado'
      };
      return translations[status] || status;
    },
    formatNextMonitoring: function formatNextMonitoring(nextMonitoring) {
      if (!nextMonitoring) {
        return 'NÃO AGENDADA';
      }
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      var year = today.getFullYear();
      var month = String(today.getMonth() + 1).padStart(2, '0');
      var day = String(today.getDate()).padStart(2, '0');

      var formattedToday = year + '-' + month + '-' + day;

      if (nextMonitoring.date === formattedToday) {
        return 'HOJE';
      } else {
        return this.formatDate(nextMonitoring.date);
      }
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '';

      var _dateStr$split = dateStr.split(' '),
          _dateStr$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_dateStr$split, 1),
          datePart = _dateStr$split2[0];

      var _datePart$split$map = datePart.split('-').map(Number),
          _datePart$split$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_datePart$split$map, 3),
          year = _datePart$split$map2[0],
          month = _datePart$split$map2[1],
          day = _datePart$split$map2[2];

      var date = new Date(year, month - 1, day);

      return date.toLocaleDateString('pt-BR');
    },
    getPastMeetings: function getPastMeetings(collaborator) {
      return (collaborator.plan_evaluation.monitoring_meetings || []).filter(function (m) {
        return m.status === 1 || m.status === 2;
      }).sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });
    },
    currentMeetingIndex: function currentMeetingIndex(collaboratorId) {
      return this.currentMeetingIndexByCollaborator[collaboratorId] || 0;
    },
    currentPastMeeting: function currentPastMeeting(collaborator) {
      var meetings = this.getPastMeetings(collaborator);
      return meetings[this.currentMeetingIndex(collaborator.id)];
    },
    prevMeeting: function prevMeeting(collaborator) {
      var id = collaborator.id;
      if (this.currentMeetingIndex(id) > 0) {
        this.slideDirectionByCollaborator[id] = 'slide-right';
        this.$set(this.currentMeetingIndexByCollaborator, id, this.currentMeetingIndex(id) - 1);
      }
    },
    nextMeeting: function nextMeeting(collaborator) {
      var id = collaborator.id;
      var meetings = this.getPastMeetings(collaborator);
      if (this.currentMeetingIndex(id) < meetings.length - 1) {
        this.slideDirectionByCollaborator[id] = 'slide-left';
        this.$set(this.currentMeetingIndexByCollaborator, id, this.currentMeetingIndex(id) + 1);
      }
    },
    goToMeeting: function goToMeeting(collaborator, index) {
      var id = collaborator.id;
      if (index !== this.currentMeetingIndex(id)) {
        this.slideDirectionByCollaborator[id] = index > this.currentMeetingIndex(id) ? 'slide-left' : 'slide-right';
        this.$set(this.currentMeetingIndexByCollaborator, id, index);
      }
    }
  },
  computed: {
    collaborators: function collaborators() {
      return this.$store.getters.collaborators;
    }
  }
});

/***/ }),

/***/ "FHYG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FHzF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FiZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'Meus Dados',
  icon: 'ti-user',
  path: '/perfil'
}, {
  name: 'Minhas Avaliações',
  icon: 'ti-view-list-alt',
  path: '/avaliacao/listar'
}, {
  name: 'Minha Equipe',
  icon: 'ti-layers-alt',
  path: '/avaliacao/equipe',
  requiresManager: true
}, {
  name: 'Código Verificador',
  icon: 'ti-package',
  path: '/avaliacao/codigos'
}, {
  name: 'Power University',
  icon: 'br-power-university',
  path: '/power-university',
  requiresManager: true,
  requiresAccessPowerUniversity: true
}]);

/***/ }),

/***/ "G24O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GB1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PowerUniversity_vue__ = __webpack_require__("qXym");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8b4870c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PowerUniversity_vue__ = __webpack_require__("QR3j");
function injectStyle (ssrContext) {
  __webpack_require__("PsJg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PowerUniversity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8b4870c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PowerUniversity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GXEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GoCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.inlineClass},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H/Zg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setBaseURL;
/* harmony export (immutable) */ __webpack_exports__["b"] = setIntercept;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);


function setBaseURL() {
   axios.defaults.baseURL = "https://api-avaliacaodesempenho.brasal.com.br";
}

function setIntercept(store, router) {
   axios.interceptors.response.use(null, function (error) {
      if (error.response.status == 401) {
         store.commit('logout');
         router.push('/login');
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
   });
}

/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("zwtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08cbb8e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("qMRi");
function injectStyle (ssrContext) {
  __webpack_require__("+Dme")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08cbb8e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HSdJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I4nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ICPI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("F4OC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58cfe092_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("D6Xl");
function injectStyle (ssrContext) {
  __webpack_require__("RZp6")
  __webpack_require__("a3kA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58cfe092"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58cfe092_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IWTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("Vzbv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68dc5fc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("JH+x");
function injectStyle (ssrContext) {
  __webpack_require__("Cfke")
  __webpack_require__("Xpan")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68dc5fc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68dc5fc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J/HH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J7HA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CollaboratorProfile_CollaboratorCard_vue__ = __webpack_require__("6KnM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CollaboratorProfile_EvaluationCard_vue__ = __webpack_require__("mtcV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.collaboratorId = parseInt(this.$route.params.collaboratorId);
    this.getCollaborator();
  },

  components: {
    CollaboratorCard: __WEBPACK_IMPORTED_MODULE_1__CollaboratorProfile_CollaboratorCard_vue__["a" /* default */],
    EvaluationCard: __WEBPACK_IMPORTED_MODULE_2__CollaboratorProfile_EvaluationCard_vue__["a" /* default */]
  },
  created: function created() {
    $('html, body').animate({ scrollTop: 0 }, 600);
  },
  data: function data() {
    return {
      collaboratorId: null,
      collaborator: {}
    };
  },

  methods: {
    getCollaborator: function getCollaborator() {
      var _this = this;

      var url = '/collaborator/manager/collaborator/' + this.collaboratorId;
      axios.get(url).then(function (res) {
        _this.collaborator = res.data;
      }).catch(function (error) {
        var message = 'Não foi possível completa requisição, tente novamente mais tarde.';

        if (error.response.status !== 500) {
          message = error.response.data.error;
        }

        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          title: 'Colaborador!',
          text: message,
          type: 'error',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'Voltar',
          buttonsStyling: false,
          allowOutsideClick: false,
          preConfirm: function preConfirm() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve('OK');
            });
          }
        }).then(function () {
          _this.$router.push('/avaliacao/equipe');
        }).catch(__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.noop);
      });
    }
  }
});

/***/ }),

/***/ "JH+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resultado_avaliacao"},[_c('h4',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.resultEvaluation.evaluation_cycle_name)+" - "+_vm._s(_vm.resultEvaluation.evaluation_type_name)+"\n    "),_c('small',[_vm._v(_vm._s(_vm._f("formatDateBr")(_vm.resultEvaluation.evaluation_cycle_start_date))+" - "+_vm._s(_vm._f("formatDateBr")(_vm.resultEvaluation.evaluation_cycle_end_date)))])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('circle-chart-card',{attrs:{"percentage":_vm.resultEvaluation.final_result,"title":"RESULTADO FINAL","description":_vm.resultEvaluation.evaluation_type_name,"color":_vm.percentTotalColor(_vm.resultEvaluation.final_result)}})],1)]),_vm._v(" "),(!_vm.resultEvaluation.blocked)?_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":_vm.resultEvaluation.total_skill_percent,"title":"COMPETÊNCIAS","color":_vm.percentTotalColor(_vm.resultEvaluation.total_skill_percent)}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":_vm.resultEvaluation.delivery_percent,"title":"ENTREGA","color":_vm.percentTotalColor(_vm.resultEvaluation.delivery_percent)}})],1)]):_vm._e(),_vm._v(" "),(!_vm.resultEvaluation.blocked)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-package"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"category"},[_vm._v("COMPETÊNCIAS")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},_vm._l((_vm.resultEvaluation.skills),function(skill,index){return _c('div',{key:("skill-" + index)},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-10 comp"},[_vm._v("\n                "+_vm._s(skill.name)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 grade_comp"},[_vm._v("\n                "+_vm._s(skill.percent)+"%\n              ")])]),_vm._v(" "),_c('p-progress',{attrs:{"value":skill.percent,"type":_vm.percentColor(skill.percent)}})],1)}),0)])],1)]):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.open_answer)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"20px"}},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v(_vm._s(_vm.resultEvaluation.open_answer.answer))])])])])]):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.evaluation_type_id == 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card card-plano-acao"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.resultEvaluation.plan)?_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":((_vm.resultEvaluation.plan.development_plan_name) + " | " + (_vm.translateStatus(_vm.resultEvaluation.plan.status))),"name":"1"}},[_c('div',[_c('i',{staticClass:"ti-calendar"}),_vm._v("  "),_c('b',[_vm._v("Data de Início:")]),_vm._v(" "+_vm._s(_vm._f("formatDateBr")(_vm.resultEvaluation.plan.start_date))),_c('br'),_vm._v(" "),_c('i',{staticClass:"ti-calendar"}),_vm._v("  "),_c('b',[_vm._v("Data de Término:")]),_vm._v(" "+_vm._s(_vm._f("formatDateBr")(_vm.resultEvaluation.plan.end_date))),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('i',{staticClass:"ti-ticket"}),_vm._v("  "),_c('b',[_vm._v("Competência:")]),_c('br'),_vm._v(" "),_vm._l((_vm.resultEvaluation.plan.newSkills),function(skill){return _c('span',{staticStyle:{"font-size":"14px"}},[_c('u',[_vm._v(_vm._s(skill.skill && skill.skill.name ? skill.skill.name : skill.name))]),_c('br'),_vm._v("\n                    "+_vm._s(skill.skill && skill.skill.description ? skill.skill.description : skill.description)),_c('br'),_c('br')])}),_vm._v(" "),_c('br')],2),_vm._v(" "),(_vm.resultEvaluation.plan.description)?_c('div',[_c('i',{staticClass:"ti-clipboard"}),_vm._v("  "),_c('b',[_vm._v("Descrição:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.plan.description)+" ")]),_c('br')]):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.action_plan_objective)?_c('div',[_c('i',{staticClass:"ti-star"}),_vm._v("  "),_c('b',[_vm._v("Objetivo:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.plan.action_plan_objective)+" ")]),_c('br')]):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.identified_improvement_areas)?_c('div',[_c('i',{staticClass:"ti-bookmark"}),_vm._v("  "),_c('b',[_vm._v("Áreas de Melhoria:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.plan.identified_improvement_areas)+" ")]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.action_plan_goals_old)?_c('div',[_c('i',{staticClass:"ti-check-box"}),_vm._v("  "),_c('b',[_vm._v("Metas:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.plan.action_plan_goals_old)+" ")]),_c('br')]):(_vm.resultEvaluation.plan.action_plan_goals && _vm.resultEvaluation.plan.action_plan_goals.length != 0)?_c('div',[_c('i',{staticClass:"ti-check-box"}),_vm._v("  "),_c('b',[_vm._v("Metas:")]),_c('br'),_vm._v(" "),_vm._l((_vm.resultEvaluation.plan.action_plan_goals),function(goal,index){return _c('div',{key:goal.id,staticClass:"goal",staticStyle:{"margin-top":"10px","margin-bottom":"15px"}},[_c('div',{staticClass:"goal-title"},[_c('span',{staticClass:"dot"},[_vm._v("•")]),_vm._v(" "),_c('b',[_vm._v("Meta "+_vm._s(index + 1))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.translateStatus(goal.status)))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goal.progress)+"%")])]),_vm._v(" "),_c('div',{staticClass:"goal-body"},[_c('div',{staticClass:"progress",staticStyle:{"margin-bottom":"10px","height":"5px"}},[_c('div',{staticClass:"progress-bar",style:('width: ' + goal.progress + '%;'),attrs:{"role":"progressbar","aria-valuenow":goal.progress,"aria-valuemin":"0","aria-valuemax":"100"}})]),_vm._v(" "),_c('b',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(goal.goal)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Estratégia:")]),_vm._v(" "+_vm._s(goal.strategy)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Prazo:")]),_vm._v(" "+_vm._s(_vm.formatDate(goal.due_date))+"\n                      ")])])})],2):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.strategies_to_reach_goals_old)?_c('div',[_c('i',{staticClass:"ti-list"}),_vm._v("  "),_c('b',[_vm._v("Estratégias para Alcançar as Metas:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.plan.strategies_to_reach_goals_old)+" ")]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.success_indicators && _vm.resultEvaluation.plan.success_indicators.length > 0)?_c('div',[_c('i',{staticClass:"ti-stats-up"}),_vm._v("  "),_c('b',[_vm._v("Indicadores de Sucesso:")]),_c('br'),_vm._v(" "),_vm._l((_vm.resultEvaluation.plan.success_indicators),function(successIndicator){return _c('div',[_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" - "+_vm._s(successIndicator.success_indicator.description)+" ")])])}),_c('br')],2):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.monitoring_meetings && _vm.resultEvaluation.plan.monitoring_meetings.length > 0)?_c('div',[_c('i',{staticClass:"ti-timer"}),_vm._v("  "),_c('b',[_vm._v("Acompanhamento:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v("\n                    Próxima reunião: "+_vm._s(_vm.formatNextMonitoring(_vm.resultEvaluation.plan.next_monitoring))+"\n                  ")]),_c('br'),_vm._v(" "),_c('i',{staticClass:"ti-agenda"}),_vm._v("  "),_c('b',[_vm._v("Histórico de Reuniões:")]),_c('br'),_vm._v(" "),(_vm.pastMeetings.length && _vm.pastMeetings.length > 0)?_c('div',{staticClass:"carousel-wrapper"},[_c('button',{staticClass:"nav-button left",attrs:{"disabled":_vm.currentMeetingIndex === 0},on:{"click":_vm.prevMeeting}},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.slideDirection,"mode":"out-in"}},[_c('div',{key:_vm.currentPastMeeting.id,staticClass:"carousel-card"},[_c('b',[_vm._v("Data:")]),_vm._v(" "+_vm._s(_vm.formatDate(_vm.currentPastMeeting.date))),_c('br'),_vm._v(" "),(_vm.currentPastMeeting.status === 2)?_c('div',[_c('span',[_vm._v("Reunião não realizada.")])]):_c('div',[_vm._l((_vm.currentPastMeeting.goal_progresses),function(goalProgress){return _c('div',[(goalProgress.progress_change > 0)?_c('div',[_c('i',{staticClass:"ti-arrow-up"}),_vm._v(" "),_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"green"}},[_vm._v(" + "+_vm._s(goalProgress.progress_change)+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])]):(goalProgress.progress_change == 0)?_c('div',[_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',[_vm._v(" + "+_vm._s(goalProgress.progress_change)+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])]):_c('div',[_c('i',{staticClass:"ti-arrow-down"}),_vm._v(" "),_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" - "+_vm._s(goalProgress.progress_change * (-1))+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])])])}),_vm._v(" "),_c('b',[_vm._v("Feedbacks:")]),_vm._v(" "+_vm._s(_vm.currentPastMeeting.feedbacks)),_c('br')],2)])]),_vm._v(" "),_c('button',{staticClass:"nav-button right",attrs:{"disabled":_vm.currentMeetingIndex >= _vm.pastMeetings.length - 1},on:{"click":_vm.nextMeeting}},[_c('i',{staticClass:"ti-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"carousel-indicators"},_vm._l((_vm.pastMeetings),function(meeting,index){return _c('span',{key:meeting.id,class:['indicator-dot', { active: index === _vm.currentMeetingIndex }],on:{"click":function($event){return _vm.goToMeeting(index)}}})}),0)],1):_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v("\n                    As reuniões de acompanhamento realizadas aparecerão aqui.\n                  ")]),_c('br')]):(_vm.resultEvaluation.plan.monitoring_frequencies.length > 0)?_c('div',[_c('i',{staticClass:"ti-timer"}),_vm._v("  "),_c('b',[_vm._v("Frequência de Monitoramento:")]),_c('br'),_vm._v(" "),_vm._l((_vm.resultEvaluation.plan.monitoring_frequencies),function(monitoringFrequency){return _c('div',[_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" - "+_vm._s(monitoringFrequency.monitoring_frequency.description)+"\n                    ")])])}),_c('br')],2):_vm._e()])])],1):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12",staticStyle:{"text-align":"center","margin":"20px 0"}},[_c('router-link',{attrs:{"to":"/avaliacao/listar"}},[_c('button',{staticClass:"btn btn-wd btn-default btn-move-left",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v("\n          Voltar\n        ")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header text-center"},[_c('h5',{staticClass:"card-title",staticStyle:{"color":"#252422","font-weight":"700"}},[_vm._v("RESULTADO")]),_vm._v(" "),_c('p',{staticClass:"category",staticStyle:{"color":"#3b4651","font-size":"12px"}},[_vm._v("Competências")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-center"},[_c('h5',{staticClass:"card-title",staticStyle:{"color":"#252422","font-weight":"700"}},[_vm._v("RESPOSTA ABERTA")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("PLANO DE AÇÃO")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Plano de Desenvolvimento proposto por seu Gestor Imediato para a competência\n            selecionada.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JhHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__ = __webpack_require__("3MeN");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14425a60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__ = __webpack_require__("k1ZS");
function injectStyle (ssrContext) {
  __webpack_require__("poPr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14425a60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Kewk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs__);











__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    keyVfor: function keyVfor() {
      return Math.random().toString(5).slice(2);
    }
  }
});

/***/ }),

/***/ "LUn3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e6aca2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("kOp2");
function injectStyle (ssrContext) {
  __webpack_require__("d5Xl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e6aca2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a38d0e24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("MnLV");
function injectStyle (ssrContext) {
  __webpack_require__("6qw8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a38d0e24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_general__ = __webpack_require__("Y3o5");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'static/img/vue-logo.png'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    },
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    }
  },
  methods: {
    initScrollBarAsync: function initScrollBarAsync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Fiov"));

              case 2:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this.$refs.sidebarScrollArea);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkAccess: function checkAccess(link) {
      if (link.requiresManager) {
        if (this.currentUser.is_manager) {
          if (link.requiresAccessPowerUniversity) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_helpers_general__["c" /* checkAccessPowerUniversity */])(this.currentUser)) {
              return true;
            }
            return false;
          }
          return true;
        }
        return false;
      }
      return true;
    }
  },
  mounted: function mounted() {
    this.initScrollBarAsync();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ "MnLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright pull-right"},[_c('a',{attrs:{"href":"https://www.brasal.com.br/","target":"_blank"}},[_c('img',{staticClass:"logo_brasal",attrs:{"src":"/static/img/logo_brasal_c.png","alt":"Brasal"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrap__ = __webpack_require__("kBzv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_pt_br__ = __webpack_require__("LVWl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gloablComponents__ = __webpack_require__("iXuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sass_demo_scss__ = __webpack_require__("9G8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sass_demo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_sass_demo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_sass_customize_scss__ = __webpack_require__("gkvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_sass_customize_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_sass_customize_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sidebarLinks__ = __webpack_require__("FiZY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_general__ = __webpack_require__("Y3o5");



























__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10__gloablComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_notifyjs___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12__components_UIComponents_SidebarPlugin__["a" /* default */], { sidebarLinks: __WEBPACK_IMPORTED_MODULE_19__sidebarLinks__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_pt_br___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_14__routes_routes__["a" /* default */],
  mode: 'history',
  linkActiveClass: 'active',
  suppressTransitionError: false
});

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__helpers_general__["a" /* initialize */])(store, router);

new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_9__App_vue__["a" /* default */]);
  },
  router: router,
  store: store
});

/***/ }),

/***/ "NKe7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("wJKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_tag__ = __webpack_require__("orbS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_slider_css__ = __webpack_require__("BxWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_slider__ = __webpack_require__("g2bL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_helpers_general__ = __webpack_require__("Y3o5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__InfoPDI9Box_vue__ = __webpack_require__("pEHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_jquery__);



























var _components;














__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_29_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_collapse_item___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.evaluationId = this.$route.params.evaluationId;
    this.collaboratorId = this.$route.params.collaboratorId;
    this.developmentPlan.evaluation_id = this.evaluationId;
    this.getResultEvaluation();
    this.getDevelopmentPlans();
    this.getSuccessIndicators();
    this.getMonitoringFrequency();
  },

  components: (_components = {
    StatsCard: __WEBPACK_IMPORTED_MODULE_30_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_31_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_28_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_slider___default.a.name, __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_slider___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_34__InfoPDI9Box_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_34__InfoPDI9Box_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_27_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'PProgress', __WEBPACK_IMPORTED_MODULE_32_src_components_UIComponents_Progress_vue__["a" /* default */]), _components),
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_36_jquery___default()('html, body').animate({ scrollTop: 0 }, 600);
  },
  data: function data() {
    var _this = this;

    var vm = this;

    return {
      evaluationId: null,
      resultEvaluation: null,
      developmentPlans: [],
      successIndicators: [],
      monitoringFrequency: [],
      developmentPlanSelected: {},
      skillId: [],
      skillView: {},
      collaboratorId: null,
      loading: false,
      developmentPlan: {
        evaluation_id: '',
        development_plan_id: 6,
        description: '',
        action_plan_objective: '',
        identified_improvement_areas: '',

        action_plan_goals: [{
          goal: '',
          strategy: '',
          due_date: ''
        }],
        strategies_to_reach_goals: '',
        start_date: '',
        end_date: '',
        success_indicators: [],
        monitoring_frequencies: [],
        monitoring_meetings: [''],
        skill_ids: []
      },
      noMeetingDateAvailable: false,
      pickerOptionsStart: {
        disabledDate: function disabledDate(date) {
          if (date < new Date()) {
            return true;
          } else {
            return false;
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: function disabledDate(date) {
          var today = new Date();
          var start = _this.developmentPlan.start_date ? new Date(_this.developmentPlan.start_date) : null;

          var d = new Date(date);

          if (d < today) return true;
          if (start && d <= start) return true;
          if (start) {
            var minEndDate = new Date(start);
            minEndDate.setDate(minEndDate.getDate() + 20);
            if (d < minEndDate) return true;
          }
          return false;
        }
      },
      pickerOptionsGoals: {
        disabledDate: function disabledDate(date) {
          var start = _this.developmentPlan.start_date ? new Date(_this.developmentPlan.start_date) : null;
          var end = _this.developmentPlan.end_date ? new Date(_this.developmentPlan.end_date) : null;

          if (!start || !end) return true;

          var current = new Date(date);
          return current < start || current > end;
        }
      }
    };
  },

  methods: {
    openOverview: function openOverview(evaluationId) {
      this.$router.push('/avaliacao/equipe/perfil/' + this.collaboratorId + '/resultado-completo/' + evaluationId);
    },
    openSetPlan: function openSetPlan(evaluationId) {
      this.$router.push('/avaliacao/formulario-resultado/' + evaluationId + '/' + this.collaboratorId);
    },
    addGoal: function addGoal() {
      this.developmentPlan.action_plan_goals.push({ goal: '', strategy: '', due_date: '' });
    },
    removeGoal: function removeGoal(index) {
      if (this.developmentPlan.action_plan_goals.length > 1) {
        this.developmentPlan.action_plan_goals.splice(index, 1);
      }
    },
    percentColor: function percentColor(percent) {
      var classColor = 'success';

      if (percent >= 0 && percent < 40) {
        classColor = 'danger';
      } else if (percent >= 40 && percent < 80) {
        classColor = 'warning';
      }
      return classColor;
    },
    percentTotalColor: function percentTotalColor(percent) {
      var color = 'green';

      if (percent >= 0 && percent < 40) {
        color = 'red';
      }

      if (percent >= 40 && percent < 80) {
        color = 'orange';
      }

      return color;
    },
    getResultEvaluation: function getResultEvaluation() {
      var _this2 = this;

      var url = '/collaborator/manager/collaborator-evaluation-plan/' + this.evaluationId;
      axios.get(url).then(function (res) {
        _this2.resultEvaluation = res.data;
      }).catch(function (error) {
        var message = 'Não foi possível completar a requisição, tente novamente mais tarde.';

        if (error.response.status !== 500) {
          message = error.response.data.error;
        }

        __WEBPACK_IMPORTED_MODULE_35_sweetalert2___default()({
          title: 'Avaliação!',
          text: message,
          type: 'error',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'Voltar',
          buttonsStyling: false,
          allowOutsideClick: false,
          preConfirm: function preConfirm() {
            return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve('OK');
            });
          }
        }).then(function () {
          _this2.$router.push('/avaliacao/equipe');
        }).catch(__WEBPACK_IMPORTED_MODULE_35_sweetalert2___default.a.noop);
      });
    },
    getDevelopmentPlans: function getDevelopmentPlans() {
      var _this3 = this;

      var url = '/collaborator/manager/development-plan-evaluation';
      axios.get(url).then(function (res) {
        _this3.developmentPlans = res.data;
      });
    },
    getSuccessIndicators: function getSuccessIndicators() {
      var _this4 = this;

      var url = '/collaborator/manager/success-indicator';
      axios.get(url).then(function (res) {
        _this4.successIndicators = res.data;
      });
    },
    getMonitoringFrequency: function getMonitoringFrequency() {
      var _this5 = this;

      var url = '/collaborator/manager/monitoring-frequency';
      axios.get(url).then(function (res) {
        _this5.monitoringFrequency = res.data;
      });
    },
    checkAccessUser: function checkAccessUser(developmentPlanId) {
      if (developmentPlanId === 5) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33_src_helpers_general__["c" /* checkAccessPowerUniversity */])(this.currentUser);
      }

      return true;
    },
    validDevelopmentPlan: function validDevelopmentPlan() {
      var goals = this.developmentPlan.action_plan_goals || [];
      var hasInvalidGoal = goals.some(function (goal) {
        return !goal.goal || !goal.strategy || !goal.due_date;
      });
      if (!!this.developmentPlan.evaluation_id && !!this.developmentPlan.development_plan_id && !!this.developmentPlan.action_plan_objective && !!this.developmentPlan.identified_improvement_areas && !!this.developmentPlan.action_plan_goals && !!this.developmentPlan.start_date && !!this.developmentPlan.end_date && this.developmentPlan.skill_ids.length !== 0 && this.developmentPlan.success_indicators.length !== 0 && this.developmentPlan.monitoring_meetings.length > 0 && this.developmentPlan.monitoring_meetings.every(function (date) {
        return !!date;
      }) && !hasInvalidGoal) {
        this.validAccess();
      } else {
        __WEBPACK_IMPORTED_MODULE_35_sweetalert2___default()({
          title: 'Plano de Ação!',
          text: 'Preencha todo os campos (*) obrigatórios.',
          type: 'error',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false,
          allowOutsideClick: false
        }).catch(__WEBPACK_IMPORTED_MODULE_35_sweetalert2___default.a.noop);
      }
    },
    saveDevelopmentPlan: function saveDevelopmentPlan(dataAccess) {
      var _this6 = this;

      var dataDevelopmentPlan = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.developmentPlan, {
        token: dataAccess.access_token
      });

      __WEBPACK_IMPORTED_MODULE_35_sweetalert2___default()({
        title: 'Você tem certeza!',
        html: 'Plano de Ação será finalizada.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Enviar Plano de Ação',
        buttonsStyling: false,
        preConfirm: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var url;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    url = '/collaborator/manager/collaborator-evaluation-plan';
                    _context.next = 3;
                    return axios.post(url, dataDevelopmentPlan).catch(function (error) {
                      var message = 'Não foi possível completa requisição, tente novamente mais tarde.';
                      if (error.response.status !== 500) {
                        message = error.response.data.error;
                      }
                      __WEBPACK_IMPORTED_MODULE_35_sweetalert2___default.a.showValidationError(message);
                      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                        reject(new Error(message));
                      });
                    });

                  case 3:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this6);
          }));

          return function preConfirm() {
            return _ref.apply(this, arguments);
          };
        }()
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_35_sweetalert2___default()({
          title: 'Plano de Ação!',
          text: 'Plano de Ação foi enviado com sucesso.',
          type: 'success',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false,
          allowOutsideClick: false,
          preConfirm: function preConfirm() {
            return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve('OK');
            });
          }
        }).then(function () {
          _this6.$router.push('/avaliacao/equipe');
        });
      }).catch(__WEBPACK_IMPORTED_MODULE_35_sweetalert2___default.a.noop);
    },
    validAccess: function validAccess() {
      var _this7 = this;

      var evaluationId = this.evaluationId;
      __WEBPACK_IMPORTED_MODULE_35_sweetalert2___default()({
        title: 'Código Verificador',
        input: 'number',
        inputPlaceholder: 'Ex: 785438',
        html: '<small>Peça ao seu colaborador o código verificador que aparece no sistema de Avaliação de Desempenho em seu telefone celular.</small>',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Verificar',
        buttonsStyling: false,
        preConfirm: function preConfirm(code) {
          if (!code) {
            __WEBPACK_IMPORTED_MODULE_35_sweetalert2___default.a.showValidationError('Informe um código verificador.');
            return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              reject(new Error('Informe o código verificador.'));
            });
          }

          return _this7.verifyCode(evaluationId, code).catch(function (error) {
            var message = 'Não foi possível completar a requisição, tente novamente mais tarde.';
            if (error.response.status !== 500) {
              message = error.response.data.error;
            }

            __WEBPACK_IMPORTED_MODULE_35_sweetalert2___default.a.showValidationError(message);

            return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              reject(new Error(message));
            });
          });
        }
      }).then(function (res) {
        _this7.saveDevelopmentPlan(res.data);
      });
    },
    verifyCode: function verifyCode(evaluationId, code) {
      return axios.post('/collaborator/manager/verify-code-evaluation', {
        evaluation_id: evaluationId,
        code: code
      });
    },
    developmentPlanShow: function developmentPlanShow() {
      var _this8 = this;

      var developmentPlan = this.developmentPlans.find(function (value) {
        return value.id === _this8.developmentPlan.development_plan_id;
      });

      if (developmentPlan) {
        this.developmentPlanSelected = developmentPlan;
      } else {
        this.developmentPlanSelected = {};
      }
    },
    evaluationEdit: function evaluationEdit() {
      var evaluationId = this.evaluationId;
      this.$router.push('/avaliacao/formulario-editar/' + evaluationId + '/' + this.collaboratorId);
    },
    whatsappGenerateLink: function whatsappGenerateLink(phone) {
      if (phone) {
        phone = phone.replace(/[^\d]+/g, '');
        var link = 'https://api.whatsapp.com/send?phone=55' + phone + '&text=Ol\xE1! Iniciaremos neste momento o seu feedback. Por favor, procure um local tranquilo para come\xE7armos.';
        return link;
      }
    },
    addMeetingDate: function addMeetingDate() {
      var _this9 = this;

      this.developmentPlan.monitoring_meetings.push('');
      this.$nextTick(function () {
        _this9.updateMeetingAvailability();
      });
    },
    removeMeetingDate: function removeMeetingDate(index) {
      var _this10 = this;

      if (this.developmentPlan.monitoring_meetings.length > 1) {
        this.developmentPlan.monitoring_meetings.splice(index, 1);
        this.$nextTick(function () {
          _this10.updateMeetingAvailability();
        });
      }
    },
    getMeetingDatePickerOptions: function getMeetingDatePickerOptions(index) {
      var _this11 = this;

      return {
        disabledDate: function disabledDate(date) {
          var start = _this11.developmentPlan.start_date ? new Date(_this11.developmentPlan.start_date) : null;
          var end = _this11.developmentPlan.end_date ? new Date(_this11.developmentPlan.end_date) : null;

          if (!start || !end) return true;
          var minDate = new Date(start);

          if (index > 0) {
            var prevMeeting = _this11.developmentPlan.monitoring_meetings[index - 1];
            if (prevMeeting) {
              minDate = new Date(prevMeeting);
            }
          }

          minDate.setDate(minDate.getDate() + 15);

          var currentDate = new Date(date);

          return currentDate < minDate || currentDate > end;
        }
      };
    },
    updateMeetingAvailability: function updateMeetingAvailability() {
      var start = this.developmentPlan.start_date ? new Date(this.developmentPlan.start_date) : null;
      var end = this.developmentPlan.end_date ? new Date(this.developmentPlan.end_date) : null;

      if (!start || !end) {
        this.noMeetingDateAvailable = true;
        return;
      }

      var meetings = this.developmentPlan.monitoring_meetings.filter(function (m) {
        return !!m;
      });
      var baseDate = meetings.length > 0 ? new Date(meetings[meetings.length - 1]) : new Date(start);
      baseDate.setDate(baseDate.getDate() + 15);

      if (baseDate >= end) {
        this.noMeetingDateAvailable = true;

        this.developmentPlan.monitoring_meetings = this.developmentPlan.monitoring_meetings.filter(function (m) {
          return !!m;
        });

        if (this.developmentPlan.monitoring_meetings.length === 0) {
          this.developmentPlan.monitoring_meetings.push('');
        }
      } else {
        this.noMeetingDateAvailable = false;
      }
    },
    clearAllDates: function clearAllDates(value) {
      if (!value) {
        this.developmentPlan.end_date = '';
        this.developmentPlan.action_plan_goals.forEach(function (goal) {
          goal.due_date = '';
        });
        this.developmentPlan.monitoring_meetings = this.developmentPlan.monitoring_meetings.map(function () {
          return '';
        });

        var nonEmpty = this.developmentPlan.monitoring_meetings.filter(function (date) {
          return !!date;
        });

        this.developmentPlan.monitoring_meetings = nonEmpty.length > 0 ? nonEmpty : [''];

        this.updateMeetingAvailability();
      }
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    },
    monitoringMeetingSignature: function monitoringMeetingSignature() {
      return this.developmentPlan.monitoring_meetings.join('|');
    },
    canAddNewMeetingDate: function canAddNewMeetingDate() {
      var meetings = this.developmentPlan.monitoring_meetings;
      var lastMeeting = meetings[meetings.length - 1];
      return !this.noMeetingDateAvailable && !!lastMeeting;
    }
  },
  watch: {
    'developmentPlan.end_date': function developmentPlanEnd_date(newDate) {
      var _this12 = this;

      if (!newDate) return;

      var endDate = new Date(newDate);

      this.developmentPlan.action_plan_goals = this.developmentPlan.action_plan_goals.map(function (goal) {
        var dueDate = goal.due_date ? new Date(goal.due_date) : null;

        if (dueDate && dueDate > endDate) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, goal, { due_date: '' });
        }
        return goal;
      });

      this.developmentPlan.monitoring_meetings = this.developmentPlan.monitoring_meetings.map(function (meeting) {
        var meetingDate = meeting ? new Date(meeting) : null;

        if (meetingDate && meetingDate > endDate) {
          return '';
        }
        return meeting;
      });

      this.$nextTick(function () {
        _this12.updateMeetingAvailability();
      });
    },
    'developmentPlan.start_date': function developmentPlanStart_date(newDate) {
      var _this13 = this;

      if (!newDate) return;

      var startDate = new Date(newDate);

      this.developmentPlan.action_plan_goals = this.developmentPlan.action_plan_goals.map(function (goal) {
        var dueDate = goal.due_date ? new Date(goal.due_date) : null;

        if (dueDate && dueDate < startDate) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, goal, { due_date: '' });
        }
        return goal;
      });

      this.developmentPlan.monitoring_meetings = this.developmentPlan.monitoring_meetings.map(function (meeting) {
        var meetingDate = meeting ? new Date(meeting) : null;

        if (meetingDate && meetingDate < startDate) {
          return '';
        }
        return meeting;
      });

      this.$nextTick(function () {
        _this13.updateMeetingAvailability();
      });
    },
    monitoringMeetingSignature: function monitoringMeetingSignature() {
      this.updateMeetingAvailability();
    }
  }
});

/***/ }),

/***/ "ORD+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb6a9b8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("A3tr");
function injectStyle (ssrContext) {
  __webpack_require__("q8Yn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb6a9b8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PmSE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_slider_css__ = __webpack_require__("BxWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_slider__ = __webpack_require__("g2bL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_helpers_general__ = __webpack_require__("Y3o5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__InfoPDI9Box_vue__ = __webpack_require__("pEHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_moment__);




















var _components;










/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.collaboratorId = this.$route.params.collaboratorId;
    this.evaluationId = this.$route.params.evaluationId;
    this.getResultEvaluation();
    this.getDevelopmentPlans();
    this.getSuccessIndicators();
    this.getMonitoringFrequency();
    if (this.resultEvaluation) {
      this.originalGoals = this.resultEvaluation.plan ? this.resultEvaluation.plan.action_plan_goals.map(function (goal) {
        return {
          id: goal.id,
          progress: goal.progress
        };
      }) : [];
    }
  },

  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_slider___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_slider___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_24__InfoPDI9Box_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_24__InfoPDI9Box_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'StatsCard', __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_21_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'CircleChartCard', __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'PProgress', __WEBPACK_IMPORTED_MODULE_22_src_components_UIComponents_Progress_vue__["a" /* default */]), _components),
  data: function data() {
    var _this = this;

    var vm = this;
    return {
      collaboratorId: null,
      evaluationId: null,
      resultEvaluation: null,
      successIndicators: [],
      monitoringFrequency: [],
      developmentPlans: [],
      developmentPlanSelected: {},
      originalGoals: [],
      originalPlan: {},
      monitoringGoals: [],
      monitoring: {
        all_meetings: [{
          date: '',
          status: false
        }]
      },
      developmentPlan: {
        evaluation_id: '',
        development_plan_id: 6,
        description: '',
        action_plan_objective: '',
        identified_improvement_areas: '',
        action_plan_goals: [{
          goal: '',
          strategy: '',
          due_date: ''
        }],
        strategies_to_reach_goals: '',
        start_date: '',
        success_indicators: [],
        monitoring_frequencies: [],
        monitoring_meetings: [{
          date: '',
          status: false
        }],
        end_date: '',
        skill_id: ''
      },
      atLeastOneMeetingHeld: false,
      steps: {
        index: true,
        update: false,
        monitoring: false
      },
      loading: false,
      currentMeetingIndex: 0,
      slideDirection: 'slide-left',
      showMeetingSchedule: false,
      noMeetingDateAvailable: false,
      pickerOptionsStart: {
        disabledDate: function disabledDate(date) {
          if (date < new Date()) {
            return true;
          } else {
            return false;
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: function disabledDate(date) {
          var today = new Date();
          var start = _this.developmentPlan.start_date ? new Date(_this.developmentPlan.start_date) : null;
          var meetings = _this.developmentPlan.monitoring_meetings || [];

          var lastDoneMeetingDate = meetings.filter(function (m) {
            return m.status === 1 && m.date;
          }).map(function (m) {
            return new Date(m.date);
          }).sort(function (a, b) {
            return b - a;
          })[0];

          var d = new Date(date);

          if (d < today) return true;
          if (start && d <= start) return true;
          if (start) {
            var minEndDate = new Date(start);
            minEndDate.setDate(minEndDate.getDate() + 20);
            if (d < minEndDate) return true;
          }
          if (lastDoneMeetingDate && d < lastDoneMeetingDate) return true;

          return false;
        }
      },
      pickerOptionsGoals: {
        disabledDate: function disabledDate(date) {
          var start = _this.developmentPlan.start_date ? new Date(_this.developmentPlan.start_date) : null;
          var end = _this.developmentPlan.end_date ? new Date(_this.developmentPlan.end_date) : null;

          if (!start || !end) return true;

          var current = new Date(date);
          return current < start || current > end;
        }
      }
    };
  },

  filters: {
    formatDateBr: function formatDateBr(date) {
      return __WEBPACK_IMPORTED_MODULE_26_moment___default()(date).format('DD/MM/YYYY');
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    },
    pastMeetings: function pastMeetings() {
      return this.resultEvaluation.plan.monitoring_meetings.filter(function (m) {
        return m.status === 1 || m.status === 2;
      }).sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });
    },
    currentPastMeeting: function currentPastMeeting() {
      return this.pastMeetings[this.currentMeetingIndex];
    },
    monitoringMeetingSignatureStepUpdate: function monitoringMeetingSignatureStepUpdate() {
      return this.developmentPlan.monitoring_meetings.map(function (m) {
        return m.date;
      }).join('|');
    },
    monitoringMeetingSignatureStepMonitoring: function monitoringMeetingSignatureStepMonitoring() {
      return this.monitoring.all_meetings.map(function (m) {
        return m.date;
      }).join('|');
    },
    canAddNewMeetingDate: function canAddNewMeetingDate() {
      var meetings = this.steps.update ? this.developmentPlan.monitoring_meetings : this.monitoring.all_meetings;

      if (!meetings || meetings.length === 0) return false;

      var last = meetings[meetings.length - 1];
      return !this.noMeetingDateAvailable && !!last && !!last.date;
    }
  },
  methods: {
    getResultEvaluation: function getResultEvaluation() {
      var _this2 = this;

      var url = '/collaborator/manager/collaborator/' + this.collaboratorId + '/result-evaluation/' + this.evaluationId;
      axios.get(url).then(function (res) {
        _this2.resultEvaluation = res.data;
        _this2.resultEvaluation.plan.monitoring_meetings.forEach(function (meeting) {
          if (meeting.status === 1) {
            _this2.atLeastOneMeetingHeld = true;
          }
        });
      }).catch(function (error) {
        var message = 'Não foi possível completa requisição, tente novamente mais tarde.';

        if (error.response.status !== 500) {
          message = error.response.data.error;
        }

        __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default()({
          title: 'Avaliação!',
          text: message,
          type: 'error',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'Voltar',
          buttonsStyling: false,
          allowOutsideClick: false,
          preConfirm: function preConfirm() {
            return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve('OK');
            });
          }
        }).then(function () {
          _this2.$router.push('/avaliacao/equipe/perfil/' + _this2.collaboratorId);
        }).catch(__WEBPACK_IMPORTED_MODULE_25_sweetalert2___default.a.noop);
      });
    },
    getDevelopmentPlans: function getDevelopmentPlans() {
      var _this3 = this;

      var url = '/collaborator/manager/development-plan-evaluation';
      axios.get(url).then(function (res) {
        _this3.developmentPlans = res.data;
      });
    },
    getSuccessIndicators: function getSuccessIndicators() {
      var _this4 = this;

      var url = '/collaborator/manager/success-indicator';
      axios.get(url).then(function (res) {
        _this4.successIndicators = res.data;
      });
    },
    getMonitoringFrequency: function getMonitoringFrequency() {
      var _this5 = this;

      var url = '/collaborator/manager/monitoring-frequency';
      axios.get(url).then(function (res) {
        _this5.monitoringFrequency = res.data;
      });
    },
    developmentPlanShow: function developmentPlanShow() {
      var _this6 = this;

      var developmentPlan = this.developmentPlans.find(function (value) {
        return value.id === _this6.developmentPlan.development_plan_id;
      });

      if (developmentPlan) {
        this.developmentPlanSelected = developmentPlan;
      } else {
        this.developmentPlanSelected = {};
      }
    },
    checkAccessUser: function checkAccessUser(developmentPlanId) {
      if (developmentPlanId === 5) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_src_helpers_general__["c" /* checkAccessPowerUniversity */])(this.currentUser);
      }

      return true;
    },
    parseDate: function parseDate(dateString) {
      var _dateString$split$map = dateString.split('-').map(Number),
          _dateString$split$map2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_dateString$split$map, 3),
          year = _dateString$split$map2[0],
          month = _dateString$split$map2[1],
          day = _dateString$split$map2[2];

      return new Date(year, month - 1, day);
    },
    getMonitoringByToday: function getMonitoringByToday(monitorings) {
      var today = new Date();
      var year = today.getFullYear();
      var month = String(today.getMonth() + 1).padStart(2, '0');
      var day = String(today.getDate()).padStart(2, '0');

      var formattedToday = year + '-' + month + '-' + day;
      var monitoring = monitorings.find(function (item) {
        var itemDate = new Date(item.date).toISOString().split('T')[0];
        return itemDate === formattedToday && item.status === 0;
      });
      return monitoring || false;
    },
    checkMonitoringByToday: function checkMonitoringByToday(nextMonitoring) {
      if (!nextMonitoring) {
        return false;
      }
      var today = new Date();
      var year = today.getFullYear();
      var month = String(today.getMonth() + 1).padStart(2, '0');
      var day = String(today.getDate()).padStart(2, '0');

      var formattedToday = year + '-' + month + '-' + day;

      return nextMonitoring.date === formattedToday;
    },
    getNextMonitoring: function getNextMonitoring(monitorings) {
      var _this7 = this;

      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var futureMonitorings = monitorings.filter(function (item) {
        var itemDate = _this7.parseDate(item.date);
        itemDate.setHours(0, 0, 0, 0);
        return itemDate > today && item.status !== 1;
      }).sort(function (a, b) {
        return _this7.parseDate(a.date) - _this7.parseDate(b.date);
      });
      return futureMonitorings.length ? futureMonitorings[0] : false;
    },
    formatNextMonitoring: function formatNextMonitoring(nextMonitoring, step) {
      if (!nextMonitoring) {
        return 'NÃO AGENDADA';
      }
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      var year = today.getFullYear();
      var month = String(today.getMonth() + 1).padStart(2, '0');
      var day = String(today.getDate()).padStart(2, '0');

      var formattedToday = year + '-' + month + '-' + day;

      if (nextMonitoring.date === formattedToday) {
        if (step.index) {
          return 'HOJE';
        }
        if (step.monitoring) {
          return 'NÃO AGENDADA';
        }
      } else {
        return this.formatDate(nextMonitoring.date);
      }
    },
    handleCancelEditing: function handleCancelEditing() {
      if (this.originalPlan) {
        this.developmentPlan = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.originalPlan));
      }
      this.handleStep('index');
    },
    handleCancelMonitoring: function handleCancelMonitoring() {
      this.monitoringGoals = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.originalGoals));
      this.handleStep('index');
    },
    handleMonitoring: function handleMonitoring(plan) {
      this.monitoringGoals = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(plan.action_plan_goals));
      this.originalGoals = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(plan.action_plan_goals));

      var todayMonitoring = this.getMonitoringByToday(plan.monitoring_meetings);

      var monitoringData = todayMonitoring ? JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(todayMonitoring)) : {};

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.monitoring, {
        id: monitoringData.id || null,
        date: monitoringData.date || '',
        status: monitoringData.status || false,
        feedbacks: monitoringData.feedbacks || '',
        evaluation_development_plan_id: monitoringData.evaluation_development_plan_id || null,
        goal_progresses: monitoringData.goal_progresses || [],
        created_at: monitoringData.created_at || null,
        updated_at: monitoringData.updated_at || null,
        all_meetings: JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(plan.monitoring_meetings))
      });

      this.handleStep('monitoring');
    },
    handleEdit: function handleEdit(plan) {
      var _this8 = this;

      var clonedPlan = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(plan));
      this.originalPlan = clonedPlan;

      this.developmentPlan.evaluation_id = this.resultEvaluation.id;
      this.developmentPlan.development_plan_id = clonedPlan.development_plan_id;
      this.developmentPlan.description = clonedPlan.description;
      this.developmentPlan.action_plan_objective = clonedPlan.action_plan_objective;
      this.developmentPlan.identified_improvement_areas = clonedPlan.identified_improvement_areas;
      this.developmentPlan.action_plan_goals = clonedPlan.action_plan_goals;
      this.developmentPlan.action_plan_goals_old = clonedPlan.action_plan_goals_old;
      this.developmentPlan.strategies_to_reach_goals_old = clonedPlan.strategies_to_reach_goals_old;
      this.developmentPlan.start_date = clonedPlan.start_date;
      this.developmentPlan.end_date = clonedPlan.end_date;
      this.developmentPlan.success_indicators = clonedPlan.success_indicators.map(function (indicator) {
        return indicator.success_indicator_id;
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
      clonedPlan.monitoring_frequencies.forEach(function (frequency) {
        _this8.developmentPlan.monitoring_frequencies.push(frequency.monitoring_frequency_id);
      });
      this.developmentPlan.monitoring_meetings = clonedPlan.monitoring_meetings;
      this.developmentPlan.skill_id = clonedPlan.skill_id;
      this.developmentPlanShow();
      this.handleStep('update');
    },
    addGoal: function addGoal() {
      this.developmentPlan.action_plan_goals.push({ goal: '', strategy: '', due_date: '' });
    },
    removeGoal: function removeGoal(index) {
      if (this.developmentPlan.action_plan_goals.length > 1) {
        this.developmentPlan.action_plan_goals.splice(index, 1);
      }
    },
    validMonitoring: function validMonitoring() {
      if (!this.monitoring.feedbacks || this.monitoring.feedbacks.trim() === '') {
        __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default()({
          title: 'Atenção!',
          text: 'Por favor, preencha o campo de feedback.',
          type: 'error',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false,
          allowOutsideClick: false
        }).catch(__WEBPACK_IMPORTED_MODULE_25_sweetalert2___default.a.noop);
      } else if (this.monitoring.all_meetings.some(function (meeting) {
        return !meeting.date;
      })) {
        __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default()({
          title: 'Atenção!',
          text: 'Por favor, preencha a data das reuniões adicionadas.',
          type: 'error',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false,
          allowOutsideClick: false
        }).catch(__WEBPACK_IMPORTED_MODULE_25_sweetalert2___default.a.noop);
      } else {
        this.registerMonitoringMeeting();
      }
    },
    registerMonitoringMeeting: function registerMonitoringMeeting() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default()({
        title: 'Você tem certeza?',
        html: 'A reunião de acomanhamento será encerrada.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Finalizar Acompanhamento',
        buttonsStyling: false,
        preConfirm: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var originalGoalsMap, goalsWithVariation, payload, url;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    originalGoalsMap = _this9.originalGoals.reduce(function (acc, goal) {
                      acc[goal.id] = goal;
                      return acc;
                    }, {});
                    goalsWithVariation = _this9.monitoringGoals.map(function (goal) {
                      var original = originalGoalsMap[goal.id] || {};
                      var variation = (goal.progress != null ? goal.progress : 0) - (original.progress != null ? original.progress : 0);

                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, goal, {
                        progress_variation: variation
                      });
                    });
                    payload = {
                      goals: goalsWithVariation,
                      monitoring: _this9.monitoring
                    };
                    url = '/collaborator/manager/register-monitoring-meeting';
                    _context.next = 6;
                    return axios.post(url, payload).catch(function (error) {
                      var message = 'Não foi possível completa requisição, tente novamente mais tarde.';
                      if (error.response.status !== 500) {
                        message = error.response.data.error;
                      }
                      __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default.a.showValidationError(message);
                      return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                        reject(new Error(message));
                      });
                    });

                  case 6:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this9);
          }));

          return function preConfirm() {
            return _ref.apply(this, arguments);
          };
        }()
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default()({
          title: 'Acompanhamento!',
          text: 'A Reunião de Acompanhamento foi registrada com sucesso!',
          type: 'success',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false,
          allowOutsideClick: false,
          preConfirm: function preConfirm() {
            return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve('OK');
            });
          }
        }).then(function () {
          _this9.updateDevelopmentPlanView();
        });
      }).catch(__WEBPACK_IMPORTED_MODULE_25_sweetalert2___default.a.noop);
    },
    validDevelopmentPlan: function validDevelopmentPlan() {
      var goals = this.developmentPlan.action_plan_goals || [];
      var hasInvalidGoal = goals.some(function (goal) {
        return !goal.goal || !goal.strategy || !goal.due_date;
      });
      if (!!this.developmentPlan.evaluation_id && !!this.developmentPlan.development_plan_id && !!this.developmentPlan.action_plan_objective && !!this.developmentPlan.identified_improvement_areas && !!this.developmentPlan.action_plan_goals && !!this.developmentPlan.start_date && !!this.developmentPlan.end_date && this.developmentPlan.success_indicators.length !== 0 && this.developmentPlan.monitoring_meetings.length > 0 && this.developmentPlan.monitoring_meetings.every(function (meeting) {
        return !!meeting.date;
      }) && !hasInvalidGoal) {
        this.saveDevelopmentPlan();
      } else {
        __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default()({
          title: 'Plano de Ação!',
          text: 'Preencha todo os campos (*) obrigatórios.',
          type: 'error',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false,
          allowOutsideClick: false
        }).catch(__WEBPACK_IMPORTED_MODULE_25_sweetalert2___default.a.noop);
      }
    },
    saveDevelopmentPlan: function saveDevelopmentPlan() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default()({
        title: 'Você tem certeza!',
        html: 'Plano de Ação será atualizado.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Atualizar Plano de Ação',
        buttonsStyling: false,
        preConfirm: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var url;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    url = '/collaborator/manager/collaborator-evaluation-plan';
                    _context2.next = 3;
                    return axios.put(url, _this10.developmentPlan).catch(function (error) {
                      var message = 'Não foi possível completa requisição, tente novamente mais tarde.';
                      if (error.response.status !== 500) {
                        message = error.response.data.error;
                      }
                      __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default.a.showValidationError(message);
                      return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                        reject(new Error(message));
                      });
                    });

                  case 3:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this10);
          }));

          return function preConfirm() {
            return _ref2.apply(this, arguments);
          };
        }()
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default()({
          title: 'Plano de Ação!',
          text: 'Plano de Ação foi atualizado com sucesso.',
          type: 'success',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false,
          allowOutsideClick: false,
          preConfirm: function preConfirm() {
            return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve('OK');
            });
          }
        }).then(function () {
          _this10.updateDevelopmentPlanView();
        });
      }).catch(__WEBPACK_IMPORTED_MODULE_25_sweetalert2___default.a.noop);
    },
    updateDevelopmentPlanView: function updateDevelopmentPlanView() {
      this.getResultEvaluation();
      this.handleStep('index');
    },
    openProfile: function openProfile() {
      this.$router.push('/avaliacao/equipe/perfil/' + this.collaboratorId);
    },
    percentColor: function percentColor(percent) {
      var classColor = 'success';

      if (percent >= 0 && percent < 40) {
        classColor = 'danger';
      } else if (percent >= 40 && percent < 80) {
        classColor = 'warning';
      }
      return classColor;
    },
    percentTotalColor: function percentTotalColor(percent) {
      var color = 'green';

      if (percent >= 0 && percent < 40) {
        color = 'red';
      }

      if (percent >= 40 && percent < 80) {
        color = 'orange';
      }

      return color;
    },
    handleStep: function handleStep(step) {
      switch (step) {
        case 'index':
          this.steps.index = true;
          this.steps.update = false;
          this.steps.monitoring = false;
          break;
        case 'update':
          this.steps.index = false;
          this.steps.update = true;
          this.steps.monitoring = false;
          break;
        case 'monitoring':
          this.steps.index = false;
          this.steps.update = false;
          this.steps.monitoring = true;
          break;
      }
    },
    translateStatus: function translateStatus(status) {
      var translations = {
        pending: 'Pendente',
        in_progress: 'Em Andamento',
        at_risk: 'Em Risco',
        completed: 'Concluído',
        overdue: 'Atrasado'
      };
      return translations[status] || status;
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '';

      var _dateStr$split = dateStr.split(' '),
          _dateStr$split2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_dateStr$split, 1),
          datePart = _dateStr$split2[0];

      var _datePart$split$map = datePart.split('-').map(Number),
          _datePart$split$map2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_datePart$split$map, 3),
          year = _datePart$split$map2[0],
          month = _datePart$split$map2[1],
          day = _datePart$split$map2[2];

      var date = new Date(year, month - 1, day);

      return date.toLocaleDateString('pt-BR');
    },
    formatTooltip: function formatTooltip(val) {
      return val + '%';
    },
    addMeetingDate: function addMeetingDate(step) {
      var _this11 = this;

      var meetings = step.update ? this.developmentPlan.monitoring_meetings : this.monitoring.all_meetings;

      if (!this.canAddNewMeetingDate) return;

      meetings.push({ date: '', status: false });
      this.$nextTick(function () {
        _this11.updateMeetingAvailability(step);
      });
    },
    removeMeetingDate: function removeMeetingDate(index, step) {
      var _this12 = this;

      var meetings = step.update ? this.developmentPlan.monitoring_meetings : this.monitoring.all_meetings;

      if (meetings.length > 1) {
        meetings.splice(index, 1);
        this.$nextTick(function () {
          _this12.updateMeetingAvailability(step);
        });
      }
    },
    getMeetingDatePickerOptions: function getMeetingDatePickerOptions(index, step) {
      var _this13 = this;

      return {
        disabledDate: function disabledDate(date) {
          var start = void 0;
          var end = void 0;
          if (step.update) {
            start = _this13.developmentPlan.start_date ? new Date(_this13.developmentPlan.start_date) : null;
            end = _this13.developmentPlan.end_date ? new Date(_this13.developmentPlan.end_date) : null;
          }
          if (step.monitoring) {
            start = _this13.resultEvaluation.plan.start_date ? new Date(_this13.resultEvaluation.plan.start_date) : null;
            end = _this13.resultEvaluation.plan.end_date ? new Date(_this13.resultEvaluation.plan.end_date) : null;
          }

          if (!start || !end) return true;
          var minDate = new Date(start);
          if (index > 0) {
            var prevMeeting = void 0;
            if (step.update) {
              prevMeeting = _this13.developmentPlan.monitoring_meetings[index - 1];
            }
            if (step.monitoring) {
              prevMeeting = _this13.monitoring.all_meetings[index - 1];
            }
            var prevMeetingDate = prevMeeting ? prevMeeting.date : null;

            if (prevMeetingDate) {
              minDate = new Date(prevMeetingDate);
            }
          }
          minDate.setDate(minDate.getDate() + 15);

          var currentDate = new Date(date);

          return currentDate < minDate || currentDate > end;
        }
      };
    },
    prevMeeting: function prevMeeting() {
      if (this.currentMeetingIndex > 0) {
        this.slideDirection = 'slide-right';
        this.currentMeetingIndex--;
      }
    },
    nextMeeting: function nextMeeting() {
      if (this.currentMeetingIndex < this.pastMeetings.length - 1) {
        this.slideDirection = 'slide-left';
        this.currentMeetingIndex++;
      }
    },
    goToMeeting: function goToMeeting(index) {
      if (index !== this.currentMeetingIndex) {
        this.slideDirection = index > this.currentMeetingIndex ? 'slide-left' : 'slide-right';
        this.currentMeetingIndex = index;
      }
    },
    updateMeetingAvailability: function updateMeetingAvailability(step) {
      var start = step.update ? this.developmentPlan.start_date : this.resultEvaluation.plan.start_date;
      var end = step.update ? this.developmentPlan.end_date : this.resultEvaluation.plan.end_date;

      var meetings = step.update ? this.developmentPlan.monitoring_meetings : this.monitoring.all_meetings;

      if (!start || !end) {
        this.noMeetingDateAvailable = true;
        return;
      }

      var filledMeetings = meetings.filter(function (m) {
        return !!m.date && m.status !== 1;
      });
      var baseDate = filledMeetings.length > 0 ? new Date(filledMeetings[filledMeetings.length - 1].date) : new Date(start);
      baseDate.setDate(baseDate.getDate() + 15);

      if (baseDate >= new Date(end)) {
        this.noMeetingDateAvailable = true;

        var remaining = meetings.filter(function (m) {
          return !!m.date || m.status === 1;
        });
        if (remaining.length === 0) {
          remaining.push({ date: '', status: false });
        }

        if (step.update) {
          this.developmentPlan.monitoring_meetings = remaining;
        } else {
          this.monitoring.all_meetings = remaining;
        }
      } else {
        this.noMeetingDateAvailable = false;
      }
    },
    clearAllDates: function clearAllDates(value) {
      if (!value) {
        this.developmentPlan.end_date = '';
        this.developmentPlan.action_plan_goals.forEach(function (goal) {
          goal.due_date = '';
        });
        this.developmentPlan.monitoring_meetings.forEach(function (meeting) {
          if (meeting.status !== 1) {
            meeting.date = '';
          }
        });
        var nonEmpty = this.developmentPlan.monitoring_meetings.filter(function (meeting) {
          return !!meeting.date || meeting.status === 1;
        });

        this.developmentPlan.monitoring_meetings = nonEmpty.length > 0 ? nonEmpty : [{ date: '', status: 0 }];

        this.updateMeetingAvailability(this.steps);
      }
    }
  },
  watch: {
    'developmentPlan.end_date': function developmentPlanEnd_date(newDate) {
      var _this14 = this;

      if (!newDate) return;

      var endDate = new Date(newDate);

      this.developmentPlan.monitoring_meetings.forEach(function (meeting) {
        if (meeting.status !== 1 && meeting.date) {
          var meetingDate = new Date(meeting.date);

          if (meetingDate > endDate) {
            meeting.date = null;
          }
        }
      });

      this.$nextTick(function () {
        _this14.updateMeetingAvailability(_this14.steps);
      });
    },
    'developmentPlan.start_date': function developmentPlanStart_date() {
      var _this15 = this;

      this.$nextTick(function () {
        _this15.updateMeetingAvailability(_this15.steps);
      });
    },
    monitoringMeetingSignatureStepUpdate: function monitoringMeetingSignatureStepUpdate() {
      if (this.steps.update) {
        this.updateMeetingAvailability(this.steps);
      }
    },
    monitoringMeetingSignatureStepMonitoring: function monitoringMeetingSignatureStepMonitoring() {
      if (this.steps.monitoring) {
        this.updateMeetingAvailability(this.steps);
      }
    }
  }
});

/***/ }),

/***/ "PsJg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QR3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkAccessUser())?_c('div',[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card card-power-university"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Power University")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("by Microsoft")]),_vm._v(" "),_c('img',{staticClass:"logo-power-university",attrs:{"src":"static/img/logo_power_university.png","alt":"Power University by Microsoft"}})]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"padding-bottom":"5px"}},[_c('a',{staticClass:"btn btn-primary btn-fill btn-wd",attrs:{"href":"https://forms.office.com/r/AnFYqTyj3Q","target":"_blank"}},[_c('i',{staticClass:"fa fa-check-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" Termo de compromisso\n              ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"5px"}},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"text-center"},[_vm._v("Iniciar jornada na Plataforma Microsoft")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('a',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"href":"static/pdf/Power_University_Trilhas.pdf","target":"_blank"}},[_c('i',{staticClass:"fa fa-list-ul",attrs:{"aria-hidden":"true"}}),_vm._v(" Trilhas\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('a',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"href":"static/pdf/Power_University_Certificacao_ESI.pdf","target":"_blank"}},[_c('i',{staticClass:"fa fa-certificate",attrs:{"aria-hidden":"true"}}),_vm._v(" Certificação ESI\n              ")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6211352a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("aidk");
function injectStyle (ssrContext) {
  __webpack_require__("h7Kw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6211352a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R7LH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RAFT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RPnc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationAnswer_vue__ = __webpack_require__("nVWP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_065754c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationAnswer_vue__ = __webpack_require__("kFOG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationAnswer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_065754c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationAnswer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RZp6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S355":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.statsCards),function(stats){return _c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-left",class:("icon-" + (stats.type)),attrs:{"slot":"header"},slot:"header"},[_c('img',{staticClass:"logo_brasal_a",attrs:{"src":"static/img/logo_brasal_c.png","alt":"Brasal"}})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('img',{staticClass:"logo_ad_ra",attrs:{"src":"static/img/logo.png","alt":"Avaliação de Desempenho"}})]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 comp"},[_vm._v("\n\n              A avaliação de desempenho por competências tem um papel fundamental dentro das empresas: identificar colaboradores que precisam ser desligados ou desenvolvidos e destacar pontos positivos e talentos na organização."),_c('br'),_c('br'),_vm._v("\n\nEla é utilizada pelas empresas para analisar o desempenho de cada colaborador, determinando se ele é o mais qualificado para sua função e os possíveis pontos de melhorias em sua performance."),_c('br'),_c('br'),_vm._v("\n\nNormalmente essa qualificação dos colaboradores é determinada pelos seus conhecimentos, habilidades e atitudes (CHA), ou seja, suas competências. Mas se vamos falar em competências, primeiro precisamos saber quais são os diferentes tipos de competências. São elas:"),_c('br'),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("Técnicas")]),_c('br'),_vm._v(" são os conhecimentos e habilidades adquiridos por uma pessoa através da educação formal e não formal, como treinamentos, cursos, palestras etc."),_c('br'),_c('br')]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Comportamentais")]),_c('br'),_vm._v(" são as atitudes e os comportamentos de uma pessoa em ambiente social ou empresarial, definidos por sua personalidade."),_c('br'),_c('br')]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Gerenciais")]),_c('br'),_vm._v(" são as competências essenciais que um gestor deve ter para conseguir gerir o desenvolvimento de si, dos colaboradores e da empresa."),_c('br'),_c('br')]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Organizacionais")]),_c('br'),_vm._v(" são todas as competências que formam a identidade e o diferencial competitivo de uma corporação."),_c('br'),_c('br')])]),_vm._v("\n\nFazer a avaliação de desempenho é importante para uma empresa conhecer a si mesma e aos seus colaboradores. Ao fazer essa avaliação baseada em competências, uma organização pode alcançar resultados melhores. Neste artigo, nós vamos te mostrar o que é avaliação de desempenho por competências e quais são os benefícios dela para uma empresa."),_c('br'),_c('br'),_vm._v(" "),_c('h4',[_vm._v("O que é Avaliação de Desempenho por Competências?")]),_c('br'),_vm._v("\nAvaliação de Desempenho por Competências é uma análise sistemática do desempenho de cada colaborador em uma empresa. Ela mensura a contribuição de cada pessoa a partir da relação entre o desempenho profissional e as competências essenciais para cumprir sua função."),_c('br'),_c('br'),_vm._v("\n\nSabemos que tudo aquilo que não pode ser avaliado, não pode ser mensurado e, se não pode ser mensurado, não pode ser melhorado. Além da avaliação de desempenho por competências, dentro do ambiente empresarial existem outros tipos de avaliação de desempenho, como a avaliação de desempenho por objetivos."),_c('br'),_c('br'),_vm._v("\n\nNo passado a avaliação de desempenho por objetivos era muito presente dentro das empresas. Este modelo visava avaliar o desempenho dos colaboradores por meio do atingimento de suas metas ou objetivos previamente acordados com o gestor."),_c('br'),_c('br'),_vm._v("\n\n\nAtualmente, muitas empresas estão aderindo à avaliação de desempenho por competências, pois ela mensura o desempenho de cada colaborador junto com as competências que são desejadas pelas organizações."),_c('br'),_c('br'),_vm._v("\n\nNeste formato, avalia-se não somente as metas e objetivos, mas também as competências técnicas, comportamentais e gerenciais, além de encontrar as necessidades de desenvolvimento dos colaboradores. Quando aplicada em uma empresa, a avaliação de desempenho por competências maximiza a produtividade e o desenvolvimento de cada colaborador, proporcionando alinhamento com os objetivos organizacionais."),_c('br'),_c('br'),_vm._v("\n\nPortanto, a avaliação de desempenho por competências cumpre um papel essencial no planejamento estratégico de pessoas em uma empresa por ser mais abrangente. "),_c('br'),_c('br')])])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S4NR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5"},[_c('user-card'),_vm._v(" "),_c('members-card')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-7"},[_c('competencias-card'),_vm._v(" "),_c('power-university')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SEJS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");




/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.getAccessCodes();
  },

  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      accessCodes: [],
      statsCards: []
    };
  },

  methods: {
    getAccessCodes: function getAccessCodes() {
      var _this = this;

      var url = '/collaborator/my-access-code-evaluations';
      axios.get(url).then(function (response) {
        _this.accessCodes = response.data;
        _this.generateCards();
      }).catch(function (error) {
        console.log(error);
      });
    },
    generateCards: function generateCards() {
      var statsCards = [];
      this.accessCodes.forEach(function (accessCode) {
        switch (accessCode.evaluation_type_id) {
          case 1:
            statsCards.push({
              type: 'danger',
              icon: 'ti-ticket',
              title: 'Código Verificador',
              value: accessCode.code,
              compText1: 'Apresente este código verificador ao seu gestor imediato para que o mesmo consiga realizar sua Avaliação de Desempenho',
              compGrade1: accessCode.name + ' - Avalia\xE7\xE3o de Desempenho'
            });
            break;
          case 2:
            statsCards.push({
              type: 'success',
              icon: 'ti-ticket',
              title: 'Código Verificador',
              value: accessCode.code,
              compText1: 'Apresente este código verificador ao seu gestor imediato para que o mesmo consiga realizar sua Avaliação de Desempenho "Me Avalie Aí"',
              compGrade1: accessCode.name + ' - Avalia\xE7\xE3o Me Avalie A\xED'
            });
            break;
        }
      });

      this.statsCards = statsCards;
    }
  }
});

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Views_Pages_Auth_Login_vue__ = __webpack_require__("sc3x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Pages_Support_vue__ = __webpack_require__("49yH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Views_Pages_UserProfile_vue__ = __webpack_require__("9gNx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_Views_Pages_UserProfile_EditProfileForm_vue__ = __webpack_require__("9597");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_Views_Pages_PowerUniversity_vue__ = __webpack_require__("pdK0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_Views_Pages_Evaluation_About_vue__ = __webpack_require__("x+NG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Dashboard_Views_Pages_Evaluation_Overview_vue__ = __webpack_require__("IWTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Dashboard_Views_Pages_Evaluation_List_vue__ = __webpack_require__("8pqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_Views_Pages_Evaluation_Code_vue__ = __webpack_require__("wzXt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Dashboard_Views_Pages_Evaluation_Position_vue__ = __webpack_require__("7zM9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Dashboard_Views_Pages_Manager_Evaluation_Team_List_vue__ = __webpack_require__("ICPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Dashboard_Views_Pages_Manager_Evaluation_Team_View_vue__ = __webpack_require__("yMN2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Dashboard_Views_Pages_Manager_Evaluation_Team_Overview_vue__ = __webpack_require__("jr0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Dashboard_Views_Pages_Manager_Evaluation_Form_vue__ = __webpack_require__("gTxY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Dashboard_Views_Pages_Manager_Evaluation_FormEdit_vue__ = __webpack_require__("ohNq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Dashboard_Views_Pages_Manager_Evaluation_FormResult_vue__ = __webpack_require__("8ooc");

























var loginPage = {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Views_Pages_Auth_Login_vue__["a" /* default */]
};

var supportPage = {
  path: '/suporte',
  name: 'Suporte',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Pages_Support_vue__["a" /* default */]
};

var profilePage = {
  path: '/perfil',
  name: 'Perfil',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Views_Pages_UserProfile_vue__["a" /* default */]
};

var profileEditPage = {
  path: '/editar-perfil',
  name: 'Editar Perfil',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_Views_Pages_UserProfile_EditProfileForm_vue__["a" /* default */]
};

var evaluationPage = {
  path: '/sobre',
  name: 'Sobre',
  component: __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_Views_Pages_Evaluation_About_vue__["a" /* default */]
};

var powerUniversityPage = {
  path: '/power-university',
  name: 'Power University',
  component: __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_Views_Pages_PowerUniversity_vue__["a" /* default */],
  meta: {
    requiresAccessPowerUniversity: true,
    requiresManager: true
  }
};

var evaluationListPage = {
  path: 'listar',
  name: 'Minhas Avaliações',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Dashboard_Views_Pages_Evaluation_List_vue__["a" /* default */]
};

var evaluationCodePage = {
  path: 'codigos',
  name: 'Códigos de Validação',
  component: __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_Views_Pages_Evaluation_Code_vue__["a" /* default */]
};

var evaluationPositionPage = {
  path: 'descritivo',
  name: 'Descritivo de Função',
  component: __WEBPACK_IMPORTED_MODULE_11__components_Dashboard_Views_Pages_Evaluation_Position_vue__["a" /* default */]
};

var evaluationOverviewPage = {
  path: 'resultado/:evaluationId',
  name: 'Visão geral da Avaliação',
  component: __WEBPACK_IMPORTED_MODULE_8__components_Dashboard_Views_Pages_Evaluation_Overview_vue__["a" /* default */]
};

var evaluationTeamListPage = {
  path: 'equipe',
  name: 'Minha Equipe',
  component: __WEBPACK_IMPORTED_MODULE_12__components_Dashboard_Views_Pages_Manager_Evaluation_Team_List_vue__["a" /* default */],
  meta: {
    requiresManager: true
  }
};

var evaluationTeamViewPage = {
  path: 'equipe/perfil/:collaboratorId',
  name: 'Perfil do Colaborador',
  component: __WEBPACK_IMPORTED_MODULE_13__components_Dashboard_Views_Pages_Manager_Evaluation_Team_View_vue__["a" /* default */],
  meta: {
    requiresManager: true
  }
};

var evaluationTeamOverviewPage = {
  path: 'equipe/perfil/:collaboratorId/resultado-completo/:evaluationId',
  name: 'Visão Geral',
  component: __WEBPACK_IMPORTED_MODULE_14__components_Dashboard_Views_Pages_Manager_Evaluation_Team_Overview_vue__["a" /* default */],
  meta: {
    requiresManager: true
  }
};

var evaluationTeamFormPage = {
  path: 'formulario/:collaboratorId/:evaluationId/:token',
  name: 'Formulário de Avaliação',
  component: __WEBPACK_IMPORTED_MODULE_15__components_Dashboard_Views_Pages_Manager_Evaluation_Form_vue__["a" /* default */],
  meta: {
    requiresManager: false
  }
};

var evaluationTeamFormEditPage = {
  path: 'formulario-editar/:evaluationId/:collaboratorId',
  name: 'Formulário de Av. - Edição',
  component: __WEBPACK_IMPORTED_MODULE_16__components_Dashboard_Views_Pages_Manager_Evaluation_FormEdit_vue__["a" /* default */],
  meta: {
    requiresManager: true
  }
};

var evaluationFormResultPage = {
  path: 'formulario-resultado/:evaluationId/:collaboratorId',
  name: 'Resultado da Avaliação',
  component: __WEBPACK_IMPORTED_MODULE_17__components_Dashboard_Views_Pages_Manager_Evaluation_FormResult_vue__["a" /* default */],
  meta: {
    requiresManager: true
  }
};

var evaluation = {
  path: '/avaliacao',
  redirect: '/sobre',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [evaluationOverviewPage, evaluationListPage, evaluationCodePage, evaluationTeamListPage, evaluationTeamViewPage, evaluationTeamOverviewPage, evaluationTeamFormPage, evaluationTeamFormEditPage, evaluationFormResultPage],
  meta: {
    requiresAuth: true
  }
};

var routes = [loginPage, supportPage, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/perfil',
  children: [profilePage, profileEditPage, powerUniversityPage],
  meta: {
    requiresAuth: true
  }
}, evaluation, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_3__UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_4__UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */]
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "VMtB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingSpin_vue__ = __webpack_require__("aZhL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7322256e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingSpin_vue__ = __webpack_require__("qCYM");
function injectStyle (ssrContext) {
  __webpack_require__("BKfn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingSpin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7322256e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingSpin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "Vr89":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vzbv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);











/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.evaluationId = this.$route.params.evaluationId;
    this.getResultEvaluation();
  },

  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    PProgress: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Progress_vue__["a" /* default */]
  },
  data: function data() {
    return {
      evaluationId: null,
      resultEvaluation: {},
      currentMeetingIndex: 0
    };
  },

  filters: {
    formatDateBr: function formatDateBr(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format('DD/MM/YYYY');
    }
  },
  methods: {
    getResultEvaluation: function getResultEvaluation() {
      var _this = this;

      var url = '/collaborator/result-evaluation/' + this.evaluationId;
      axios.get(url).then(function (res) {
        _this.resultEvaluation = res.data;

        console.log('resultEvaluation.open_answer');
        console.log(_this.resultEvaluation.open_anwswer);
      }).catch(function (error) {
        var message = 'Não foi possível completa requisição, tente novamente mais tarde.';

        if (error.response.status !== 500) {
          message = error.response.data.error;
        }

        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
          title: 'Avaliação!',
          text: message,
          type: 'error',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'Voltar',
          buttonsStyling: false,
          allowOutsideClick: false,
          preConfirm: function preConfirm() {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve('OK');
            });
          }
        }).then(function () {
          _this.$router.push('/avaliacao/listar');
        }).catch(__WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.noop);
      });
    },
    percentColor: function percentColor(percent) {
      var classColor = 'success';

      if (percent >= 0 && percent < 40) {
        classColor = 'danger';
      } else if (percent >= 40 && percent < 80) {
        classColor = 'warning';
      }
      return classColor;
    },
    percentTotalColor: function percentTotalColor(percent) {
      var color = 'green';

      if (percent >= 0 && percent < 40) {
        color = 'red';
      }

      if (percent >= 40 && percent < 80) {
        color = 'orange';
      }

      return color;
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '';

      var _dateStr$split = dateStr.split(' '),
          _dateStr$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_dateStr$split, 1),
          datePart = _dateStr$split2[0];

      var _datePart$split$map = datePart.split('-').map(Number),
          _datePart$split$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_datePart$split$map, 3),
          year = _datePart$split$map2[0],
          month = _datePart$split$map2[1],
          day = _datePart$split$map2[2];

      var date = new Date(year, month - 1, day);

      return date.toLocaleDateString('pt-BR');
    },
    translateStatus: function translateStatus(status) {
      var translations = {
        pending: 'Pendente',
        in_progress: 'Em Andamento',
        at_risk: 'Em Risco',
        completed: 'Concluído',
        overdue: 'Atrasado'
      };
      return translations[status] || status;
    },
    formatNextMonitoring: function formatNextMonitoring(nextMonitoring) {
      console.log('nextMonitoring', nextMonitoring);
      if (!nextMonitoring) {
        return 'NÃO AGENDADA';
      }
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      var year = today.getFullYear();
      var month = String(today.getMonth() + 1).padStart(2, '0');
      var day = String(today.getDate()).padStart(2, '0');

      var formattedToday = year + '-' + month + '-' + day;

      console.log('nextMonitoring.date', nextMonitoring.date);
      console.log('formattedToday', formattedToday);

      if (nextMonitoring.date === formattedToday) {
        return 'HOJE';
      } else {
        return this.formatDate(nextMonitoring.date);
      }
    },
    prevMeeting: function prevMeeting() {
      if (this.currentMeetingIndex > 0) {
        this.slideDirection = 'slide-right';
        this.currentMeetingIndex--;
      }
    },
    nextMeeting: function nextMeeting() {
      if (this.currentMeetingIndex < this.pastMeetings.length - 1) {
        this.slideDirection = 'slide-left';
        this.currentMeetingIndex++;
      }
    },
    goToMeeting: function goToMeeting(index) {
      if (index !== this.currentMeetingIndex) {
        this.slideDirection = index > this.currentMeetingIndex ? 'slide-left' : 'slide-right';
        this.currentMeetingIndex = index;
      }
    }
  },
  computed: {
    pastMeetings: function pastMeetings() {
      return this.resultEvaluation.plan.monitoring_meetings.filter(function (m) {
        return m.status === 1 || m.status === 2;
      }).sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });
    },
    currentPastMeeting: function currentPastMeeting() {
      return this.pastMeetings[this.currentMeetingIndex];
    }
  }
});

/***/ }),

/***/ "WFzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__ = __webpack_require__("x/a9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7797e692_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__ = __webpack_require__("wz5Z");
function injectStyle (ssrContext) {
  __webpack_require__("J/HH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7797e692_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X+ky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X5Wu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XPMo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XXU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  data: function data() {
    return {
      isClosed: true
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    logoutUser: function logoutUser() {
      this.$store.commit('logout');
      this.$router.push('/login');
    },
    firstName: function firstName() {
      var name = this.currentUser.name.split(' ');
      return name[0];
    },
    openForms: function openForms() {
      window.open('https://forms.office.com/r/KCTMGsuk42', '_blank');
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  }
});

/***/ }),

/***/ "Xpan":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y3o5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["b"] = setAuthorization;
/* unused harmony export verifyManagerEmail */
/* unused harmony export validCPF */
/* unused harmony export getNumber */
/* harmony export (immutable) */ __webpack_exports__["d"] = readOrientation;
/* harmony export (immutable) */ __webpack_exports__["c"] = checkAccessPowerUniversity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__("H/Zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_trafficSystem__ = __webpack_require__("kB3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);






function initialize(store, router) {
  router.beforeEach(function (to, from, next) {
    var requiresAuth = to.matched.some(function (record) {
      return record.meta.requiresAuth;
    });
    var requiresManager = to.matched.some(function (record) {
      return record.meta.requiresManager;
    });
    var requiresAccessPowerUniversity = to.matched.some(function (record) {
      return record.meta.requiresAccessPowerUniversity;
    });
    var currentUser = store.state.currentUser;

    if (currentUser) {
      if (currentUser.is_manager && to.path !== '/editar-perfil') {
        verifyManagerEmail(currentUser, router);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__services_trafficSystem__["a" /* trafficSystem */])(to.path, router, store);
    }

    if (requiresAuth && !currentUser) {
      next('login');
    } else if (to.path == '/login' && currentUser) {
      next('/');
    } else if (requiresManager) {
      if (currentUser.is_manager) {
        if (requiresAccessPowerUniversity) {
          if (checkAccessPowerUniversity(currentUser)) {
            next();
          } else {
            next('/');
          }
        } else {
          next();
        }
      } else {
        next('/');
      }
    } else {
      next();
    }
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* setBaseURL */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_api__["b" /* setIntercept */])(store, router);

  if (store.getters.currentUser) {
    setAuthorization(store.getters.currentUser.token);
  }
}

function setAuthorization(token) {
  axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
}

function verifyManagerEmail(manager, router) {
  if (!manager.email) {
    __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
      title: 'Caro(a) Gestor(a)!',
      text: 'Por favor complementar seu cadastro com e-mail e telefone.',
      type: 'warning',
      showCancelButton: false,
      confirmButtonClass: 'btn btn-info btn-fill',
      confirmButtonText: 'OK',
      buttonsStyling: false,
      allowOutsideClick: false,
      preConfirm: function preConfirm() {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          resolve('OK');
        });
      }
    }).then(function () {
      router.push('/editar-perfil');
    }).catch(__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.noop);
  }
}

function validCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf == '') return false;

  if (cpf.length != 11 || cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" || cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" || cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") return false;

  var add = 0;
  for (var i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i);
  }var rev = 11 - add % 11;
  if (rev == 10 || rev == 11) rev = 0;
  if (rev != parseInt(cpf.charAt(9))) return false;

  add = 0;
  for (var i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i);
  }rev = 11 - add % 11;
  if (rev == 10 || rev == 11) ;
  rev = 0;
  if (rev != parseInt(cpf.charAt(10))) return false;
  return true;
}

function getNumber(str) {
  return str.replace(/[^0-9]/g, '');
}

function readOrientation(file) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var reader = new FileReader();

    reader.onload = function () {
      return resolve(function () {
        var view = new DataView(reader.result);

        if (view.getUint16(0, false) !== 0xFFD8) {
          return;
        }

        var length = view.byteLength;
        var offset = 2;

        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xFFE1) {
            offset += 2;

            if (view.getUint32(offset, false) !== 0x45786966) {
              return;
            }

            offset += 6;
            var little = view.getUint16(offset, false) === 0x4949;

            offset += view.getUint32(offset + 4, little);

            var tags = view.getUint16(offset, little);

            offset += 2;

            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return view.getUint16(offset + i * 12 + 8, little);
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
      }());
    };

    reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
  });
}

function checkAccessPowerUniversity(user) {
  var companyCods = ['60.000.001'];
  var userCompanyCod = user.position.department.company.cod;

  return companyCods.includes(userCompanyCod);
}

/***/ }),

/***/ "YU9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    collaborator: [Object]
  },
  data: function data() {
    return {};
  },

  filters: {
    formatDateBr: function formatDateBr(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY');
    }
  },
  methods: {}
});

/***/ }),

/***/ "Z450":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-progress',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    value: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    values: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),

/***/ "ZBtw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"div",class:[_vm.getSlideClass, {open:_vm.isOpen}],on:{"click":_vm.toggleDropDown}},[_vm._t("title",[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c35c38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("ZBtw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c35c38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a3kA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a9Ek":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aCDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "aZhL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: 'spinner'
    },
    check: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loadingClass: function loadingClass() {
      return 'fa-' + this.type;
    }
  }
});

/***/ }),

/***/ "ag0+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  }
});

/***/ }),

/***/ "aidk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_vm._m(0),_vm._v(" "),_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_vm._t("default"),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._t("links",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkAccess(link)),expression:"checkAccess(link)"}],key:link.name + index,attrs:{"link":link}},_vm._l((link.children),function(subLink,index){return _c('sidebar-item',{key:subLink.name + index,attrs:{"link":subLink}})}),1)}))],2)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",staticStyle:{"padding-top":"0px !important"}},[_c('a',{staticClass:"simple-text logo-normal",attrs:{"href":"/"}},[_c('img',{staticClass:"logo_menu",attrs:{"src":"/static/img/logo_branca_2025.png","alt":"Avaliação de Desempenho"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "azot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-gestor"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"list-unstyled team-members"},[((_vm.currentUser.manager.hasOwnProperty('name')))?_c('li',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive img-gestor",attrs:{"src":_vm.currentUser.manager.avatar_url,"alt":_vm.currentUser.manager.name}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-9 n-gestor"},[_vm._v("\n            "+_vm._s(_vm.currentUser.manager.name)+"\n            "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-success"},[_c('small',[_vm._v(_vm._s(_vm.currentUser.manager.position))])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.evaluationMe)?_c('button',{staticClass:"btn btn-wd btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.toEvaluateMe()}}},[_vm._m(0),_vm._v("Me avalia aí\n            ")]):_vm._e()])])]):_c('li',{staticClass:"text-center"},[_c('strong',[_vm._v("Entre em contato com o seu gestor.")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-thumbs-up"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_879b8aa4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("6V8M");
function injectStyle (ssrContext) {
  __webpack_require__("u3/v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_879b8aa4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cDSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cubp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resultEvaluation)?_c('div',{staticClass:"resultado_avaliacao"},[_c('h4',{staticClass:"title",staticStyle:{"margin-bottom":"25px"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.evaluation_cycle_name)+" - "+_vm._s(_vm.resultEvaluation.evaluation_type_name)+" "),_c('small',[_vm._v(_vm._s(_vm._f("formatDateBr")(_vm.resultEvaluation.evaluation_cycle_start_date))+"\n      - "+_vm._s(_vm._f("formatDateBr")(_vm.resultEvaluation.evaluation_cycle_end_date)))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content desc_member"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-xs-4"},[_c('div',{staticClass:"avatar img_member"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":_vm.resultEvaluation.collaborator.avatar_url,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-xs-8"},[_c('div',{staticClass:"pull-left name_member"},[_c('span',[_vm._v("\n                  "+_vm._s(_vm.resultEvaluation.collaborator.name)+"\n                ")]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.position.name))]),_vm._v(" "),_c('br')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('circle-chart-card',{attrs:{"percentage":_vm.resultEvaluation.final_result,"title":"RESULTADO FINAL","description":_vm.resultEvaluation.evaluation_type_name,"color":_vm.percentTotalColor(_vm.resultEvaluation.final_result)}})],1),_vm._v(" "),(!_vm.resultEvaluation.blocked)?_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":_vm.resultEvaluation.total_skill_percent,"title":"COMPETÊNCIAS","color":_vm.percentTotalColor(_vm.resultEvaluation.total_skill_percent)}})],1):_vm._e(),_vm._v(" "),(!_vm.resultEvaluation.blocked)?_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":_vm.resultEvaluation.delivery_percent,"title":"ENTREGA","color":_vm.percentTotalColor(_vm.resultEvaluation.delivery_percent)}})],1):_vm._e()]),_vm._v(" "),(!_vm.resultEvaluation.blocked)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-package"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"category"},[_vm._v("COMPETÊNCIAS")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},_vm._l((_vm.resultEvaluation.skills),function(skill,index){return _c('div',{key:("skill-" + index)},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-10 comp"},[_vm._v("\n                "+_vm._s(skill.name)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 grade_comp"},[_vm._v("\n                "+_vm._s(skill.percent)+"%\n              ")])]),_vm._v(" "),_c('p-progress',{attrs:{"value":skill.percent,"type":_vm.percentColor(skill.percent)}})],1)}),0)])],1)]):_vm._e(),_vm._v(" "),(!_vm.resultEvaluation.blocked && _vm.resultEvaluation.evaluation_type_id == 1)?_c('info-pdi-9box',{attrs:{"resultEvaluation":_vm.resultEvaluation}}):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.evaluation_type_id == 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card card-plano-acao"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[(_vm.steps.index)?_c('div',{staticClass:"col-lg-12 col-md-12"},[(_vm.resultEvaluation.plan)?_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":((_vm.resultEvaluation.plan.development_plan_name) + " | " + (_vm.translateStatus(_vm.resultEvaluation.plan.status))),"name":"1"}},[_c('div',{staticStyle:{"padding-top":"20px"}},[_c('i',{staticClass:"ti-calendar"}),_vm._v("  "),_c('b',[_vm._v("Data de Início:")]),_vm._v(" "+_vm._s(_vm._f("formatDateBr")(_vm.resultEvaluation.plan.start_date))),_c('br'),_vm._v(" "),_c('i',{staticClass:"ti-calendar"}),_vm._v("  "),_c('b',[_vm._v("Data de Término:")]),_vm._v(" "+_vm._s(_vm._f("formatDateBr")(_vm.resultEvaluation.plan.end_date))),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('i',{staticClass:"ti-ticket"}),_vm._v("  "),_c('b',[_vm._v("Competência:")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.resultEvaluation.plan.newSkills),function(skill){return _c('span',{staticStyle:{"font-size":"14px"}},[_c('u',[_vm._v(_vm._s(skill.skill && skill.skill.name ? skill.skill.name : skill.name))]),_c('br'),_vm._v("\n                        "+_vm._s(skill.skill && skill.skill.description ? skill.skill.description : skill.description)),_c('br'),_c('br')])}),_vm._v(" "),_c('br')],2),_vm._v(" "),(_vm.resultEvaluation.plan.description)?_c('div',[_c('i',{staticClass:"ti-clipboard"}),_vm._v("  "),_c('b',[_vm._v("Descrição:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.plan.description)+" ")]),_c('br')]):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.action_plan_objective)?_c('div',[_c('i',{staticClass:"ti-star"}),_vm._v("  "),_c('b',[_vm._v("Objetivo:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.plan.action_plan_objective)+" ")]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.identified_improvement_areas)?_c('div',[_c('i',{staticClass:"ti-bookmark"}),_vm._v("  "),_c('b',[_vm._v("Áreas de Melhoria:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.plan.identified_improvement_areas)+"\n                      ")]),_c('br')]):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.action_plan_goals_old)?_c('div',[_c('i',{staticClass:"ti-check-box"}),_vm._v("  "),_c('b',[_vm._v("Metas:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.plan.action_plan_goals_old)+" ")]),_c('br')]):(_vm.resultEvaluation.plan.action_plan_goals.length != 0)?_c('div',[_c('i',{staticClass:"ti-check-box"}),_vm._v("  "),_c('b',[_vm._v("Metas:")]),_c('br'),_vm._v(" "),_vm._l((_vm.resultEvaluation.plan.action_plan_goals),function(goal,index){return _c('div',{key:goal.id,staticClass:"goal",staticStyle:{"margin-top":"10px","margin-bottom":"15px"}},[_c('div',{staticClass:"goal-title"},[_c('span',{staticClass:"dot"},[_vm._v("•")]),_vm._v(" "),_c('b',[_vm._v("Meta "+_vm._s(index + 1))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.translateStatus(goal.status)))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goal.progress)+"%")])]),_vm._v(" "),_c('div',{staticClass:"goal-body"},[_c('div',{staticClass:"progress",staticStyle:{"margin-bottom":"10px","height":"5px"}},[_c('div',{staticClass:"progress-bar",style:('width: ' + goal.progress + '%;'),attrs:{"role":"progressbar","aria-valuenow":goal.progress,"aria-valuemin":"0","aria-valuemax":"100"}})]),_vm._v(" "),_c('b',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(goal.goal)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Estratégia:")]),_vm._v(" "+_vm._s(goal.strategy)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Prazo:")]),_vm._v(" "+_vm._s(_vm.formatDate(goal.due_date))+"\n                          ")])])})],2):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.strategies_to_reach_goals_old)?_c('div',[_c('i',{staticClass:"ti-list"}),_vm._v("  "),_c('b',[_vm._v("Estratégias para Alcançar as Metas:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(_vm.resultEvaluation.plan.strategies_to_reach_goals_old)+" ")]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.success_indicators && _vm.resultEvaluation.plan.success_indicators.length > 0)?_c('div',[_c('i',{staticClass:"ti-stats-up"}),_vm._v("  "),_c('b',[_vm._v("Indicadores de Sucesso:")]),_c('br'),_vm._v(" "),_vm._l((_vm.resultEvaluation.plan.success_indicators),function(successIndicator){return _c('div',[_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" - "+_vm._s(successIndicator.success_indicator.description)+"\n                        ")])])}),_c('br')],2):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.monitoring_meetings && _vm.resultEvaluation.plan.monitoring_meetings.length > 0)?_c('div',[_c('i',{staticClass:"ti-timer"}),_vm._v("  "),_c('b',[_vm._v("Acompanhamento:")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v("\n                        Próxima reunião: "+_vm._s(_vm.formatNextMonitoring(_vm.resultEvaluation.plan.next_monitoring, _vm.steps))+"\n                      ")]),_c('br'),_vm._v(" "),_c('i',{staticClass:"ti-agenda"}),_vm._v("  "),_c('b',[_vm._v("Histórico de Reuniões:")]),_c('br'),_vm._v(" "),(_vm.pastMeetings.length && _vm.pastMeetings.length > 0)?_c('div',{staticClass:"carousel-wrapper"},[_c('button',{staticClass:"nav-button left",attrs:{"disabled":_vm.currentMeetingIndex === 0},on:{"click":_vm.prevMeeting}},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.slideDirection,"mode":"out-in"}},[_c('div',{key:_vm.currentPastMeeting.id,staticClass:"carousel-card"},[_c('b',[_vm._v("Data:")]),_vm._v(" "+_vm._s(_vm.formatDate(_vm.currentPastMeeting.date))),_c('br'),_vm._v(" "),(_vm.currentPastMeeting.status === 2)?_c('div',[_c('span',[_vm._v("Reunião não realizada.")])]):_c('div',[_vm._l((_vm.currentPastMeeting.goal_progresses),function(goalProgress){return _c('div',[(goalProgress.progress_change > 0)?_c('div',[_c('i',{staticClass:"ti-arrow-up"}),_vm._v(" "),_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"green"}},[_vm._v(" + "+_vm._s(goalProgress.progress_change)+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])]):(goalProgress.progress_change == 0)?_c('div',[_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',[_vm._v(" + "+_vm._s(goalProgress.progress_change)+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])]):_c('div',[_c('i',{staticClass:"ti-arrow-down"}),_vm._v(" "),_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" - "+_vm._s(goalProgress.progress_change * (-1))+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])])])}),_vm._v(" "),_c('b',[_vm._v("Feedbacks:")]),_vm._v(" "+_vm._s(_vm.currentPastMeeting.feedbacks)),_c('br')],2)])]),_vm._v(" "),_c('button',{staticClass:"nav-button right",attrs:{"disabled":_vm.currentMeetingIndex >= _vm.pastMeetings.length - 1},on:{"click":_vm.nextMeeting}},[_c('i',{staticClass:"ti-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"carousel-indicators"},_vm._l((_vm.pastMeetings),function(meeting,index){return _c('span',{key:meeting.id,class:['indicator-dot', { active: index === _vm.currentMeetingIndex }],on:{"click":function($event){return _vm.goToMeeting(index)}}})}),0)],1):_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v("\n                        As reuniões de acompanhamento realizadas aparecerão aqui.\n                      ")]),_c('br'),_c('br')]):(_vm.resultEvaluation.plan.monitoring_frequencies.length > 0)?_c('div',[_c('i',{staticClass:"ti-timer"}),_vm._v("  "),_c('b',[_vm._v("Frequência de Monitoramento:")]),_c('br'),_vm._v(" "),_vm._l((_vm.resultEvaluation.plan.monitoring_frequencies),function(monitoringFrequency){return _c('div',[_c('div',{staticStyle:{"text-align":"justify"}},[_vm._v(" - "+_vm._s(monitoringFrequency.monitoring_frequency.description)+" ")])])}),_c('br')],2):_vm._e()])])],1):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.evaluation_cycle_active)?_c('div',{staticStyle:{"margin":"20px 0"}},[_c('button',{staticClass:"btn btn-wd btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleEdit(_vm.resultEvaluation.plan)}}},[_vm._m(1),_vm._v("\n                  Editar\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-warning",staticStyle:{"margin-left":"5px"},attrs:{"type":"button","disabled":!_vm.checkMonitoringByToday(_vm.resultEvaluation.plan.next_monitoring)},on:{"click":function($event){return _vm.handleMonitoring(_vm.resultEvaluation.plan)}}},[_vm._m(2),_vm._v("\n                  "+_vm._s(_vm.resultEvaluation.plan.next_monitoring ? (
                    _vm.checkMonitoringByToday(_vm.resultEvaluation.plan.next_monitoring) ? 'Iniciar Acompanhamento' : ("Próximo Acompanhamento: " + (_vm.formatDate(_vm.resultEvaluation.plan.next_monitoring.date)))
                  ) : 'Sem Acompanhamento Agendado')+"\n                ")])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.steps.update)?_c('div',{staticClass:"col-lg-12 col-md-12"},[(!!_vm.developmentPlanSelected.description)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"13px"}},[_c('blockquote',{staticStyle:{"font-style":"normal","font-size":"14px"}},[_vm._v("\n                    "+_vm._s(_vm.developmentPlanSelected.description)+"\n                  ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"13px"}},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"13px"}},[_vm._v("\n                  Caro(a) Gestor(a), favor levar em consideração abaixo o tempo necessário para o colaborador\n                  desenvolver a competência. Tempo mínimo do Plano de Ação: 20 dias.\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Data de Início*")]),_vm._v(" "),_c('div',[_c('el-date-picker',{attrs:{"format":"dd/MM/yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Selecione a data","picker-options":_vm.pickerOptionsStart,"disabled":_vm.atLeastOneMeetingHeld},on:{"change":_vm.clearAllDates},model:{value:(_vm.developmentPlan.start_date),callback:function ($$v) {_vm.$set(_vm.developmentPlan, "start_date", $$v)},expression:"developmentPlan.start_date"}})],1),_vm._v(" "),(_vm.atLeastOneMeetingHeld)?_c('div',{staticStyle:{"margin-top":"10px","font-size":"12px","color":"gray"}},[_c('span',[_vm._v("Não é possível alterar a data de início pois existem reuniões de acompanhamento já realizadas.")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Data de Término*")]),_vm._v(" "),_c('div',[_c('el-date-picker',{attrs:{"format":"dd/MM/yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Selecione a data","picker-options":_vm.pickerOptionsEnd},on:{"change":_vm.clearAllDates},model:{value:(_vm.developmentPlan.end_date),callback:function ($$v) {_vm.$set(_vm.developmentPlan, "end_date", $$v)},expression:"developmentPlan.end_date"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.resultEvaluation.plan.description)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Descrição*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.developmentPlan.description),expression:"developmentPlan.description"}],staticClass:"form-control",attrs:{"placeholder":"Descreva as atividades a serem executadas.","rows":"3","maxlength":"2000"},domProps:{"value":(_vm.developmentPlan.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.developmentPlan, "description", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Objetivo*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.developmentPlan.action_plan_objective),expression:"developmentPlan.action_plan_objective"}],staticClass:"form-control",attrs:{"placeholder":"Descreva os objetivos do plano de ação.","rows":"3","maxlength":"2000"},domProps:{"value":(_vm.developmentPlan.action_plan_objective)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.developmentPlan, "action_plan_objective", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Áreas de Melhoria*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.developmentPlan.identified_improvement_areas),expression:"developmentPlan.identified_improvement_areas"}],staticClass:"form-control",attrs:{"placeholder":"Informe onde o colaborador pode melhorar.","rows":"3","maxlength":"2000"},domProps:{"value":(_vm.developmentPlan.identified_improvement_areas)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.developmentPlan, "identified_improvement_areas", $event.target.value)}}})]),_vm._v(" "),(_vm.resultEvaluation.plan.action_plan_goals_old)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Metas*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.developmentPlan.action_plan_goals_old),expression:"developmentPlan.action_plan_goals_old"}],staticClass:"form-control",attrs:{"placeholder":"Descreva as metas do plano de ação.","rows":"3","maxlength":"2000"},domProps:{"value":(_vm.developmentPlan.action_plan_goals_old)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.developmentPlan, "action_plan_goals_old", $event.target.value)}}})]):(_vm.resultEvaluation.plan.action_plan_goals.length != 0)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                      Metas*\n                    ")]),_vm._v(" "),_vm._l((_vm.developmentPlan.action_plan_goals),function(goalItem,index){return _c('div',{key:index,staticClass:"well",staticStyle:{"padding":"15px","margin-bottom":"10px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Meta "+_vm._s(index + 1)+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(goalItem.goal),expression:"goalItem.goal"}],staticClass:"form-control",attrs:{"type":"text","placeholder":'Digite a meta ' + (index + 1),"maxlength":"200"},domProps:{"value":(goalItem.goal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(goalItem, "goal", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Prazo*")]),_vm._v(" "),_c('div',[_c('el-date-picker',{attrs:{"format":"dd/MM/yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Selecione a data","disabled":!_vm.developmentPlan.start_date || !_vm.developmentPlan.end_date,"picker-options":_vm.pickerOptionsGoals},model:{value:(goalItem.due_date),callback:function ($$v) {_vm.$set(goalItem, "due_date", $$v)},expression:"goalItem.due_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estratégias para alcançar essa meta*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(goalItem.strategy),expression:"goalItem.strategy"}],staticClass:"form-control",attrs:{"placeholder":"Ex.: Participação em cursos, feedbacks periódicos, envolvimento em projetos...","rows":"3","maxlength":"2000"},domProps:{"value":(goalItem.strategy)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(goalItem, "strategy", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","disabled":_vm.developmentPlan.action_plan_goals.length === 1},on:{"click":function($event){return _vm.removeGoal(index)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Remover\n                      ")])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"type":"button"},on:{"click":_vm.addGoal}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Adicionar Meta\n                    ")])],2):_vm._e(),_vm._v(" "),(_vm.resultEvaluation.plan.strategies_to_reach_goals_old)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Estratégias para Alcançar as Metas*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.developmentPlan.strategies_to_reach_goals_old),expression:"developmentPlan.strategies_to_reach_goals_old"}],staticClass:"form-control",attrs:{"placeholder":"Sugira estratégias para alcançar as metas.","rows":"3","maxlength":"2000"},domProps:{"value":(_vm.developmentPlan.strategies_to_reach_goals_old)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.developmentPlan, "strategies_to_reach_goals_old", $event.target.value)}}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Indicadores de Sucesso*")]),_vm._v(" "),_vm._l((_vm.successIndicators),function(indicator,index){return _c('div',{key:index},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.developmentPlan.success_indicators),expression:"developmentPlan.success_indicators"}],attrs:{"type":"checkbox","id":'success-indicator-checkbox-' + index},domProps:{"value":indicator.id,"checked":Array.isArray(_vm.developmentPlan.success_indicators)?_vm._i(_vm.developmentPlan.success_indicators,indicator.id)>-1:(_vm.developmentPlan.success_indicators)},on:{"change":function($event){var $$a=_vm.developmentPlan.success_indicators,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=indicator.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.developmentPlan, "success_indicators", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.developmentPlan, "success_indicators", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.developmentPlan, "success_indicators", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"non-bold-label",attrs:{"for":'success-indicator-checkbox-' + index}},[_vm._v(_vm._s(indicator.description))])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-gorup"},[_c('label',{staticClass:"control-label"},[_vm._v("Reuniões de Acompanhameto*")]),_vm._v(" "),_vm._l((_vm.developmentPlan.monitoring_meetings),function(meeting,index){return _c('div',{key:index,staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('el-date-picker',{attrs:{"format":"dd/MM/yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Selecione a data","disabled":!_vm.developmentPlan.start_date || !_vm.developmentPlan.end_date || meeting.status == 1 || meeting.status == 2,"picker-options":_vm.getMeetingDatePickerOptions(index, _vm.steps)},model:{value:(_vm.developmentPlan.monitoring_meetings[index].date),callback:function ($$v) {_vm.$set(_vm.developmentPlan.monitoring_meetings[index], "date", $$v)},expression:"developmentPlan.monitoring_meetings[index].date"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","disabled":_vm.developmentPlan.monitoring_meetings.length === 1 || meeting.status == 1 || meeting.status == 2},on:{"click":function($event){return _vm.removeMeetingDate(index, _vm.steps)}}},[_c('i',{staticClass:"fa fa-trash"})])])],1)}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"type":"button","disabled":!_vm.canAddNewMeetingDate},on:{"click":function($event){return _vm.addMeetingDate(_vm.steps)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Adicionar Data\n                    ")]),_vm._v(" "),(_vm.noMeetingDateAvailable)?_c('span',{staticStyle:{"font-size":"12px","color":"gray","margin-left":"10px"}},[_vm._v("Não é possível adicionar mais reuniões dentro do intervalo atual.")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"20px 0"}},[_c('button',{staticClass:"btn btn-wd btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.validDevelopmentPlan()}}},[_c('loading-spin',{staticClass:"loading-spin-login",attrs:{"check":_vm.loading}}),_vm._v("\n                  Salvar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleCancelEditing()}}},[_vm._v("\n                  Cancelar\n                ")])])]):_vm._e(),_vm._v(" "),(_vm.steps.monitoring)?_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('i',{staticClass:"ti-check-box"}),_vm._v("  "),_c('b',[_vm._v("Metas:")]),_c('br'),_vm._v(" "),_vm._l((_vm.monitoringGoals),function(goal,index){return _c('div',{key:goal.id,staticClass:"goal",staticStyle:{"margin-top":"10px","margin-bottom":"15px"}},[_c('div',{staticClass:"goal-title"},[_c('span',{staticClass:"dot"},[_vm._v("•")]),_vm._v(" "),_c('b',[_vm._v("Meta "+_vm._s(index + 1))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goal.progress)+"%")])]),_vm._v(" "),_c('div',{staticClass:"goal-body"},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('el-slider',{attrs:{"min":0,"max":100,"step":5,"show-tooltip":"","format-tooltip":_vm.formatTooltip},model:{value:(goal.progress),callback:function ($$v) {_vm.$set(goal, "progress", $$v)},expression:"goal.progress"}})],1),_vm._v(" "),_c('b',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(goal.goal)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Estratégia:")]),_vm._v(" "+_vm._s(goal.strategy)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Prazo:")]),_vm._v(" "+_vm._s(_vm.formatDate(goal.due_date))+"\n                    ")])])})],2)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"col-md-12"},[_vm._m(4),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.monitoring.feedbacks),expression:"monitoring.feedbacks"}],staticClass:"form-control",attrs:{"rows":"4","placeholder":"Escreva aqui as observações ou feedbacks desta reunião..."},domProps:{"value":(_vm.monitoring.feedbacks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.monitoring, "feedbacks", $event.target.value)}}})])]),_vm._v(" "),(_vm.pastMeetings && _vm.pastMeetings.length > 0)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('i',{staticClass:"ti-agenda"}),_vm._v("  "),_c('b',[_vm._v("Histórico de Reuniões:")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"carousel-wrapper"},[_c('button',{staticClass:"nav-button left",attrs:{"disabled":_vm.currentMeetingIndex === 0},on:{"click":_vm.prevMeeting}},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.slideDirection,"mode":"out-in"}},[_c('div',{key:_vm.currentPastMeeting.id,staticClass:"carousel-card"},[_c('b',[_vm._v("Data:")]),_vm._v(" "+_vm._s(_vm.formatDate(_vm.currentPastMeeting.date))),_c('br'),_vm._v(" "),_vm._l((_vm.currentPastMeeting.goal_progresses),function(goalProgress,index){return _c('div',[(goalProgress.progress_change && goalProgress.progress_change > 0)?_c('div',[_c('i',{staticClass:"ti-arrow-up"}),_vm._v(" "),_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"green"}},[_vm._v(" + "+_vm._s(goalProgress.progress_change)+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])]):(goalProgress.progress_change == 0)?_c('div',[_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',[_vm._v(" + "+_vm._s(goalProgress.progress_change)+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])]):_c('div',[_c('i',{staticClass:"ti-arrow-down"}),_vm._v(" "),_c('b',[(goalProgress.action_plan_goal.deleted_at)?_c('span',[_vm._v("Meta (excluída):")]):_c('span',[_vm._v("Meta:")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" - "+_vm._s(goalProgress.progress_change * (-1))+"%")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(goalProgress.action_plan_goal.goal))])])])}),_vm._v(" "),_c('b',[_vm._v("Feedbacks:")]),_vm._v(" "+_vm._s(_vm.currentPastMeeting.feedbacks)),_c('br')],2)]),_vm._v(" "),_c('button',{staticClass:"nav-button right",attrs:{"disabled":_vm.currentMeetingIndex >= _vm.pastMeetings.length - 1},on:{"click":_vm.nextMeeting}},[_c('i',{staticClass:"ti-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"carousel-indicators"},_vm._l((_vm.pastMeetings),function(meeting,index){return _c('span',{key:meeting.id,class:['indicator-dot', { active: index === _vm.currentMeetingIndex }],on:{"click":function($event){return _vm.goToMeeting(index)}}})}),0)],1),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"col-md-12"},[_vm._m(5),_vm._v(" "),_c('b',[_vm._v("Próxima reunião:")]),_vm._v(" "+_vm._s(_vm.formatNextMonitoring(_vm.getNextMonitoring(_vm.resultEvaluation.plan.monitoring_meetings), _vm.steps))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"col-md-12",on:{"click":function($event){_vm.showMeetingSchedule = !_vm.showMeetingSchedule}}},[_c('span',{staticClass:"btn-label"},[(_vm.showMeetingSchedule)?_c('i',{staticClass:"ti-angle-up",staticStyle:{"color":"#007bff"}}):_c('i',{staticClass:"ti-angle-down",staticStyle:{"color":"#007bff"}})]),_vm._v(" "),_c('span',{staticStyle:{"color":"#007bff","cursor":"pointer"}},[_vm._v("Gerenciar reuniões")])])]),_vm._v(" "),(_vm.showMeetingSchedule)?_c('div',{staticClass:"row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-gorup"},[_c('label',{staticClass:"control-label"},[_vm._v("Reuniões de Acompanhameto*")]),_vm._v(" "),_vm._l((_vm.monitoring.all_meetings),function(meeting,index){return _c('div',{key:index,staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('el-date-picker',{attrs:{"format":"dd/MM/yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Selecione a data","disabled":!_vm.resultEvaluation.plan.start_date || !_vm.resultEvaluation.plan.end_date || meeting.status == 1 || meeting.status == 2 || meeting.date === new Date().toISOString().split('T')[0],"picker-options":_vm.getMeetingDatePickerOptions(index, _vm.steps)},model:{value:(_vm.monitoring.all_meetings[index].date),callback:function ($$v) {_vm.$set(_vm.monitoring.all_meetings[index], "date", $$v)},expression:"monitoring.all_meetings[index].date"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","disabled":_vm.monitoring.all_meetings.length === 1 || meeting.status == 1 || meeting.status == 2 || meeting.date === new Date().toISOString().split('T')[0]},on:{"click":function($event){return _vm.removeMeetingDate(index, _vm.steps)}}},[_c('i',{staticClass:"fa fa-trash"})])])],1)}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"type":"button","disabled":!_vm.canAddNewMeetingDate},on:{"click":function($event){return _vm.addMeetingDate(_vm.steps)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Adicionar Data\n                    ")]),_vm._v(" "),(_vm.noMeetingDateAvailable)?_c('span',{staticStyle:{"font-size":"12px","color":"gray","margin-left":"10px"}},[_vm._v("Não é possível adicionar mais reuniões dentro do intervalo atual.")]):_vm._e()],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"30px 0"}},[_c('button',{staticClass:"btn btn-wd btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.validMonitoring()}}},[_c('loading-spin',{staticClass:"loading-spin-login",attrs:{"check":_vm.loading}}),_vm._v("\n                  Salvar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleCancelMonitoring()}}},[_vm._v("\n                  Cancelar\n                ")])])]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12",staticStyle:{"text-align":"center","margin":"20px 0"}},[_c('button',{staticClass:"btn btn-wd btn-default btn-move-left",attrs:{"type":"button"},on:{"click":function($event){return _vm.openProfile()}}},[_vm._m(7),_vm._v("\n        Voltar\n      ")])])])],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("PLANO DE AÇÃO")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Plano de Desenvolvimento proposto por seu Gestor Imediato para a competência\n            selecionada.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-pencil-alt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-timer"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"13px"}},[_c('br'),_vm._v("\n                  As reuniões periódicas de acompanhamento devem ter um intervalo de no mínimo 15 dias da data de início ou da última reunião.\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"ti-comment-alt"}),_vm._v("  "),_c('b',[_vm._v("Feedbacks do acompanhamento:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-timer"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"13px"}},[_c('br'),_vm._v("\n                  As reuniões periódicas de acompanhamento devem ter um intervalo de no mínimo 15 dias da data de início ou da última reunião.\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-left"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d5Xl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660838f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("X5Wu");
function injectStyle (ssrContext) {
  __webpack_require__("Ev6x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660838f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dgU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs__);













__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_collapse_item___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.getMySkills();
  },
  data: function data() {
    return {
      skills: [],
      activeName: 'first',
      loading: false
    };
  },

  methods: {
    getMySkills: function getMySkills() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = '/collaborator/my-skills';

                _this.loading = true;
                _context.next = 4;
                return axios.get(url).then(function (response) {
                  _this.skills = response.data;
                }).catch(function (error) {
                  console.log(error);
                });

              case 4:
                _this.loading = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    keyVfor: function keyVfor(index) {
      return index + Math.random().toString(5).slice(2);
    }
  }
});

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43942653_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("vSCn");
function injectStyle (ssrContext) {
  __webpack_require__("LUn3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43942653_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    label: String
  }
});

/***/ }),

/***/ "elQm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.cycleYear = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc().format('YYYY');
    this.getEvaluationCycles();
    this.getDefaultEvaluations(this.cycleYear);
  },
  data: function data() {
    return {
      cycleYear: '',
      evaluationCycles: [],
      myEvaluations: [],
      myDefaultEvaluationCycleYear: ''
    };
  },

  filters: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD/MM/YYYY');
    }
  },
  methods: {
    getEvaluationCycles: function getEvaluationCycles() {
      var _this = this;

      var url = '/collaborator/evaluation-cycle';
      axios.get(url).then(function (response) {
        _this.evaluationCycles = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getDefaultEvaluations: function getDefaultEvaluations() {
      var _this2 = this;

      var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var url = '/collaborator/my-evaluations';

      if (year) {
        url += '?cycle=' + year;
      }

      axios.get(url).then(function (response) {
        _this2.myEvaluations = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    evaluationInfo: function evaluationInfo() {
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Avaliação Pendente',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        html: 'Essa Avaliação ainda não foi realizada pelo gestor imediato '
      });
    },
    evaluationTypeTranslate: function evaluationTypeTranslate(typeId) {
      switch (typeId) {
        case 1:
          return 'Av. de Desempenho';
        case 2:
          return 'Me avalia aí';
        case 3:
          return 'Autoavaliação';
        default:
          break;
      }
    },
    toEvaluate: function toEvaluate(evaluation) {
      var _this3 = this;

      var evaluationId = evaluation.id;
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Você tem certeza!',
        text: 'Você iniciará avaliação agora.',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'OK',
        buttonsStyling: false,
        preConfirm: function preConfirm(res) {
          return _this3.verifyAccess(evaluationId).catch(function (error) {
            var message = 'Não foi possível completa requisição, tente novamente mais tarde.';
            if (error.response.status !== 500) {
              message = error.response.data.error;
            }

            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.showValidationError(message);

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              reject(new Error(message));
            });
          });
        }
      }).then(function (res) {
        _this3.execEvaluation(evaluationId, res.data);
      });
    },
    verifyAccess: function verifyAccess(evaluationId) {
      return axios.post('/collaborator/manager/verify-access-evaluation', {
        evaluation_id: evaluationId
      });
    },
    execEvaluation: function execEvaluation(evaluationId, dataAccess) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Acesso Liberado!',
        html: 'Link de validação gerado. <br/> <small>Você tem 72 horas para realizar avaliação com o link gerado.</small>',
        type: 'success',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Acessar Avaliação',
        buttonsStyling: false,
        preConfirm: function preConfirm() {
          if (dataAccess.access_token) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve(dataAccess);
            });
          }

          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            reject(new Error('Token não pode ser encontrado.'));
          });
        }
      }).then(function (res) {
        var collaboratorId = JSON.parse(localStorage.getItem('user')).id;
        _this4.$router.push('/avaliacao/formulario/' + collaboratorId + '/' + evaluationId + '/' + res.access_token);
      }).catch(__WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.noop);
    }
  },
  watch: {
    myDefaultEvaluationCycleYear: function myDefaultEvaluationCycleYear(value) {
      this.getDefaultEvaluations(value);
    }
  }
});

/***/ }),

/***/ "ewrW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f+Jq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fE7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.evaluation)?_c('div',[(_vm.loading)?_c('div',{staticClass:"view-block"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h5',{staticClass:"title_h5"},[_vm._v("Gestor Imediato")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center desc_member"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-2"},[_c('div',{staticClass:"avatar img_member"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":_vm.currentUser.avatar_url,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('div',{staticClass:"pull-left name_member"},[_c('span',[_vm._v("\n                    "+_vm._s(_vm.currentUser.name)+"\n                  ")]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.currentUser.position.functional_classification.name))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h5',{staticClass:"title_h5"},[_vm._v("Colaborador")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center desc_member"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-2"},[_c('div',{staticClass:"avatar img_member"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":_vm.evaluation.collaborator.avatar_url,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('div',{staticClass:"pull-left name_member"},[_c('span',[_vm._v("\n                  "+_vm._s(_vm.evaluation.collaborator.name)+"\n                ")]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.evaluation.collaborator.position.name))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card card-av-desempenho"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("COMPETÊNCIAS")]),_vm._v(" "),_vm._l((_vm.evaluation.collaborator.skills),function(skill,index){return _c('div',{key:("skill-" + index),staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',[_c('b',[_vm._v(_vm._s(skill.name))]),_c('br'),_c('br'),_c('small',[_vm._v(_vm._s(skill.description))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('evaluation-answer',{attrs:{"answerEdit":skill.answer,"evaluationWeight":_vm.evaluation.evaluation_weight,"skillId":skill.id},on:{"setEvaluationAnswer":_vm.setEvaluationAnswer}})],1)])])])})],2)]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"card card-av-desempenho"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("Entrega")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('evaluation-delivery-answer',{attrs:{"answerEdit":_vm.evaluation.collaborator.evaluation_delivery_answer},on:{"setEvaluationDeliveryAnswer":_vm.setEvaluationDeliveryAnswer}})],1)])])])])]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('button',{staticClass:"btn btn-wd btn-success btn-fill btn-rotate bt-end",attrs:{"type":"button"},on:{"click":function($event){return _vm.validEvaluation()}}},[_vm._m(2),_vm._v("\n              Salvar Avaliação\n            ")])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v("Avaliar segundo a realidade atual (o desempenho das entregas realizadas) e não pela situação esperada (o potencial demonstrado). A avaliação só terá valor se as respostas refletirem as verdadeiras práticas e a performance apresentada pelo colaborador ao longo do último ano. ​Trata-se de uma “fotografia” das entregas em geral, considerando o que normalmente acontece. Ou seja, deve refletir a maioria das entregas e trabalhos resultados e não o “destaque de um único trabalho).​"),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-save"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fGX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationDeliveryAnswer_vue__ = __webpack_require__("6H4O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673ae056_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationDeliveryAnswer_vue__ = __webpack_require__("9WBg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationDeliveryAnswer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673ae056_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationDeliveryAnswer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fr0d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"card card-competencias"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Minhas Competências "),_c('loading-spin',{attrs:{"check":_vm.loading}})],1),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Em quais competências serei avaliado?")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',_vm._l((_vm.skills),function(skill,index){return _c('el-collapse-item',{key:_vm.keyVfor(index),attrs:{"title":skill.name}},[_c('div',{staticStyle:{"padding-left":"15px"}},[_vm._v("\n                "+_vm._s(skill.description)),_c('br'),_c('br')])])}),1),_vm._v(" "),((_vm.skills.length === 0))?_c('div',{staticStyle:{"padding-bottom":"15px"}},[_c('p',{staticClass:"category"},[_vm._v("\n              Competências não foram encontradas! Por favor, entre em contato com a equipe de suporte "),_c('router-link',{attrs:{"to":"/suporte","tag":"b"}},[_c('a',[_vm._v("aqui")])]),_vm._v(".\n            ")],1)]):_vm._e()],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gTxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("5snn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b737cf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("87ks");
function injectStyle (ssrContext) {
  __webpack_require__("ORD+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b737cf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gkvT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h7Kw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hASK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-switch',
  props: {
    label: String,
    value: [Array, Boolean],
    disabled: [Boolean, String],
    onText: String,
    offText: String,
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    switchClass: function switchClass() {
      var base = 'bootstrap-switch-';
      var state = this.model ? 'on' : 'off';
      return base + state;
    },

    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    triggerToggle: function triggerToggle() {
      this.model = !this.model;
    }
  }
});

/***/ }),

/***/ "hUK+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-competencias"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Avaliações "),_c('loading-spin',{attrs:{"check":_vm.loading}})],1),_vm._v(" "),_vm._m(0),_vm._m(1),_vm._v(" "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',_vm._l((_vm.evaluations),function(evaluation,index){return _c('el-collapse-item',{key:index,attrs:{"title":((evaluation.evaluation_cycle_name) + " - " + (evaluation.evaluation_type_name) + " | " + (evaluation.evaluation_label_status.name)),"name":evaluation.id}},[(evaluation.evaluation_type_id == 1)?_c('div',[(evaluation.status)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('b',[_vm._v("Segue abaixo o resultado da avaliação:")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('circle-chart-card',{attrs:{"percentage":evaluation.total_percent,"title":"RESULTADO FINAL","description":evaluation.evaluation_type_name,"color":_vm.percentTotalColor(evaluation.total_percent)}})],1),_vm._v(" "),(evaluation.is_plan)?_c('div',{staticClass:"col-lg-12 col-sm-12 text-center"},[_c('button',{staticClass:"btn btn-info btn-fill btn-wd",on:{"click":function($event){return _vm.openOverview(evaluation.id)}}},[_vm._v("Visão Geral")])]):_c('div',{staticClass:"col-lg-12 col-sm-12 text-center"},[_c('button',{staticClass:"btn btn-success btn-fill btn-wd",on:{"click":function($event){return _vm.openSetPlan(evaluation.id)}}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-target"})]),_vm._v("\n                Informar o plano de ação\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-warning btn-fill",on:{"click":function($event){return _vm.evaluationEdit(evaluation.id)}}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v("\n                Editar Avaliação\n              ")])])]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('button',{staticClass:"btn btn-fill btn-success btn-wd",on:{"click":function($event){return _vm.toEvaluate(evaluation)}}},[_c('i',{staticClass:"ti-check"}),_vm._v(" AVALIAR\n              ")])])])]):_vm._e(),_vm._v(" "),(evaluation.evaluation_type_id == 3)?_c('div',[(evaluation.status)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('b',[_vm._v("Segue abaixo o resultado da autoavaliação:")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('circle-chart-card',{attrs:{"percentage":evaluation.total_percent,"title":"RESULTADO FINAL","description":evaluation.evaluation_type_name,"color":_vm.percentTotalColor(evaluation.total_percent)}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-sm-12 text-center"},[_c('button',{staticClass:"btn btn-info btn-fill btn-wd",on:{"click":function($event){return _vm.openOverview(evaluation.id)}}},[_vm._v("Visão Geral")])])]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('b',[_vm._v("Aguardando realização da autoavaliação")])])])])]):_vm._e()])}),1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("Seguem abaixo as avaliações do colaborador até o momento: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plano-acao"},[_c('i',{staticClass:"ti-arrow-circle-right text-warning"}),_c('small',[_c('b',{staticStyle:{"color":"#f0a810","padding-left":"5px"}},[_vm._v("PA - PLANO DE AÇÃO")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hbXy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cropperjs_dist_cropper_css__ = __webpack_require__("5Qkr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cropperjs_dist_cropper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cropperjs_dist_cropper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cropperjs__ = __webpack_require__("4RJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cropperjs__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImageCropper',
  data: function data() {
    return {
      cropper: {},
      croppable: false
    };
  },

  methods: {
    render: function render(src) {
      var _this = this;

      var contentImage = document.getElementById('contentImage');
      contentImage.innerHTML = '';
      var img = new Image();
      img.onload = function () {
        _this.cropper = new __WEBPACK_IMPORTED_MODULE_1_cropperjs___default.a(img, {
          aspectRatio: 1,
          zoomOnWheel: false,
          viewMode: 1,
          ready: function ready() {
            _this.croppable = true;
          }
        });
      };
      img.src = src;
      contentImage.appendChild(img);
    },
    getCanvas: function getCanvas(sourceCanvas) {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var width = sourceCanvas.width;
      var height = sourceCanvas.height;

      canvas.width = width;
      canvas.height = height;
      context.imageSmoothingEnabled = true;
      context.drawImage(sourceCanvas, 0, 0, width, height);
      context.beginPath();

      context.fill();

      return canvas;
    },
    cropImage: function cropImage() {
      var _this2 = this;

      if (!this.croppable) {
        return;
      }

      var croppedCanvas = this.cropper.getCroppedCanvas();
      var canvas = this.getCanvas(croppedCanvas);

      canvas.toBlob(function (blob) {
        var data = {
          file: new File([blob], 'profile_image.jpg', { type: blob.type, lastModified: Date.now() }),
          url: URL.createObjectURL(blob)
        };

        _this2.setImage(data);
      }, 'image/jpeg', 1);
    },
    setImage: function setImage(data) {
      this.$emit('setImage', data);
    }
  }
});

/***/ }),

/***/ "i4WV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iPfK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.evaluationId = this.$route.params.evaluationId;
    this.collaboratorId = this.$route.params.collaboratorId;
    this.getCollaborator();
  },
  data: function data() {
    return {
      token: null,
      evaluation: null,
      loading: true,
      evaluationAnswers: [],
      evaluationDeliveryAnswer: ''
    };
  },

  methods: {
    getCollaborator: function getCollaborator() {
      var _this = this;

      var url = '/collaborator/manager/collaborator-evaluation-edit';
      axios.post(url, { evaluation_id: this.evaluationId }).then(function (response) {
        _this.evaluation = response.data;
        _this.setEvaluationAnswers();
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
        if (error.response.status === 500) {
          _this.setError('Error inesperado, tente novamente mais tarde.');
        } else {
          _this.setError(error.response.data.error);
        }
      });
    },
    setError: function setError(message) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Avaliação!',
        text: message,
        type: 'warning',
        showCancelButton: false,
        confirmButtonClass: 'btn btn-success btn-fill',
        confirmButtonText: 'Voltar',
        buttonsStyling: false,
        allowOutsideClick: false,
        preConfirm: function preConfirm() {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            resolve('OK');
          });
        }
      }).then(function () {
        _this2.$router.push('/avaliacao/equipe');
      });
    },
    setEvaluationAnswers: function setEvaluationAnswers() {
      var skills = this.evaluation.collaborator.skills;
      var answers = [];

      skills.forEach(function (skill) {
        answers.push({
          skillId: skill.id,
          answerValue: skill.answer
        });
      });

      this.evaluationAnswers = answers;
      this.evaluationDeliveryAnswer = this.evaluation.collaborator.evaluation_delivery_answer;
    },
    setEvaluationAnswer: function setEvaluationAnswer(answer) {
      var answers = this.evaluationAnswers.filter(function (element) {
        if (element.skillId === answer.skillId) {
          return false;
        } else {
          return true;
        }
      });

      answers.push(answer);

      this.evaluationAnswers = answers;
    },
    setEvaluationDeliveryAnswer: function setEvaluationDeliveryAnswer(answer) {
      this.evaluationDeliveryAnswer = answer.answerValue;
    },
    validEvaluation: function validEvaluation() {
      var _this3 = this;

      var countSkills = this.evaluation.collaborator.skills.length;

      if (this.evaluationAnswers.length === countSkills && !!this.evaluationDeliveryAnswer) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          title: 'Você tem certeza!',
          html: 'Avaliação será Salva.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Enviar Avaliação',
          buttonsStyling: false,
          preConfirm: function preConfirm() {
            return _this3.updateEvaluationAnswer().catch(function (error) {
              var message = 'Não foi possível completa requisição, tente novamente mais tarde.';
              if (error.response.status !== 500) {
                message = error.response.data.error;
              }
              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.showValidationError(message);
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                reject(new Error(message));
              });
            });
          }
        }).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            title: 'Avaliação Salva!',
            html: 'Avaliação do colaborador foi realizada com sucesso. <br> <small>Você será redirecionado para o <b>Plano de Ação</b></small>',
            type: 'success',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'OK',
            buttonsStyling: false,
            allowOutsideClick: false,
            preConfirm: function preConfirm() {
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                resolve('OK');
              });
            }
          }).then(function () {
            _this3.$router.push('/avaliacao/formulario-resultado/' + _this3.evaluation.id + '/' + _this3.collaboratorId);
          });
        }).catch(__WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.noop);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          title: 'Atenção!',
          text: 'Você não finalizou avaliação.',
          type: 'warning',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        }).then(function () {
          _this3.scrollWinTop();
        });
      }
    },
    updateEvaluationAnswer: function updateEvaluationAnswer() {
      var url = '/collaborator/manager/collaborator-evaluation-answer/' + this.evaluationId;
      return axios.put(url, { evaluationAnswers: this.evaluationAnswers, evaluationDeliveryAnswer: this.evaluationDeliveryAnswer });
    },
    scrollWinTop: function scrollWinTop() {
      $('.main-panel').scrollTop(250, 0);
    },
    handleClose: function handleClose(tag) {
      this.tags.dynamicTags.splice(this.tags.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this4 = this;

      this.tags.inputVisible = true;
      this.$nextTick(function () {
        _this4.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.tags.inputValue;
      if (inputValue) {
        this.tags.dynamicTags.push(inputValue);
      }
      this.tags.inputVisible = false;
      this.tags.inputValue = '';
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  }
});

/***/ }),

/***/ "iSL4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompetenciasCard_vue__ = __webpack_require__("dgU1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67208e72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompetenciasCard_vue__ = __webpack_require__("fr0d");
function injectStyle (ssrContext) {
  __webpack_require__("CBCL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompetenciasCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67208e72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompetenciasCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iXuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__ = __webpack_require__("wH4b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Inputs_EvaluationAnswer_vue__ = __webpack_require__("RPnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UIComponents_Inputs_EvaluationDeliveryAnswer_vue__ = __webpack_require__("fGX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UIComponents_LoadingSpin_vue__ = __webpack_require__("VMtB");









var GlobalComponents = {
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Inputs_EvaluationAnswer_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Inputs_EvaluationAnswer_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_5__components_UIComponents_Inputs_EvaluationDeliveryAnswer_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__components_UIComponents_Inputs_EvaluationDeliveryAnswer_vue__["a" /* default */]);
    Vue.component('loading-spin', __WEBPACK_IMPORTED_MODULE_6__components_UIComponents_LoadingSpin_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "ij53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__("XXU8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_692ebc61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__("+QeK");
function injectStyle (ssrContext) {
  __webpack_require__("qiLv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_692ebc61_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);


/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jcvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  filters: {
    formatDateBr: function formatDateBr(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY');
    }
  },
  methods: {
    openForms: function openForms() {
      window.open('https://forms.office.com/r/KCTMGsuk42', '_blank');
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  }
});

/***/ }),

/***/ "jr0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("PmSE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be37cee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("cubp");
function injectStyle (ssrContext) {
  __webpack_require__("G24O")
  __webpack_require__("yURV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2be37cee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be37cee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k1ZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"row",attrs:{"id":"loading"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kB3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trafficSystem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);



var _this = this;



var getSettings = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(store) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getSettings(_x) {
    return _ref.apply(this, arguments);
  };
}();

var trafficSystem = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(path, router, store) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            getSettings(store);

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function trafficSystem(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ "kBzv":
/***/ (function(module, exports, __webpack_require__) {


window._ = __webpack_require__("M4fF");
window.Popper = __webpack_require__("Zgw8").default;

try {
  window.$ = window.jQuery = __webpack_require__("7t+N");

  __webpack_require__("gNGx");
} catch (e) {
  console.log(e);
}

window.axios = __webpack_require__("mtWM");

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/***/ }),

/***/ "kFOG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.evaluationWeight === 4)?_c('div',[_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId1,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"1"},domProps:{"checked":_vm._q(_vm.answer,"1")},on:{"change":function($event){_vm.answer="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId1}},[_c('div',{staticClass:"escala1"},[_vm._v("1")]),_vm._v(" Abaixo do esperado (0 a 50%): Não apresenta os resultados esperados.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId2,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"2"},domProps:{"checked":_vm._q(_vm.answer,"2")},on:{"change":function($event){_vm.answer="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId2}},[_c('div',{staticClass:"escala2"},[_vm._v("2")]),_vm._v(" Em desenvolvimento (51 a 79%): Apresenta os resultados esperados esporadicamente.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId3,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"3"},domProps:{"checked":_vm._q(_vm.answer,"3")},on:{"change":function($event){_vm.answer="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId3}},[_c('div',{staticClass:"escala3"},[_vm._v("3")]),_vm._v(" Dentro do esperado (80 a 100%): Apresenta os resultados esperados.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId4,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"4"},domProps:{"checked":_vm._q(_vm.answer,"4")},on:{"change":function($event){_vm.answer="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId4}},[_c('div',{staticClass:"escala4"},[_vm._v("4")]),_vm._v(" Acima do esperado (101 a 120%):Supera os resultados esperados frequentemente.\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.evaluationWeight === 5)?_c('div',[_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId1,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"1"},domProps:{"checked":_vm._q(_vm.answer,"1")},on:{"change":function($event){_vm.answer="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId1}},[_c('div',{staticClass:"escala1"},[_vm._v("1")]),_vm._v(" Apresenta minimamente a competência avaliada. "),_c('div',{staticClass:"vezes"},[_vm._v("(até 40% das vezes)")])])]),_vm._v(" "),_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId2,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"2"},domProps:{"checked":_vm._q(_vm.answer,"2")},on:{"change":function($event){_vm.answer="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId2}},[_c('div',{staticClass:"escala2"},[_vm._v("2")]),_vm._v(" Apresenta poucas vezes a competência avaliada. "),_c('div',{staticClass:"vezes"},[_vm._v("(entre 40.1% e 60% das vezes)")])])]),_vm._v(" "),_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId3,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"3"},domProps:{"checked":_vm._q(_vm.answer,"3")},on:{"change":function($event){_vm.answer="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId3}},[_c('div',{staticClass:"escala3"},[_vm._v("3")]),_vm._v(" Apresenta muitas vezes a competência avaliada. "),_c('div',{staticClass:"vezes"},[_vm._v("(entre 60.1% e 80% das vezes)")])])]),_vm._v(" "),_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId4,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"4"},domProps:{"checked":_vm._q(_vm.answer,"4")},on:{"change":function($event){_vm.answer="4"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId4}},[_c('div',{staticClass:"escala4"},[_vm._v("4")]),_vm._v(" Apresenta na maioria das vezes a competência avaliada. "),_c('div',{staticClass:"vezes"},[_vm._v("(entre 80.1% e 95% das vezes)")])])]),_vm._v(" "),_c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.answer),expression:"answer"}],attrs:{"id":_vm.rId5,"type":"radio","name":_vm.cbId,"disabled":_vm.disabled,"value":"5"},domProps:{"checked":_vm._q(_vm.answer,"5")},on:{"change":function($event){_vm.answer="5"}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.rId5}},[_c('div',{staticClass:"escala5"},[_vm._v("5")]),_vm._v(" Apresenta sempre a competência avaliada. "),_c('div',{staticClass:"vezes"},[_vm._v("(entre 95.1% e 100% das vezes)")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kOp2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4872174_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("GoCh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4872174_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kesT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"card card-competencias"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Como usar?")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Seguem abaixo os vídeos de suporte a utilização da Avaliação de Desempenho.")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"padding-bottom":"5px"}},[_c('a',{staticClass:"btn btn-default",staticStyle:{"width":"100%","text-align":"left"},attrs:{"href":"https://www.youtube.com/watch?v=bZp53Q5SOns&feature=youtu.be","target":"_blank"}},[_c('span',{staticStyle:{"color":"red"}},[_c('i',{staticClass:"fa fa-youtube-play",attrs:{"aria-hidden":"true"}})]),_vm._v(" Primeiros passos\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"padding-bottom":"5px"}},[_c('a',{staticClass:"btn btn-default",staticStyle:{"width":"100%","text-align":"left"},attrs:{"href":"https://www.youtube.com/watch?v=0XzUu0uyVAk&feature=youtu.be","target":"_blank"}},[_c('span',{staticStyle:{"color":"red"}},[_c('i',{staticClass:"fa fa-youtube-play",attrs:{"aria-hidden":"true"}})]),_vm._v(" Avaliação Versão Gestor\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"padding-bottom":"5px"}},[_c('a',{staticClass:"btn btn-default",staticStyle:{"width":"100%","text-align":"left"},attrs:{"href":"https://www.youtube.com/watch?v=LQLlzPo3hL4&feature=youtu.be","target":"_blank"}},[_c('span',{staticStyle:{"color":"red"}},[_c('i',{staticClass:"fa fa-youtube-play",attrs:{"aria-hidden":"true"}})]),_vm._v(" Avaliação Versão Colaborador\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"padding-bottom":"5px"}},[_c('a',{staticClass:"btn btn-default",staticStyle:{"width":"100%","text-align":"left"},attrs:{"href":"https://www.youtube.com/watch?v=ietJNNsnd0E&ab_channel=PortalBrasal","target":"_blank"}},[_c('span',{staticStyle:{"color":"red"}},[_c('i',{staticClass:"fa fa-youtube-play",attrs:{"aria-hidden":"true"}})]),_vm._v(" Me avalia aí! Versão Colaborador\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"padding-bottom":"5px"}},[_c('a',{staticClass:"btn btn-default",staticStyle:{"width":"100%","text-align":"left"},attrs:{"href":"https://www.youtube.com/watch?v=fXyEN26B83Y&ab_channel=PortalBrasal","target":"_blank"}},[_c('span',{staticStyle:{"color":"red"}},[_c('i',{staticClass:"fa fa-youtube-play",attrs:{"aria-hidden":"true"}})]),_vm._v(" Me avalia aí! Versão Gestor\n              ")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m9jm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_vm._t("content")],2)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mTam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{staticClass:"logo_ad",attrs:{"src":"static/img/logo_branca_2025.png","alt":"Avaliação de Desempenho"}})])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('router-link',{attrs:{"to":"/suporte","tag":"li"}},[_c('a',[_vm._v("Suporte")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.authenticate($event)}}},[_c('div',{staticClass:"card card-login",attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Matrícula")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.username),expression:"form.username"}],staticClass:"form-control input-no-border",attrs:{"type":"text","placeholder":"Preencha sua Matrícula","inputmode":"numeric","autocomplete":"username"},domProps:{"value":(_vm.form.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"form-control input-no-border",attrs:{"type":"password","placeholder":"Preencha seu CPF","inputmode":"numeric","autocomplete":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[(_vm.authError)?_c('p',{staticClass:"authError text-danger"},[_vm._v(" "+_vm._s(_vm.authError))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-wd ",attrs:{"type":"submit"}},[_c('loading-spin',{staticClass:"loading-spin-login",attrs:{"check":_vm.loading}}),_vm._v(" Entrar")],1),_vm._v(" "),_c('div',{staticClass:"forgot"},[_c('router-link',{attrs:{"to":"/suporte"}},[_vm._v("\n                        Você tem alguma dúvida?\n                      ")])],1)])])])])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"full-page-background",staticStyle:{"background-image":"url(static/img/background/background-2.jpg)"}})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/suporte","tag":"li"}},[_c('a',[_vm._v("Suporte")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Login do Colaborador")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_c('img',{staticClass:"logo_brasal",attrs:{"src":"static/img/logo_brasal.png","alt":"Brasal"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "me3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__("hASK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3982514b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__("ug2s");
function injectStyle (ssrContext) {
  __webpack_require__("DaUO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3982514b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mtcV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationCard_vue__ = __webpack_require__("/JCG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469d7fcd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationCard_vue__ = __webpack_require__("hUK+");
function injectStyle (ssrContext) {
  __webpack_require__("ewrW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluationCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469d7fcd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluationCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mz9B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nL1X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-user"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.currentUser.position.department.company.banner_url,"alt":"..."}})]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar border-white",attrs:{"src":_vm.currentUser.avatar_url,"alt":"..."}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.currentUser.name)+"\n        "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('small',[_vm._v(_vm._s(_vm.currentUser.position.name))])])])]),_vm._v(" "),_c('p',{staticClass:"description text-center"},[_c('b',{staticClass:"seg"},[_vm._v(_vm._s(_vm.currentUser.position.department.company.name))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-left info_colaborador"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v(" Data de Admissão\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm._f("formatDateBr")(_vm.currentUser.admission_date)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v(" E-mail\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.currentUser.email))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v(" Telefone\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.currentUser.phone))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v(" Classificação Funcional\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.currentUser.position.functional_classification.name))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nVWP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'evaluation-answer',
  props: {
    evaluationWeight: [Number],
    answerEdit: [Number],
    skillId: [Number],
    label: [String, Number],
    disabled: [Boolean, String],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      answer: this.answerEdit,
      cbId: '',
      rId1: '',
      rId2: '',
      rId3: '',
      rId4: '',
      rId5: ''
    };
  },

  computed: {
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
    this.rId1 = Math.random().toString(16).slice(2);
    this.rId2 = Math.random().toString(16).slice(2);
    this.rId3 = Math.random().toString(16).slice(2);
    this.rId4 = Math.random().toString(16).slice(2);
    this.rId5 = Math.random().toString(16).slice(2);
  },

  watch: {
    answer: function answer(val) {
      var data = {
        skillId: this.skillId,
        answerValue: val
      };
      this.$emit('setEvaluationAnswer', data);
    }
  }
});

/***/ }),

/***/ "negu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Gestor Imediato',
      evaluationMe: false
    };
  },

  methods: {
    toEvaluateMe: function toEvaluateMe() {
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Você tem certeza?',
        text: 'Seu gestor imediato receber\xE1 um e-mail para agendar sua avalia\xE7\xE3o.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, quero enviar!',
        buttonsStyling: false,
        preConfirm: function preConfirm() {
          var url = '/collaborator/to-evaluation-me';
          return axios.post(url).catch(function (error) {
            var message = 'Não foi possível completa requisição, tente novamente mais tarde.';
            if (error.response.status !== 500) {
              message = error.response.data.error;
            }
            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.showValidationError(message);
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              reject(new Error(message));
            });
          });
        }
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          title: 'Enviado!',
          text: 'Seu gestor imediato recebeu um e-mail requisitando que ele realize sua avaliação.',
          type: 'success',
          confirmButtonClass: 'btn btn-success btn-fill',
          buttonsStyling: false
        });
      });
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  }
});

/***/ }),

/***/ "niwI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoVideo_vue__ = __webpack_require__("2Pzx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbfea3d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoVideo_vue__ = __webpack_require__("kesT");
function injectStyle (ssrContext) {
  __webpack_require__("36l/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbfea3d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oAPB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oMdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageCropper_vue__ = __webpack_require__("hbXy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249f85b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageCropper_vue__ = __webpack_require__("2jgC");
function injectStyle (ssrContext) {
  __webpack_require__("i4WV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageCropper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249f85b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageCropper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ohNq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormEdit_vue__ = __webpack_require__("iPfK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aa3d226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormEdit_vue__ = __webpack_require__("fE7L");
function injectStyle (ssrContext) {
  __webpack_require__("R7LH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aa3d226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_auth__ = __webpack_require__("7CgR");





var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_auth__["a" /* getLocalUser */])();

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    currentUser: user,
    isLoggedin: !!user,
    loading: false,
    auth_error: null,
    collaborators: []
  },
  getters: {
    isLoading: function isLoading(state) {
      return state.loading;
    },
    isLoggedin: function isLoggedin(state) {
      return state.isLoggedin;
    },
    currentUser: function currentUser(state) {
      return state.currentUser;
    },
    authError: function authError(state) {
      return state.auth_error;
    },
    collaborators: function collaborators(state) {
      return state.collaborators;
    }
  },
  mutations: {
    login: function login(state) {
      state.loading = true;
      state.auth_error = null;
    },
    loginSuccess: function loginSuccess(state, payload) {
      state.auth_error = null;
      state.isLoggedin = true;
      state.loading = false;
      state.currentUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, payload.user, { token: payload.access_token });

      localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.currentUser));
    },
    alterUserData: function alterUserData(state, payload) {
      localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
    },
    loginFailed: function loginFailed(state, payload) {
      state.loading = false;
      state.auth_error = payload.error;
    },
    logout: function logout(state) {
      localStorage.removeItem("user");
      state.isLoggedin = false;
      state.currentUser = null;
    },
    updateCollaborators: function updateCollaborators(state, payload) {
      state.collaborators = payload;
    }
  },
  actions: {
    login: function login(context) {
      context.commit("login");
    },
    getCollaborators: function getCollaborators(context, payload) {
      return axios.get("collaborator/manager/collaborators").then(function (response) {
        context.commit('updateCollaborators', response.data);
      });
    }
  }
});

/***/ }),

/***/ "p1o5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[(_vm.values.length === 0)?_c('div',{staticClass:"progress-bar",class:("progress-bar-" + _vm.type),style:(("width: " + _vm.value + "%;")),attrs:{"role":"progressbar","aria-valuenow":_vm.value,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"sr-only"},[_vm._t("default")],2)]):_vm._l((_vm.values),function(progress){return _c('div',{staticClass:"progress-bar",class:("progress-bar-" + (progress.type)),style:(("width: " + (progress.value) + "%;"))},[_c('span',{staticClass:"sr-only"})])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pEHt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoPDI9Box_vue__ = __webpack_require__("yigp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290947ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoPDI9Box_vue__ = __webpack_require__("u1Ru");
function injectStyle (ssrContext) {
  __webpack_require__("FHzF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoPDI9Box_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290947ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoPDI9Box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pdK0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PowerUniversity_vue__ = __webpack_require__("Kewk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f10cb82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PowerUniversity_vue__ = __webpack_require__("s1fn");
function injectStyle (ssrContext) {
  __webpack_require__("ADJj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PowerUniversity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f10cb82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PowerUniversity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "poPr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pp1H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q8Yn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qCYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.check)?_c('i',{staticClass:"fa fa-spin",class:_vm.loadingClass}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qFR4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.steps.profile)?_c('div',{staticClass:"card card-edit-profile"},[_c('div',{staticClass:"card-content"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validForm()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"alter-avatar",class:{ 'border-green' : !!_vm.tempAvatar, 'border-white': !_vm.tempAvatar }},[_c('img',{attrs:{"src":(!!_vm.tempAvatar ? _vm.tempAvatar : _vm.currentUser.avatar_url),"alt":_vm.currentUser.name}}),_vm._v(" "),_c('div',{staticClass:"alter-avatar-hover",on:{"click":function($event){return _vm.openFile()}}},[_vm._m(0)]),_vm._v(" "),_c('span',{staticClass:"hide"},[_c('input',{ref:"avatar",attrs:{"type":"file","accept":"image/*","capture":"user"},on:{"change":_vm.onFileChange}})])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('h4',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.currentUser.name)+"\n                "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('small',[_vm._v(_vm._s(_vm.currentUser.position.name))])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"email","label":"E-mail","placeholder":"e-mail"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{directives:[{name:"mask",rawName:"v-mask",value:('(##) # ####-####'),expression:"'(##) # ####-####'"}],attrs:{"type":"text","label":"Telefone","placeholder":"telefone","inputmode":"numeric"},model:{value:(_vm.user.phone),callback:function ($$v) {_vm.$set(_vm.user, "phone", $$v)},expression:"user.phone"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill btn-wd",attrs:{"type":"submit"}},[_c('loading-spin',{staticClass:"loading-spin-login",attrs:{"check":_vm.loading}}),_vm._v(" Salvar\n          ")],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]):_vm._e(),_vm._v(" "),(_vm.steps.cropimage)?_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ImageCropper',{ref:"imageCropper",on:{"setImage":_vm.setImage}})],1),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-primary btn-fill",staticStyle:{"margin-top":"20px"},attrs:{"type":"button","title":"Cortar"},on:{"click":function($event){return _vm.cropImage()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Definir como foto do perfil\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill",staticStyle:{"margin-top":"20px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.handleStep('profile')}}},[_vm._v("Cancelar")])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"ti-camera"}),_vm._v(" "),_c('br'),_vm._v(" Atualizar")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Recortar Imagem")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Para recortar esta imagem, arraste a região abaixo e clique em \"Definir como foto do perfil\"")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qMRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",class:{active: _vm.isActive},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name)+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path)?_vm._t("title",[_c(_vm.elementType(_vm.link, false),{tag:"component",class:{active: _vm.link.active},attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":_vm.link.path}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini"},[_vm._v(_vm._s(_vm.link.name.substring(0, 1)))]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.link.name))])]:[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]],2)]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qXym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_general__ = __webpack_require__("Y3o5");




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  },
  methods: {
    checkAccessUser: function checkAccessUser() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_src_helpers_general__["c" /* checkAccessPowerUniversity */])(this.currentUser);
    }
  }
});

/***/ }),

/***/ "qiLv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rP9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__ = __webpack_require__("9597");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__ = __webpack_require__("v98p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserProfile_CompetenciasCard_vue__ = __webpack_require__("iSL4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserProfile_InfoVideo__ = __webpack_require__("niwI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserProfile_PowerUniversity_vue__ = __webpack_require__("GB1h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserProfile_MembersCard_vue__ = __webpack_require__("4qt1");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditProfileForm: __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__["a" /* default */],
    UserCard: __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__["a" /* default */],
    CompetenciasCard: __WEBPACK_IMPORTED_MODULE_2__UserProfile_CompetenciasCard_vue__["a" /* default */],
    MembersCard: __WEBPACK_IMPORTED_MODULE_5__UserProfile_MembersCard_vue__["a" /* default */],
    InfoVideo: __WEBPACK_IMPORTED_MODULE_3__UserProfile_InfoVideo__["a" /* default */],
    PowerUniversity: __WEBPACK_IMPORTED_MODULE_4__UserProfile_PowerUniversity_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "rsHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desc_cargo"},[_c('h4',{staticClass:"title"},[_vm._v("Quais são suas atividades? ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('stats-card',[_c('div',{staticClass:"icon-big icon-info text-center",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"ti-user"})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.currentUser.position.name))])]),_vm._v(" "),_c('div',{staticClass:"stats footer_cargo",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6 comp"},[_c('label',[_vm._v("Número do Cargo")]),_c('br'),_vm._v("\n              "+_vm._s(_vm.currentUser.position.cod)),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 comp"},[_c('label',[_vm._v("UNIORG")]),_c('br'),_vm._v("\n              "+_vm._s(_vm.currentUser.position.department.company.cod)),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 comp"},[_c('label',[_vm._v("Descrição do Cargo")]),_c('br'),_vm._v("\n              "+_vm._s(_vm.currentUser.position.function_description)),_c('br'),_c('br')])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s1fn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card card-competencias"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',[_c('el-collapse-item',{key:_vm.keyVfor(),attrs:{"title":"Sugestão de trilhas por área"}},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9",attrs:{"allowfullscreen":""}},[_c('object',{attrs:{"data":"static/pdf/Power_University_Trilhas.pdf","type":"application/pdf"}})])]),_vm._v(" "),_c('el-collapse-item',{key:_vm.keyVfor(),attrs:{"title":"Painel de acompanhamento"}},[_c('div',{staticStyle:{"padding-top":"15px"}},[_c('a',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"href":"https://app.powerbi.com/links/CDnTDvk2bW?ctid=d895c5b4-1caf-40f3-b3c4-7124c8711044&pbi_source=linkShare","target":"_blank"}},[_c('i',{staticClass:"fa fa-bar-chart",attrs:{"aria-hidden":"true"}}),_vm._v(" Abrir no Powerbi\n                ")])])])],1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Power University")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("by Microsoft")]),_vm._v(" "),_c('img',{staticClass:"logo-power-university",attrs:{"src":"static/img/logo_power_university.png","alt":"Power University by Microsoft"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "sbDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__ = __webpack_require__("Z450");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_300164c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__ = __webpack_require__("p1o5");
function injectStyle (ssrContext) {
  __webpack_require__("9OU8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_300164c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sc3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("9HkA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273ac028_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("mTam");
function injectStyle (ssrContext) {
  __webpack_require__("DRfi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273ac028_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "smGu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-user"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.collaborator.banner_url,"alt":"..."}})]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar border-white",attrs:{"src":_vm.collaborator.avatar_url,"alt":"..."}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.collaborator.name)+"\n        "),_c('br'),_vm._v(" "),(_vm.collaborator.position)?_c('a',{attrs:{"href":"#"}},[_c('small',[_vm._v(_vm._s(_vm.collaborator.position.name))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.collaborator.position)?_c('p',{staticClass:"description text-center"},[(_vm.collaborator.position.department)?_c('b',{staticClass:"seg"},[_vm._v(_vm._s(_vm.collaborator.position.department.company.name))]):_vm._e()]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u1Ru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"card card-competencias"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"matrix matrix-result"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"matrix-content"},[_c('div',{staticClass:"matrix-row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-blue-1"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Acima do esperado")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('span',{staticClass:"scale-result"},[_vm._v("101 a 107.3")]),_vm._v(" "),(((_vm.resultEvaluation.final_result >= 101) && (_vm.resultEvaluation.final_result <= 107.3)))?_c('span',{staticClass:"label-result"},[_c('strong',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.name))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-blue-2"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Acima do esperado")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('span',{staticClass:"scale-result"},[_vm._v("107.4 a 113.7")]),_vm._v(" "),(((_vm.resultEvaluation.final_result >= 107.4) && (_vm.resultEvaluation.final_result <= 113.7)))?_c('span',{staticClass:"label-result"},[_c('strong',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.name))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-blue-3"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Acima do esperado")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('span',{staticClass:"scale-result"},[_vm._v("113.8 a 120")]),_vm._v(" "),(((_vm.resultEvaluation.final_result >= 113.8) && (_vm.resultEvaluation.final_result <= 120)))?_c('span',{staticClass:"label-result"},[_c('strong',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.name))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"matrix-row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-green-1"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Dentro do esperado")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('span',{staticClass:"scale-result"},[_vm._v("80 a 86.5")]),_vm._v(" "),(((_vm.resultEvaluation.final_result >= 80) && (_vm.resultEvaluation.final_result <= 86.5)))?_c('span',{staticClass:"label-result"},[_c('strong',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.name))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-green-2"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Dentro do esperado")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('span',{staticClass:"scale-result"},[_vm._v("86.6 a 94")]),_vm._v(" "),(((_vm.resultEvaluation.final_result >= 86.6) && (_vm.resultEvaluation.final_result <= 94)))?_c('span',{staticClass:"label-result"},[_c('strong',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.name))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-green-3"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Dentro do esperado")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('span',{staticClass:"scale-result"},[_vm._v("94.1 a 100.9")]),_vm._v(" "),(((_vm.resultEvaluation.final_result >= 94.1) && (_vm.resultEvaluation.final_result <= 100.9)))?_c('span',{staticClass:"label-result"},[_c('strong',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.name))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"matrix-row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-red-1"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Abaixo de esperado")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('span',{staticClass:"scale-result"},[_vm._v("0 a 25")]),_vm._v(" "),(((_vm.resultEvaluation.final_result >= 0) && (_vm.resultEvaluation.final_result <= 25)))?_c('span',{staticClass:"label-result"},[_c('strong',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.name))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-red-2"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Abaixo de esperado")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('span',{staticClass:"scale-result"},[_vm._v("25.1 a 50.9")]),_vm._v(" "),(((_vm.resultEvaluation.final_result >= 25.1) && (_vm.resultEvaluation.final_result <= 50.9)))?_c('span',{staticClass:"label-result"},[_c('strong',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.name))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-yellow-3"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Em desenvolvimento")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('span',{staticClass:"scale-result"},[_vm._v("51 a 79.9")]),_vm._v(" "),(((_vm.resultEvaluation.final_result >= 51) && (_vm.resultEvaluation.final_result <= 79.9)))?_c('span',{staticClass:"label-result"},[_c('strong',[_vm._v(_vm._s(_vm.resultEvaluation.collaborator.name))])]):_vm._e()])])])]),_vm._v(" "),_vm._m(6)])])])])])])]),_vm._v(" "),_vm._m(7)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"card card-competencias"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("Matriz de Desenvolvimento")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"matrix"},[_c('div',{staticClass:"matrix-left-title"},[_c('span',[_vm._v("DESEMPENHO")])]),_vm._v(" "),_c('div',{staticClass:"matrix-content"},[_c('div',{staticClass:"matrix-row"},[_c('div',{staticClass:"matrix-label"},[_c('span',[_vm._v("Acima do esperado")])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-blue-1"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Acima do esperado - 101 a 107.3")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Desempenho frequentemente acima do esperado.")]),_vm._v(" "),_c('li',[_vm._v("Entrega além da expectativa para a função e contribui com melhorias para suas atividades.")]),_vm._v(" "),_c('li',[_vm._v("Possui elevada competência em seu cargo e está aprimorando outras adicionais.")]),_vm._v(" "),_c('li',[_vm._v("Pode apoiar e ser desenvolvido em novos desafios, além da sua função.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-blue-2"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Acima do esperado - 107 a 113.7")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Desempenho sempre acima do esperado.")]),_vm._v(" "),_c('li',[_vm._v("É referência na função atual e na condução de melhorias para sua área.")]),_vm._v(" "),_c('li',[_vm._v("Possui elevada competência em seu cargo e já está em consolidação de outras adicionais.")]),_vm._v(" "),_c('li',[_vm._v("Pode conduzir alguns desafios, além da sua função, e deve ser preparado para o seu próximo passo de carreira.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-blue-3"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Acima do esperado 113.8 a 120")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Desempenho supera o esperado consistentemente.")]),_vm._v(" "),_c('li',[_vm._v("É expert em sua função, possui competências adicionais e atua em melhorias/inovação para sua área, diretoria e para a empresa.")]),_vm._v(" "),_c('li',[_vm._v("Está pronto para assumir novos cargos com escopo e responsabilidades mais amplos e complexos.")]),_vm._v(" "),_c('li',[_vm._v("É reconhecido por colegas e gestores para o seu próximo passo e/ou como sucessor de sua área.")])])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-row"},[_c('div',{staticClass:"matrix-label"},[_c('span',[_vm._v("Dentro do esperado")])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-green-1"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Dentro do esperado - 80 a 86.5")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Desempenho satisfatório, mas eventualmente apresenta alguma inconsistência e pode não atender a todos os requisitos esperados para a sua entrega.")]),_vm._v(" "),_c('li',[_vm._v("Apresenta as competências para a função, mas necessita consolidá-las e fortalecer a sua atuação.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-green-2"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Dentro do esperado - 86.5 a 94")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Desempenho satisfatório.")]),_vm._v(" "),_c('li',[_vm._v("Entrega o esperado para a função, de forma completa, dentro do prazo e  padrão de qualidade.")]),_vm._v(" "),_c('li',[_vm._v("Está consolidado nas competências de seu cargo e possui resultados consistentes.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-green-3"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Dentro do esperado - 94.1 a 100.9")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Desempenho satisfatório e ocasionalmente acima do esperado.")]),_vm._v(" "),_c('li',[_vm._v("Entrega o esperado para a função, de forma completa, no prazo e com qualidade, e consegue lidar com situações atípicas.")]),_vm._v(" "),_c('li',[_vm._v("Consolidado nas competências de seu cargo e em desenvolvimento de outras adicionais.")])])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-row"},[_c('div',{staticClass:"matrix-label"},[_c('span',[_vm._v("Abaixo do esperado e "),_c('br'),_vm._v(" Em desenvolvimento")])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-red-1"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Abaixo de esperado - 0 a 25")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Baixo desempenho.")]),_vm._v(" "),_c('li',[_vm._v("Raramente entrega resultados e normalmente incompletos, fora do prazo e padrão de qualidade.")]),_vm._v(" "),_c('li',[_vm._v("Padrão de qualidade abaixo do esperado.")]),_vm._v(" "),_c('li',[_vm._v("Possui competências em nível insuficiente para a sua função.")]),_vm._v(" "),_c('li',[_vm._v("Priorizar feedback assertivo e execução do PDI.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-red-2"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Abaixo de esperado - 25.1 a 50.9")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Desempenho Inconsistente e competências em nivel muito básico para a função.")]),_vm._v(" "),_c('li',[_vm._v("Oscila em suas entregas, normalmente finalizando-as de maneira incompleta, fora do prazo e padrão de qualidade.")]),_vm._v(" "),_c('li',[_vm._v("Apresenta dificuldades de adaptação.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-yellow-3"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Em desenvolvimento - 51 a 79.9")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Desempenho parcialmente satisfatório.")]),_vm._v(" "),_c('li',[_vm._v("Está em desenvolvimento na função atual e consolidação de suas competências.")]),_vm._v(" "),_c('li',[_vm._v("Oscila em suas entregas, mas normalmente sçao concluídas dew forma completa, no prazo e com a qualidade esperada.")]),_vm._v(" "),_c('li',[_vm._v("Apresenta alto potencial, mas precisa melhorar seu desempenho.")])])])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-bottom-title"},[_c('span',[_vm._v("POTENCIAL")])])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("Resultado do Colaborador")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matrix-left-title"},[_c('span',[_vm._v("DESEMPENHO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matrix-label"},[_c('span',[_vm._v("Acima do esperado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matrix-label"},[_c('span',[_vm._v("Dentro do esperado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matrix-label"},[_c('span',[_vm._v("Abaixo do esperado e "),_c('br'),_vm._v(" em desenvolvimento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matrix-bottom-title"},[_c('span',[_vm._v("POTENCIAL")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"card card-competencias"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("Orientações para o PDI")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"matrix"},[_c('div',{staticClass:"matrix-left-title"},[_c('span',[_vm._v("DESEMPENHO")])]),_vm._v(" "),_c('div',{staticClass:"matrix-content"},[_c('div',{staticClass:"matrix-row"},[_c('div',{staticClass:"matrix-label"},[_c('span',[_vm._v("Acima do esperado")])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-blue-1"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Acima do esperado - 101 a 107.3")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Reconhecer a evolução das entregas e estimular o desenvolvimento de novas competências que alavanquem o seu potencial para um próximo passo de carreira.")]),_vm._v(" "),_c('li',[_vm._v("Apoiar em demandas de melhoria dos processos/fluxos e projetos de sua função e área.")]),_vm._v(" "),_c('li',[_vm._v("Treinar e orientar novos colaboradores da área.")]),_vm._v(" "),_c('li',[_vm._v("Realizar acompanhamento periódico.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-blue-2"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Acima do esperado - 107.4 a 113.7")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Reforçar o avanço em seu potencial e estabelecer um PDI focado no próximo passo de carreira.")]),_vm._v(" "),_c('li',[_vm._v("Ser referência em sua função, para a equipe e demais colaboradores/gestores, e conduzir projetos e demandas de melhoria  para a área/diretoria.")]),_vm._v(" "),_c('li',[_vm._v("Treinar e orientar novos colaboradores da área.")]),_vm._v(" "),_c('li',[_vm._v("Realizar acompanhamento periódico.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-blue-3"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Acima do esperado - 113.8 a 120")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Validar que está pronto para o próximo passo de carreira e/ou para assumir a sucessão da área atual.")]),_vm._v(" "),_c('li',[_vm._v("Ser expert na função, dar suporte para sua gestão e participar de projetos gerais de melhoria.")]),_vm._v(" "),_c('li',[_vm._v("Ser incluído e apoiar em fóruns/comitês de estrategia e inovação em sua área/diretoria.")]),_vm._v(" "),_c('li',[_vm._v("Dar visibilidade ao colaborador, reconhecer e movimenta-lo")])])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-row"},[_c('div',{staticClass:"matrix-label"},[_c('span',[_vm._v("Dentro do esperado")])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-green-1"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Dentro do esperado - 80 a 86.5")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Reconhecer as competências e entregas dentro do esperado e sinalizar as que necessitam de aprimoramento para sua consolidação na função.")]),_vm._v(" "),_c('li',[_vm._v("Entender as dificuldades/necessidades do colaborador e elaborar um PDI focado em ações práticas e no acompanhamento de colegas mais experientes e referências na área.")]),_vm._v(" "),_c('li',[_vm._v("Realizar acompanhamento periódico.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-green-2"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Dentro do esperado - 86.6 a 94")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Reconhecer o desempenho satisfatório e a evolução do colaborador e estimulá-lo a novos aprendizados e desafios em sua função atual.")]),_vm._v(" "),_c('li',[_vm._v("Direcionar para atividades diferentes das que já realiza e aumentar suas responsabilidades na área.")]),_vm._v(" "),_c('li',[_vm._v("Elaborar PDI para incentivo e apoio a novas atribuições e realizar acompanhamento periódico.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-green-3"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Dentro do esperado - 94.1 a 100.9")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Reforçar o alto potencial do colaborador e mapear junto a ele ações teóricas e práticas, de continuidade para seu desenvolvimento de suas competências e entregas.")]),_vm._v(" "),_c('li',[_vm._v("Atribuir a ele atividades com maior escopo e complexidade e/ou identificar possibilidades de movimentação lateral para novas funções dentro do seu nível de atuação.")]),_vm._v(" "),_c('li',[_vm._v("Realizar acompanhamento periódico.")])])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-row"},[_c('div',{staticClass:"matrix-label"},[_c('span',[_vm._v("Abaixo do esperado e "),_c('br'),_vm._v(" em desenvolvimento")])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-red-1"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Abaixo de esperado - 0 a 25")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Realizar feedback formal, reforçando o desempenho insatisfatório e entendendo o grau de interesse e comprometimento do colaborador com as melhorias necessárias.")]),_vm._v(" "),_c('li',[_vm._v("Estabelecer em conjunto um PDI de curto prazo, focado nos pontos mais críticos de desenvolvimento e realizar acompanhamento periódico até a conclusão.")]),_vm._v(" "),_c('li',[_vm._v("Caso não haja melhoria, considerar desligamento.")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-red-2"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Abaixo de esperado - 25.1 a 50.9")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Realizar feedback formal sobre o baixo desempenho e competências críticas a desenvolver e entender os obstáculos e motivadores do colaborador.")]),_vm._v(" "),_c('li',[_vm._v("Identificar a compatibilidade com as atividades exercidas e definir um PDI de médio prazo para as principais questões de melhoria.")]),_vm._v(" "),_c('li',[_vm._v("Avaliar a viabilidade de uma mudança de atividade/escopo de atuação/função (job rotation).")])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-card matrix-card-yellow-3"},[_c('div',{staticClass:"matrix-card-title"},[_vm._v("Em desenvolvimento - 51 a 79.9")]),_vm._v(" "),_c('div',{staticClass:"matrix-card-content"},[_c('ul',[_c('li',[_vm._v("Orientar o colaborador com clareza sobre o seu papel, o que é esperado e quais as suas metas.")]),_vm._v(" "),_c('li',[_vm._v("Capacitar na função com o apoio dos materiais disponíveis (políticas da CIA, processos e fluxos da área) e de treinamentos on-the-job com colaboradores referência na área.")]),_vm._v(" "),_c('li',[_vm._v("Realizar acompanhamento e feedbacks periódicos.")])])])])])]),_vm._v(" "),_c('div',{staticClass:"matrix-bottom-title"},[_c('span',[_vm._v("POTENCIAL")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u3/v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "uViM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ug2s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",class:_vm.switchClass},[_c('div',{staticClass:"bootstrap-switch-container",on:{"click":function($event){return _vm.triggerToggle()}}},[_c('span',{staticClass:"bootstrap-switch-handle-on ",class:("bootstrap-switch-" + _vm.type)},[_vm._t("on",[_vm._v("\n          "+_vm._s(_vm.onText)+"\n      ")])],2),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-label"}),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-handle-off bootstrap-switch-default"},[_vm._t("off",[_vm._v("\n          "+_vm._s(_vm.offText)+"\n      ")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v98p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__ = __webpack_require__("jcvC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c067b332_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__ = __webpack_require__("nL1X");
function injectStyle (ssrContext) {
  __webpack_require__("uViM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c067b332"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c067b332_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vIxs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-minimize"},[_c('button',{staticClass:"btn btn-fill btn-icon",on:{"click":_vm.minimizeSidebar}},[_c('i',{class:_vm.$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'})])]),_vm._v(" "),_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar3"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand"},[_vm._v(_vm._s(this.$route.name))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9f633ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("m9jm");
function injectStyle (ssrContext) {
  __webpack_require__("HSdJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9f633ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9f633ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vSCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"type":"sidebar","sidebar-links":_vm.$sidebar.sidebarLinks}},[_c('user-menu'),_vm._v(" "),_c('mobile-menu')],1),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wH4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("1Kqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4dbeb28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("yuFm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4dbeb28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wJKS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wQ02":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wz5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-circle-chart",attrs:{"data-background-color":_vm.color}},[_c('div',{staticClass:"card-header text-center"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{ref:"chart",staticClass:"chart-circle",attrs:{"data-percent":_vm.percentage}},[_vm._v(_vm._s(_vm.percentage)+"%")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wzXt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Code_vue__ = __webpack_require__("SEJS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a54f52cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Code_vue__ = __webpack_require__("DQiw");
function injectStyle (ssrContext) {
  __webpack_require__("pp1H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Code_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a54f52cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Code_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x+NG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("xDe0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce6c1312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("S355");
function injectStyle (ssrContext) {
  __webpack_require__("mz9B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce6c1312_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x/a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'circle-chart-card',
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    percentage: {
      type: Number,
      default: 0
    },
    title: String,
    description: String
  },
  data: function data() {
    return {
      chartId: 'no-id',
      chart: null
    };
  },

  methods: {
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    renderChart: function renderChart(EasyPieChart) {
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 6,
        size: 160,
        scaleColor: false,
        trackColor: 'rgba(255,255,255,.25)',
        barColor: '#FFFFFF',
        animate: { duration: 2000, enabled: true }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var EasyPieChart;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "PeU/"));

            case 3:
              EasyPieChart = _context.sent;

              _this.renderChart(EasyPieChart);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    percentage: function percentage(newVal) {
      if (this.chart) {
        this.chart.update(newVal);
      }
    }
  }
});

/***/ }),

/***/ "xDe0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],

    PProgress: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Progress_vue__["a" /* default */]
  },
  data: function data() {
    return {
      statsCards: [{
        type: 'warning',
        icon: 'ti-briefcase',
        title: 'Negócios',
        value: '8',
        compText1: 'Persuasão'
      }],
      earningsChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'April', 'May', 'June'],
          series: [[230, 340, 400, 300, 570, 500, 800]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-green'
          }
        }
      }

    };
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    window.addEventListener('online', this.notificationInternetStatus);
    window.addEventListener('offline', this.notificationInternetStatus);
  },

  methods: {
    notificationInternetStatus: function notificationInternetStatus() {
      if (window.navigator.onLine) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          title: 'Internet!',
          text: 'Conectado.',
          type: 'success',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false,
          allowOutsideClick: false,
          preConfirm: function preConfirm() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              resolve('OK');
            });
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          title: 'Internet!',
          text: 'Desconectado. Verifique sua conexão com a internet.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false,
          allowOutsideClick: false
        });
      }
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  }
});

/***/ }),

/***/ "yMN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__("J7HA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afec1ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__("5Hee");
function injectStyle (ssrContext) {
  __webpack_require__("Vr89")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afec1ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yURV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yigp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'info-pdi-9box',
  props: {
    resultEvaluation: Object
  }
});

/***/ }),

/***/ "yuFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    }
  }
});

/***/ }),

/***/ "zwtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      this.$sidebar.displaySidebar(false);
      if (this.$route) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e7f0c667582319451d04.js